export default [
  {
    title_english: "Everyday Banana Bread",
    img: "everyday-banana-bread",
    slug: "everyday-banana-bread",
    title: "خبز الموز لكل يوم",
    description: "لذيذ ونديّ.",
    ingredients: "3 حبات موز تامة النضج، مهروسة|2 من بياض البيض |2 ملعقة كبيرة من زيت كانولا |1/3 - 1/2 كوب (67 - 100 جم) سكر |1/4 كوب (56 مل) لبن منزوع الدسم|1/2 ملعقة صغيرة ملح |1/2 ملعقة صغيرة بيكربونات صوديوم|1 ملعقة صغيرة مسحوق خبز |كوب ونصف (210 جم) دقيق.",
    method: "سخن الفرن أولًا إلى درجة حرارة 350 فهرنهايت (176 مئوية). |في وعاء خلط كبير، ادمج المكونات الخمسة الأولى وامزجها جيدًا. |امزج المكونات الجافة برفق وقلبها حتى تصبح طرية. |صبها في صينية خُبز مقاس 5 × 9 بوصات مطلية برذاذ زيت غير لاصق. |ضعها في الفرن لمدة 50 - 55 دقيقة، حتى يخرج السكين منها نظيفًا بعد غرسه بها. |احفظ المتبقي في الثلاجة.",
    difficulty: "سهلة",
    category: "dessert|snack",
    time: 65,
    serves: 10,
    fat: 3,
    saturated: 0,
    calories: 156,
    cholesterol: 0,
    carbohydrate: 29,
    protein: 3,
    sodium: 243,
    hasImage: true
  },
  {
    title_english: "Oven Fried Sole",
    title: "سمك موسى مقلي في الفرن",
    description: "",
    ingredients: "1 رطل (450 جم)من سمك موسى أو السمك المفلطح |كوب (125 جم) بقسماط جاف |1/4 كوب (55 جم) تتبيلة فرنسية أو تتبيلة ثاوزند آيلاند خالية من الدهون",
    method: "سخن الفرن أولًا إلى درجة حرارة 450 فهرنهايت (232 مئوية). |اغمس السمك في التتبيلة، ثم في البقسماط. |رش صينية بسكويت برذاذ زيت الطهي (Pam) ورص عليها السمك. |ضعها في الفرن لمدة 10 - 12 دقيقة، أو حتى يتفتت السمك بسهولة عند اختباره بشوكة. |اقلبه في منتصف المدة. |يُقدم مع ليمون أو المزيد من التتبيلة لغمسه فيها.",
    difficulty: "سهلة",
    category: "dinner|quick and easy",
    img: "oven-fried-sole",
    slug: "oven-fried-sole",
    serves: 4,
    time: 20,
    fat: 3.6,
    calories: 207,
    cholesterol: 52,
    carbohydrate: 24,
    saturated: 0.8,
    sodium: 670,
    fiber: 2,
    hasImage: true
  },
  {
    title_english: "Eggplant/Aubergine Parmesan",
    title: "الباذنجان بجبن البارميزان",
    description: "طعم أصلي بدون كتل شحم. الفرق الكبير هو أن الباذنجان يُغطى بالبقسماط ثم يُطهى في الفرن، بدلًا من أن يُقلى.",
    ingredients: "1 ثمرة باذنجان كبيرة، مقشرة ومقطعة شرائح|1 ثمرة كوسة، مقطعة مكعبات|1 ثمرة قرع صيفي، مقطعة مكعبات|8 أوقيات ( 225 جم) فطر، مقطع شرائح |26 أوقية (737 جم) برطمان صلصة الطماطم (يفضل استخدام أقل محتوى دهون) |4 أوقيات (113 جم) جبن موتزاريلا خالٍ من الدهون أو منخفض الدهون، مفتت* |4 ملاعق كبيرة من جبن بارميزان |2 من بياض البيض |كوب (50 جم) من البقسماط",
    method: "سخن الفرن أولًا إلى 375 فهرنهايت (190 مئوية). |اخلط بياض البيض في إناء، اغمس فيه شرائح الباذنجان، ثم اغمسها في وعاء آخر به البقسماط. |ضعها في صينية عميقة مقاس 9 × 13 بوصة تم تجهيزها برش رذاذ زيت طهي غير لاصق. |ضعها في الفرن لمدة 30 دقيقة. أخرجها من الفرن. |صب الصلصة فوق الباذنجان، ورش الخضراوات والجبن، وضعها مجددًا في الفرن لمدة 20 - 25 دقيقة حتى تفور.",
    difficulty: "متوسطة",
    category: "dinner|vegetarian",
    img: "eggplant-parmesan",
    slug: "eggplant-parmesan",
    time: 65,
    serves: 4,
    fat: 3,
    saturated: 2,
    calories: 279,
    cholesterol: 10,
    carbohydrate: 42,
    protein: 21,
    sodium: 479,
    hasImage: true
  },
  {
    title_english: "Berry Crunch Treat",
    title: "حلوى التوت المقرمشة",
    description: "رائعة للإفطار أو الغداء أو كوجبة خفيفة!",
    ingredients: "1/2 كوب (100 جم) من ثمار التوت الطازج أو المجمد|2 ملعقة كبيرة من فاكهة محفوظة (Simply Fruit Preserves) (بأي نكهة) |1/8 كوب (18 جم) جرانولا |1/2 كوب (125 جم) زبادي يوناني سادة خالٍ من الدهون",
    method: "اخلط جميع المكونات معًا واستمتع!",
    difficulty: "سهلة",
    category: "quick and easy|breakfast|snack",
    img: "berry-crunch-treat",
    slug: "berry-crunch-treat",
    time: 5,
    serves: 1,
    fat: 0.7,
    saturated: 0.18,
    calories: 205,
    cholesterol: 6,
    carbohydrate: 37,
    protein: 13,
    sodium: 63,
    fiber: 5,
    hasImage: true
  },
  {
    title_english: "Southern Black-Eyed Pea Patties",
    title: "فطائر اللوبياء من مطبخ الجنوب الأمريكي",
    description: "تنوع ممتع لبرجر الخضراوات التقليدي. يُقدم في خبز عربي مع طماطم، أو خيار، أو قشدة حامضة خالية من الدهون/ زبادي يوناني خالٍ من الدهون أو صلصة.",
    ingredients: "2/3 كوب (93 جم) شوفان|2 كوب ونصف (375 جم) لوبياء، مطهية|3 حبات بصل أخضر شرائح |2 من بياض البيض |1 ملعقة صغيرة كمون |1 ملعقة صغيرة ونصف مسحوق الفلفل الحار |1/8 ملعقة صغيرة فلفل الشطة |1/4 ملعقة صغيرة ملح |1 ملعقة كبيرة زيت",
    method: "اطحن الشوفان في آلة تحضير الطعام. |خذ 3 ملاعق كبيرة من مسحوق الشوفان واحفظ الباقي للاستخدام لاحقًا. |أضف جميع المكونات الأخرى ما عدا الزيت إلى آلة تحضير الطعام واخلطها حتى تصبح معجونًا سميكًا (أضف القليل من الماء عند الضرورة). |أخرجها واصنع منها 6 أقراص. اغمسها في الشوفان المحفوظ وسوّها في الزيت في مقلاة. ضعها على النار حتى النضج وتحولها إلى اللون البني على كلا الجانبين.",
    difficulty: "سهلة",
    category: "vegetarian|lunch|dinner",
    img: "black-eyed-pea-patties",
    slug: "black-eyed-pea-patties",
    serves: 6,
    fat: 4,
    saturated: 1,
    calories: 166,
    cholesterol: 0,
    carbohydrate: 27,
    protein: 7,
    sodium: 146,
    fiber: 6,
    hasImage: true,
  },
  {
    title_english: "Chicken Breasts with Savory Peach Glaze",
    title: "صدور الدجاج المغطاة بطبقة شهية من الخوخ",
    description: "هذه الوصفة الشهية السهلة هي طريقة أخرى تضفي الحيوية على وصفة صدور الدجاج المعتادة! يمكن أيضًا إضافة طبقة لامعة لذيذة إلى فيليه اللحم.",
    ingredients: "1 كوب (350 جم) من خوخ محفوظ |1 ملعقة كبيرة من صلصة الصويا |1 ملعقة كبيرة خردل ديجون |1 فص ثوم صغير، مفروم |4 حبات بصل أخضر، مقطعة مكعبات |1/3 حبة فلفل أحمر حلو، مقطعة قطع صغيرة |1/8 ملعقة صغيرة رقائق فلفل أحمر (اختياري) |6 أنصاف صدور دجاج مخلية بدون جلد.",
    method: "سخن الفرن أولًا إلى درجة حرارة 350 فهرنهايت (176 مئوية). |اخلط جميع المكونات، ما عدا الدجاج، في وعاء خلط متوسطة الحجم. |ضع قطع الدجاج في صينية وغطها بالخليط. |ضع في الفرن لمدة 30 دقيقة، أو حتى تصل قطع الدجاج إلى درجة حرارة داخلية 165 فهرنهايت (73 مئوية)",
    difficulty: "سهلة",
    category: "dinner|quick and easy",
    img: "chicken-breasts-with-savory-peach-glaze",
    slug: "chicken-breasts-with-savory-peach-glaze",
    time: 40,
    serves: 6,
    fat: 4.5,
    saturated: 1,
    calories: 299,
    cholesterol: 124,
    carbohydrate: 21,
    protein: 39,
    sodium: 304,
    hasImage: true,
  },
  {
    title_english: "Chicken Caesar Salad",
    title: "سلطة سيزار بالدجاج",
    description: "وجبة صحية من طبق مفضل غني بالدهون. أضف طماطم شيري زاهية الحمرة لتنوع لذيذ.",
    ingredients: "8 أكواب (600 جم) خس روماني مغسول ومقطع مسبقًا |رطل (16 أوقية) صدور دجاج مخلية بدون جلد مطهية مسبقًا ومقطعة إلى شرائح |1 كوب (115 جم) كسرات خبز محمصة خالٍ من الدهون |أوقية (28 جم) جبن بارميزان خالٍ من الدهون مفتت |1/2 كوب (175 جم) تتبيلة سلطة سيزار كريمية خالية من الدهون |1/2 ملعقة صغيرة فلفل أسود مطحون طازج |1 ثمرة ليمون طازجة",
    method: "ضع الخس وكسرات الخبز المحمصة في إناء كبير وأضف التتبيلة واخلطهما خلطًا جيدًا. |اعصر الليمون على خليط الخس وأضف الجبن؛ واخلطه مجددًا. |قسم الخليط في 4 أطباق للتقديم. |ضع قطع الدجاج المطهية المقطعة إلى شرائح رفيعة أو قطع صغيرة واقسمها بالتساوي فوق كل طبق تقديم.",
    difficulty: "سهلة",
    category: "lunch|quick and easy|dinner",
    hasImage: true,
    img: "chicken-caesar-salad",
    slug: "chicken-caesar-salad",
    time: 10,
    serves: 4,
    fat: 4,
    saturated: 2,
    calories: 214,
    cholesterol: 92,
    carbohydrate: 22,
    protein: 19,
    sodium: 484
  },
  {
    title_english: "Chicken Picante",
    title: "دجاج بياكنتي",
    description: "تعتبر تتبيلة النقع السهلة هذه تغييرًا مثيرًا لوصفات الدجاج المكررة.",
    ingredients: "4 صدور دجاج مخلية بدون جلد |3/4 كوب (263 جم) صلصة |2 ملعقة كبيرة خردل ديجون (زد منه إذا كنت تحب النكهة الحارة!) |عصير 2 حبة ليمون طازجتين",
    method: "سخن الفرن أولًا إلى درجة حرارة 350 فهرنهايت (176 مئوية). |ضع الدجاج في صينية عميقة تم تجهيزها برش زيت طهي غير لاصق، أو في صينية مبطنة بورق ألومنيوم غير لاصق. |في وعاء صغير، اخلط الصلصة والخردل وعصير الليمون وصبه فوق الدجاج. |ضع قطع الدجاج في الثلاجة لمدة ساعة واحدة أو أكثر. |غطها وضع في الفرن لمدة 35 - 40 دقيقة. |قدمها مع أرز بني (هناك الكثير من الصلصة لإضافة نكهة إلى الأرز).",
    difficulty: "سهلة",
    category: "lunch|dinner|family favorites",
    hasImage: true,
    img: "chicken-picante",
    slug: "chicken-picante",
    time: 110,
    serves: 4,
    fat: 4,
    saturated: 1,
    calories: 172,
    cholesterol: 85,
    carbohydrate: 3,
    protein: 31,
    sodium: 420
  },
  {
    title_english: "Chocolate Chip Cookie Bars",
    title: "أصابع البسكويت برقائق الشكولاتة",
    description: "يُخبز هذا البسكويت مثل كعك البراوني السميك الفاتح الذي يمكن أن تستمتع به العائلة كلها كتحلية بعد المدرسة.",
    ingredients: "1/4 كوب (56 جم) زبد غير مملح |1/2 كوب (147 جم) صلصة تفاح غير مملحة، في درجة حرارة الغرفة |2 كوب ممتلئ من (340 جم) السكر البني |2 كوب (385 جم) دقيق لجميع الأغراض |1 ملعقة كبيرة من مسحوق الخبز |1/2 ملعقة صغيرة ملح |3 بيضات |1 ملعقة صغيرة مستخلص فانيليا |1/4 كوب (38 جم) + 2 ملعقة كبيرة من رقائق شكولاتة صغيرة نصف محلاة |رذاذ زيت طهي غير لاصق ودقيق إضافي لتجهيز الصينية",
    method: "أذب الزبد، ثم أضف صلصة التفاح وضعهما جانبًا ليبردا. |جهز صينية مقاس 9 × 13 بوصة برشها بزيت طهي غير لاصق وبدقيق. |في وعاء منفصل، اخلط الدقيق، ومسحوق الخبز والملح. |بمجرد أن يبرد خليط الزبد، أضف البيض، واحدة تلو الأخرى، واخلط بعد إضافة كل واحدة. |أضف الفانيليا. |أضف المكونات الجافة وامزج جيدًا، مع دمج خليط الدقيق كله. |قلب معه رقائق الشكولاتة الصغيرة. |ضع الوعاء في الفرن لمدة 30 - 40 دقيقة في درجة حرارة 325 فهرنهايت (162 مئوية). |بمجرد أن يبرد، قطع الناتج إلى 24 لوحًا.",
    difficulty: "سهلة",
    category: "dessert|family favorites|light snacks",
    hasImage: true,
    img: "chocolate-chip-cookie-bars",
    slug: "chocolate-chip-cookie-bars",
    time: 60,
    serves: 24,
    fat: 3.5,
    saturated: 1.9,
    calories: 164,
    cholesterol: 28,
    carbohydrate: 32,
    protein: 2,
    sodium: 124
  },
  {
    title_english: "Chopped Vegetable Frittata",
    title: "فريتاتا بالخضراوات المقطعة",
    description: "وجبة مثالية من أجل إفطار بدون مجهود أو متأخر، أو لوجبة بين الإفطار والغداء، أو حتى العشاء.",
    ingredients: "8 أوقيات (226 جم) علبة بديل بيض / 8 من بياض البيض، مخفوق قليلًا |2 حبة بصل أخضر، مفروم |1 حبة طماطم، مقطعة مكعبات |1/2 حبة فلفل أحمر، مقطعة مكعبات |1 حبة فلفل أخضر، مقطعة مكعبات |كوب/كوب (175 - 350 جم) فطر، مقطع شرائح |1 كوب (175 جم) بطاطس حمراء، مطهية ومقطعة شرائح |1/2 حبة خيار، مقشرة ومقطعة شرائح |4 أوقيات (113 جم) علبة فلفل أخضر حار |1/2 ملعقة صغيرة مسحوق ثوم |1/4 ملعقة صغيرة فلفل أبيض |ملح وفقًا لذوقك، حسب الرغبة",
    method: "جهز مقلاة تسوية عن طريق رشها بزيت طهي غير لاصق. |قم بتسوية جميع الخضراوات حتى تصبح نصف ناضجة. |صب بديل البيض/ بياض البيض على الخضراوات وضعها مغطاة على النار على حرارة منخفضة إلى متوسطة حتى يصبح البيض ناضجًا بالكامل ومنفوشًا.",
    difficulty: "سهلة",
    category: "breakfast|light snacks|quick and easy",
    hasImage: true,
    img: "chopped-vegetable-frittata",
    slug: "chopped-vegetable-frittata",
    time: 20,
    serves: 2,
    fat: 4,
    saturated: 0,
    calories: 224,
    cholesterol: 0,
    carbohydrate: 30,
    protein: 18,
    sodium: 408
  },
  {
    title_english: "Corn and Black Bean Salad",
    title: "سلطة الذرة والفاصولياء السوداء",
    description: "هذه السلطة سهلة التحضير بمكونات موجودة بالفعل في مطبخك.",
    ingredients: "16 أوقية (453 جم) علبة فاصولياء سوداء منخفضة الصوديوم، مغسولة ومصفاة |كوب (175 جم) طماطم إيطالي طازجة مقطعة مكعبات |1/2 كوب (75 جم) ذرة مجمدة، تُذاب |1/2 كوب (75 جم) فلفل أخضر مقطع مكعبات |2 ملعقة كبيرة بصل أحمر مفروم |1/4 كوب (88 جم) صلصة (حارة بقدر ما تحب) |عصير ثمرة ليمون خضراء",
    method: "اخلط جميع المكونات. تُبرد وتُقدم كطبق رئيسي أو سلطة إضافية.",
    difficulty: "سهلة",
    category: "lunch|family favorites|quick and easy|vegetarian|fat free",
    hasImage: true,
    img: "corn-and-black-bean-salad",
    slug: "corn-and-black-bean-salad",
    time: 10,
    serves: 2,
    fat: 0,
    saturated: 0,
    calories: 270,
    cholesterol: 0,
    carbohydrate: 52,
    protein: 16,
    sodium: 382
  },
  {
    title_english: "Corn Bread Casserole with Topping",
    title: "صينية خبز الذرة مع الإضافات",
    description: "هذا الطبق مميز ويكثر تداوله خلال موسم الشواء.",
    ingredients: "خليط خبز ذرة منخفض الدهون (عبوة 16 أوقية (453 جم)) | 2.15 أوقية (425 جم) حبة ذرة حلوة كريمية |1 كوب بديل البيض |2 حبة بصل كبية، واحدة مقطعة مكعبات كبيرة، وواحدة مقطعة شرائح رفيعة |1 كوب (240 جم) قشدة حامضة خالية من الدهون/ زبادي يوناني خالٍ من الدهون |1/4 كوب (29 جم) جبن شيدر مفتت منخفض الدهون |1 ملعقة صغيرة شبت مجفف (اختياري)",
    method: "سخن الفرن أولًا إلى درجة حرارة 400 فهرنهايت (204 مئوية). رش صينية عميقة مقاس 13 بوصة بزيت طهي غير لاصق. |في إناء متوسط، اخلط بديل البيض والذرة الكريمية معًا، ثم أضف محتويات خليط خبز الذرة. اخلط حتى تذوب أي كتل. |صب العجين السائل في الصينية العميقة. |في مقلاة تسوية مجهزة برش زيت طهي غير لاصق، قم بتسوية البصل لمدة 5 - 8 دقائق حتى يصبح نصف شفاف. برده قليلًا وأضف القشدة الحامضة/ الزبادي اليوناني. افرد القشدة فوق خليط خبز الذرة، ورشّه بالجبن والشبت، حسب الرغبة. |اخبزه في الفرن لمدة 30 - 35 دقيقة، أو حتى تغرز سكينًا ويخرج نظيفًا. يُقطع إلى 18 قطعة ويُقدم.",
    difficulty: "متوسطة",
    category: "lunch|family favorites|dinner|vegetarian",
    hasImage: true,
    img: "corn-bread-casserole-with-topping",
    slug: "corn-bread-casserole-with-topping",
    time: 45,
    serves: 18,
    fat: 2.3,
    saturated: 0.2,
    calories: 166,
    cholesterol: 12,
    carbohydrate: 31,
    protein: 5.5,
    sodium: 397
  },
  {
    title_english: "Cream of Potato Soup",
    title: "حساء كريمة البطاطس",
    description: "",
    ingredients: "1 كوب (175 جم) بطاطس مقطعة شرائح|1 كوب ونصف (338 مل) مرق دجاج منخفض الصوديوم وخالٍ من الدهون|1/2 كوب (88 جم) بصل مقطع مكعبات |1 ملعقة صغيرة زيت زيتون |2 ملعقة كبيرة دقيق أبيض لجميع الأغراض |1/4 ملعقة صغيرة ملح |رشة فلفل أبيض (اختياري) |1 كوب (225 مل) لبن خالي الدسم",
    method: "في قدر صلصة، ادمج البطاطس، ومرق الدجاج، والبصل، والشبت معًا. اجعل الخليط يغلي. اخفض درجة الحرارة، ثم غطه واتركه على نار هادئة لمدة 10 دقائق. |ضع نصف خليط الخضراوات في الخلاط أو آلة تحضير الطعام. اخلطه لمدة 30 إلى 60 ثانية حتى يصبح متجانسًا. |صبه في وعاء. من أجل قوام متجانس للغاية، ضع خليط الخضراوات المتبقي في الخلاط. من أجل قوام متكتل أكثر، اترك النصف الثاني بدون وضعه في الخلاط. ضع كل شيء في جانب. |في نفس قدر الصلصة على حرارة متوسطة، أضف زيت الزيتون ودفئه. |قلب به الدقيق والملح والفلفل (حسب الرغبة) واخفقها كلها. |ضعه على النار لمدة دقيقة. أضف اللبن. ضعه على النار وقلب الخليط بالمخفقة حتى يثخن وتظهر الفقاقيع. |أضف خليط الخضراوات والمرق وقلبه. ضعه على النار وقلب الحساء حتى يسخن بالكامل. |تبله حسب الذوق بملح وفلفل إضافيين.",
    difficulty: "متوسطة",
    category: "family favorites|lunch|dinner|vegetarian",
    hasImage: true,
    img: "cream-of-potato-soup",
    slug: "cream-of-potato-soup",
    time: 30,
    serves: 3,
    fat: 2.4,
    saturated: 1,
    calories: 135,
    cholesterol: 2,
    carbohydrate: 20,
    protein: 7,
    sodium: 268,
    fiber: 2
  },
  {
    title_english: "Crock Pot Beef Roast & Veggies",
    title: "اللحم المشوي والخضراوات في قدر الطهي البطيء",
    description: "طبق سريع وسهل ولذيذ، وهو مثالي لأي وقت في العام.",
    ingredients: "1 رطل (450 جم) لحم بقري منخفض الدهون من الردف فقط |1 كوب (150 جم) فاصولياء خضراء |2 كوب ونصف (125 جم) جزر، مقطع مكعبات |1/2 كوب (113 مل) مرق لحم |1 كوب (299 جم) أرز أبيض |3 ملاعق كبيرة خل بلسمي |2 ملعقة كبيرة بهارات مسكيت جافة",
    method: "اخلط جميع المكونات ما عدا الأرز في قدر الطهي البطيء. |قم بطهيها على حرارة منخفضة لمدة 8 - 10 ساعات حتى يمكن تفتيت اللحم بسهولة باستخدام شوكة. |قم بطهي الأرز عند اقتراب انتهاء نضج القدر، حسب توجيهات الوصفة. |قدّم مكونات قدر الطهي البطيء على الأرز.",
    difficulty: "سهلة",
    category: "family favorites|dinner|hearty meal",
    hasImage: true,
    img: "crock-pot-beef-roast-and-veggies",
    slug: "crock-pot-beef-roast-and-veggies",
    serves: 4,
    fat: 8,
    saturated: 5,
    calories: 435,
    cholesterol: 103,
    carbohydrate: 52,
    protein: 39,
    sodium: 660
  },
  {
    title_english: "Crock Pot Caribbean Chicken",
    title: "الدجاج الكاريبي في قدر الطهي البطيء",
    description: "طبق استوائي سهل ذو مذاق حلو وشهي.",
    ingredients: "1 رطل ( 450 جم) صدور دجاج مخلية بدون جلد |1/4 كوب مضغوط (43 جم) سكر بني |1/2 ملعقة صغيرة جوزة الطيب |1/3 كوب (75 مل) عصير برتقال |1/2 كوب (88 جم) زبيب |8 أوقيات (226 جم) قطع أناناس معلب مع العصير |1/2 ملعقة صغير قرفة",
    method: "ضع جميع المكونات في قدر الطهي البطيء. |قم بطهيها لمدة 4 - 6 ساعات. |قدمها على أرز مطهو بالبخار، حسب الرغبة.",
    difficulty: "سهلة",
    category: "family favorites|dinner|hearty meal",
    hasImage: true,
    img: "crock-pot-caribbean-chicken",
    slug: "crock-pot-caribbean-chicken",
    serves: 4,
    fat: 4,
    saturated: 0,
    calories: 399,
    cholesterol: 80,
    carbohydrate: 68,
    protein: 26,
    sodium: 65
  },
  {
    title_english: "Crock Pot Mexican Chicken Soup",
    title: "حساء الدجاج المكسيكي في قدر الطهي البطيء",
    description: "طبق غني بالنكهات والتوابل.",
    ingredients: "2 ملعقة كبيرة من عصير الليمون الأخضر |3 أكواب ونصف (175 جم) جزر، مقطع مكعبات |1 ملعقة صغيرة مسحوق فلفل حار |1 ملعقة كبيرة ثوم مفروم |4 أكواب (900 مل) مرق دجاج خالٍ من الدهون ومنخفض الصوديوم |1 كوب (225 مل) عصير طماطم |1 ملعقة صغيرة بذور شمر |1 ملعقة صغيرة كمون مطحون |1 رطل (16 أوقية) صدور دجاج مخلي بدون الجلد |1 حبة بصل صفراء كبيرة، مقطعة مكعبات",
    method: "اخلط جميع المكونات في قدر الطهي البطيء وضعها على النار لمدة 6 - 8 ساعات على حرارة منخفضة، أو حتى ينضج الدجاج. |فتت الدجاج وقدمه.",
    difficulty: "سهلة",
    category: "family favorites|dinner|hearty meal",
    hasImage: true,
    img: "crock-pot-mexican-chicken-soup",
    slug: "crock-pot-mexican-chicken-soup",
    serves: 4,
    fat: 4,
    saturated: 0,
    calories: 229,
    cholesterol: 66,
    carbohydrate: 17,
    protein: 29,
    sodium: 369
  },
  {
    title_english: "Crock Pot Honey Garlic Chicken and Veggies",
    title: "الدجاج والخضراوات مع العسل والثوم في قدر الطهي البطيء",
    description: "تغيير جديد في وصفة دجاج قدر الطهي البطيء التقليدية.",
    ingredients: "2 رطل من ( 900 جم) صدور دجاج |16 أوقية (453 جم) بطاطس حمراء صغيرة |16 أوقية (453 جم) جزر صغير |2 ملعقة كبيرتان بقدونس مقطع |1/2 كوب (175 جم) صلصة صويا منخفضة الصوديوم |1 كوب (350 جم) عسل |1/4 كوب (88 جم) كاتشاب |2 فص ثوم مفروم |1 ملعقة صغيرة ريحان مجفف |1/2 ملعقة صغيرة أوريجانو مجفف |1/4 ملعقة صغيرة رقائق فلفل أحمر مسحوقة |1/4 ملعقة صغيرة فلفل أسود مطحون |1/2 كوب (113 مل) ماء",
    method: "في إناء كبير، اخلط صلصة الصويا والعسل والكاتشاب والثوم والريحان والأوريجانو ورقائق الفلفل الأحمر والفلفل. |ضع الدجاج والبطاطس والجزر في قدر الطهي البطيء. |صب خليط الصلصة فوق الدجاج والبطاطس والجزر. |أضف الماء إلى قدر الطهي البطيء. |غطه وضعه على نار بحرارة منخفضة لمدة 7 ساعات ونصف أو على حرارة مرتفعة لمدة 3 ساعات ونصف.",
    difficulty: "سهلة",
    category: "family favorites|dinner|hearty meal",
    hasImage: true,
    img: "crock-pot-honey-garlic-chicken",
    slug: "crock-pot-honey-garlic-chicken",
    serves: 4,
    fat: 6.6,
    saturated: 1.4,
    calories: 721,
    cholesterol: 166,
    carbohydrate: 110,
    protein: 59,
    sodium: 1194,
    fiber: 6,
  },
  {
    title_english: "Banana Pudding",
    title: "بودينج الموز",
    description: "طبق حلوى سهل التحضير لعائلتك أو رائع للتقديم في التجمعات",
    ingredients: "2 حبة موز ناضج كبير، مقطعة شرائح |2 عبوة بودينج فانيليا فوري خالٍ من السكر، وخالٍ من الدهون (علبة قدرها أوقية (28 جم)) |3 أكواب (710 مل) لبن خالي الدهون |4 أوقيات (113 جم) كريمة علوية مخفوقة خالية من الدهون |1/2 كوب (113 جم) قشدة حامضة خالية من الدهون/ زبادي يوناني خالٍ من الدهون |1/4 كوب (50 جم) محليّ خالٍ من السعرات الحرارية |30 بسكويت ويفر بالفانيليا منخفض الدهون",
    method: "أفرغ كلًا من عبوتي مسحوق البودينج في وعاء خلط واخلطهما مع 3 أكواب (710 مل) من اللبن البارد. اترك الخليط ليبرد وضعه في الثلاجة حتى يثخن. |في وعاء منفصل، اخلط الزينة المخفوقة، والقشدة الحامضة الخالية من الدهون/ الزبادي اليوناني الخالي من الدهون، والمحلي. |خذ صينية عميقة أو إناء واسعًا شفافًا وضع المكونات في طبقات: ابدأ ببسكويت الويفر، ثم شرائح الموز ثم البودينج، وكرر الخطوات. ثم زينه بخليط الكريمة المخفوقة.",
    difficulty: "سهلة",
    category: "light snacks|dessert|family favorites|quick and easy",
    hasImage: true,
    img: "banana-pudding",
    slug: "banana-pudding",
    serves: 10,
    fat: 1.5,
    saturated: 0,
    calories: 128,
    cholesterol: 3,
    carbohydrate: 26,
    protein: 4,
    sodium: 168,
    fiber: 1
  },
  {
    title_english: "Easy Candied Sweet Potatoes",
    title: "بطاطا حلوة محلاة سهلة التحضير",
    description: "إليك طبقًا موسميًا سهلًا يمكن الاستمتاع به في أي وقت من العام!",
    ingredients: "رطل ونصف (657 جم) بطاطا حلوة أو يام مقشرة ومقطعة شرائح رفيعة |2 - 3 ملاعق كبيرة برتقال أو مشمش أو تفاح محفوظ |1/2- 3/4 كوب (113 مل - 169 مل) عصير برتقال |قطع مارشمللو صغيرة (اختياري/ غير مدرجة في التحليل)",
    method: "سخن الفرن أولًا إلى درجة حرارة 350 فهرنهايت (176 مئوية). |في وعاء صغير، ادمج الفاكهة المحفوظة وعصير البرتقال. |ضع شرائح البطاطا الحلوة في صينية عميقة. |صب خليط العصير فوق البطاطا وغطها بورق ألومنيوم أو غطاء. |ضع في الفرن لمدة 45 دقيقة، مع تقليبها في منتصف المدة. |زينها بقطع المارشمللو الصغيرة أثناء آخر 10 دقائق في الخبز، حسب الرغبة. |يمكنك أيضًا أن تضعها في الميكروويف في طبق يمكن إدخاله في الميكروويف لمدة 20 - 25 دقيقة، مع التقليب من وقت لآخر، حتى تصبح البطاطا طرية.",
    difficulty: "سهلة",
    category: "family favorites|dinner",
    hasImage: true,
    img: "easy-candied-sweet-potatoes",
    slug: "easy-candied-sweet-potatoes",
    time: 55,
    serves: 4,
    fat: 0.2,
    saturated: 0,
    calories: 184,
    cholesterol: 0,
    carbohydrate: 44,
    protein: 3,
    sodium: 98,
    fiber: 5
  },
  {
    title_english: "Easy Crockpot Refried Beans",
    title: "فاصولياء مقلية سهلة التحضير في قدر الطهي البطيء",
    description: "هذه الوصفة سهلة لدرجة أنك تستطيع تحضيرها وأنت مغمض العينين!",
    ingredients: "1 حبة بصل مقشرة ومقطعة لنصفين |2 كوب (300 جم) فاصولياء منقطة جافة مشطوفة |2 فص ثوم مفروم |3/4 ملعقة صغيرة ملح |1/2 ملعقة صغيرة فلفل أسود |1/8 ملعقة صغيرة كمون |6 أكواب (1350 مل) ماء",
    method: "اخلط جميع المكونات في قدر الطهي البطيء. |ضع المكونات على نار ذات حرارة عالية لمدة 8 ساعات أو اتركها طوال الليل أثناء نومك. |أخرج قطع البصل الكبيرة وصف السائل الإضافي. احفظ بعضًا من السائل الإضافي لتضيفه لاحقًا إلى المنتج النهائي من أجل الوصول إلى القوام المثالي للفاصولياء (أنت لا تريدها أن تكون جافة أكثر من اللازم). |اهرس الفاصولياء المتبقية بهراسة بطاطس وعندها تكون قد انتهيت!",
    difficulty: "سهلة",
    category: "family favorites|dinner|hearty meal",
    hasImage: true,
    img: "easy-crock-pot-refried-beans",
    slug: "easy-crock-pot-refried-beans",
    serves: 10,
    fat: 0.5,
    saturated: 0,
    calories: 134,
    cholesterol: 0,
    carbohydrate: 25,
    protein: 8,
    sodium: 184
  },
  {
    title_english: "Easy Eggless Cocoa Cake",
    title: "كعكة كاكاو سهلة بدون بيض",
    description: "",
    ingredients: "1 كوب ونصف (210 جم) دقيق |1 كوب (200 جم) سكر |1/4 كوب (31 جم) كاكاو |1 ملعقة صغيرة مسحوق خبز |1/4 ملعقة صغيرة ملح |كوب (225 مل) ماء |2 ملعقة كبيرة من الزيت |2 ملعقة كبيرة من زبادي سادة خالٍ من الدهون |1 ملعقة كبيرة خل |1 ملعقة صغيرة مستخلص فانيليا",
    method: "سخن الفرن أولًا إلى درجة حرارة 350 فهرنهايت (176 مئوية). |اخلط المكونات الجافة. أضف المكونات السائلة وقلبها حتى تصبح متجانسة. |صبها في صينية خبز مقاس 8 × 8 بوصة تم تجهيزها عن طريق رش زيت طهي غير لاصق. |ضعها في الفرن لمدة 30 - 35 دقيقة أو حتى تغرز سكين ويخرج نظيفًا. برّد المكونات. |رش فوقها السكر الناعم ورقائق الشكولاتة.",
    difficulty: "سهلة",
    category: "family favorites|dessert",
    hasImage: true,
    img: "easy-eggless-cocoa-cake",
    slug: "easy-eggless-cocoa-cake",
  },
  {
    title_english: "Easy Fat-Free Cheesecake",
    title: "كعكة الجبن السهلة الخالية من الدهون",
    description: "غنية بالكريمة ومذاقها يماثل الكعكة الأصلية. يمكنك تقليل السكر والنشويات باستبدالها بمحلّي خالي من السعرات الحرارية.",
    ingredients: "16 أوقية (453 جم) من جبن كريمي خالٍ من الدهون، بدرجة حرارة الغرفة |1/2 كوب (113 جم) سكر عادي أبيض (أو 1/2 كوب (113 جم) محلي) |3/4 كوب (190 جم) زبادي يوناني سادة خالٍ من الدهون، بدرجة حرارة الغرفة |1 ملعقة صغيرة فانيليا |4 بياض بيض أو كوب بياض بيض سائل |2 ملعقة كبيرة عصير ليمون |2 ملعقة كبيرة دقيق لجميع الأغراض |كريمة فوقية اختيارية - حشو فطيرة كرز خفيف أو توت طازج",
    method: "سخن الفرن أولًا إلى درجة حرارة 350 فهرنهايت (176 مئوية). |رش قالب كعك اسفنجي طول 9 بوصات بزيت طهي غير لاصق. |في وعاء كبير، اخلط الجبن الكريمي، والسكر (أو المحلي الخالي من السعرات الحرارية)، والفانيليا واضرب المكونات بخلاط كهربائي حتى تصبح متجانسة. |أضف الزبادي وبياض البيض وعصير الليمون والدقيق واستمر في الخلط. |صب بالتساوي في قالب الكعك المجهز مسبقًا. |ضع الخليط في الفرن حتى يصبح متماسكًا واسفنجي القوام عند لمسه، 30 -40 دقيقة. |اتركه يبرد بالكامل. |إن أردت، أضف الكريمة الفوقية الإضافية.",
    difficulty: "سهلة",
    category: "family favorites|dessert",
    hasImage: true,
    img: "easy-fat-free-cheesecake",
    slug: "easy-fat-free-cheesecake",
    time: 45,
    serves: 9,
    fat: 3.6,
    saturated: 0.6,
    calories: 199,
    cholesterol: 0,
    carbohydrate: 40,
    protein: 3,
    sodium: 122,
  },
  {
    title_english: "Easy Ice Cream",
    title: "أيس كريم سهل",
    description: "تحلية سريعة ومنخفضة الدهون. لنكهات مختلفة، استخدام فواكه مجمدة أخرى.",
    ingredients: "1 عبوة من الفراولة المجمدة (10 أوقيات) (283 جم) |1/2 كوب (113 جم) سكر |2/3 كوب (150 مل) خليط متساوٍ من اللبن والقشدة خالٍ من الدهون",
    method: "ضع الفاكهة والسكر في آلة تحضير الطعام أو الخلاط واخلطهما حتى تصبح الفاكهة مقطعة قطعًا كبيرة. |أثناء تشغيل آلة تحضير الطعام، صب خليط اللبن والقشدة ببطء واستمر في الخلط حتى يندمج بالكامل. |إذا كنت تحب قوام الأيس كريم اللين، فقدمه على الفور. إذا كنت تحب أن يكون الأيس كريم متماسكًا، فجمده حتى يصبح متماسكًا.",
    difficulty: "سهلة",
    category: "family favorites|dessert|light snacks|fat free",
    hasImage: true,
    img: "easy-ice-cream",
    slug: "easy-ice-cream",
    serves: 4,
    fat: 0,
    saturated: 0,
    calories: 147,
    cholesterol: 0,
    carbohydrate: 36,
    protein: 2,
    sodium: 40,
    fiber: 2
  },
  {
    title_english: "Eggplant/Aubergine Caviar",
    title: "كافيار الباذنجان",
    description: "طبق الباذنجان هذا هو طبق تقليدي في دول الشرق الأوسط، وحشوة رائعة للخبز العربي المصنوع من دقيق القمح الكامل، أو للاستخدام كإضافة فوق الخبز المحمص أو القراقيش.",
    ingredients: "حبة أو اثنين باذنجان (حوالي 3 أكواب (675 جم) قلب مهروس) |1/4 كوب (44 جم) بصل، مفروم جيدًا |1/4 كوب (44 جم) بصل أخضر، مفروم جيدًا |1/4 كوب (44 جم) فلفل أخضر، مفروم جيدًا |2/3 فصوص ثوم مفروم جيدًا (أو 1/2 ملعقة صغيرة مسحوق ثوم) |1 كوب (175 جم) طماطم مقشرة ومقطعة قطع صغيرة جدًا (يمكن استخدام الطماطم المعلبة المقطعة) |1 ملعقة صغيرة سكر |1 عصير حبة ليمون |فلفل أسود، حسب الذوق",
    method: "ضع الباذنجان المثقوب في الميكروويف على الإعداد العالي لمدة 10 دقائق. اتركه يبرد قليلًا. |في وعاء كبير، امزج المكونات المتبقية. |اشطر الباذنجان نصفين وأخرج القلب وضعه في الوعاء. قلّب جيدًا لمزجه. |ضعه في الثلاجة لساعتين أو أكثر قبل التقديم.",
    difficulty: "متوسطة",
    category: "lunch|snack|vegetarian",
    hasImage: true,
    img: "eggplant-caviar",
    slug: "eggplant-caviar",
    serves: 5,
    fat: 0.4,
    saturated: 0,
    calories: 76,
    cholesterol: 0,
    carbohydrate: 16,
    protein: 3,
    sodium: 13
  },
  {
    title_english: "Bean and Macaroni Soup",
    title: "حساء الفاصولياء والمعكرونة",
    description: "هذا الحساء الصحي الثخين وجبة غداء مشبعة. ضاعف الحصة لشهية أكبر.",
    ingredients: "14 أوقية (397 جم) علبة فاصولياء بيضاء مشطوفة ومصفاة |14 أوقية (397 جم) علبة طماطم مقطعة |رذاذ زيت طهي غير لاصق |1 حبة بصل، مقطعة مكعبات |4 حبات جزر، مقطع شرائح رفيعة |1/2 ملعقة صغيرة مسحوق ثوم |1/2 ملعقة صغيرة توابل إيطالية |2/3 كوب (77 جم) معكرونة غير مطبوخة |3 أكواب أو أكثر (710 مل) ماء",
    method: "رش قدر سعة جالون بزيت الطهي غير اللاصق. |أضف البصل والجزر وقم بتسويته لمدة 5 دقائق. |أضف الطماطم، والتوابل، والماء؛ واجعلها تغلِ. |أضف المعكرونة والفاصولياء واجعلها تغلي لمدة 10 دقائق حتى تنضج المعكرونة. قلب من وقت لآخر. |اغرف الحساء بمغرفة في وعاء كبير وتمتع بالمذاق!",
    difficulty: "سهلة",
    category: "quick and easy|vegetarian|lunch|hearty meal",
    hasImage: true,
    img: "bean-and-macaroni-soup",
    slug: "bean-and-macaroni-soup",
    time: 20,
    serves: 4,
    fat: 1,
    saturated: 0,
    calories: 197,
    cholesterol: 0,
    carbohydrate: 39,
    protein: 7.5,
    sodium: 358
  },
  {
    title_english: "Fat-Free Corn Bread",
    title: "خبز الذرة الخالي من الدهون",
    description: "طبق مفضل من أطباق مطبخ الجنوب الأمريكي. سهل التحضير يحتوي على دهون.",
    ingredients: "1 كوب دقيق ذرة أصفر |1/2 كوب (79 جم) دقيق لجميع الأغراض |1/2 ملعقة صغيرة ملح |1 ملعقة كبيرة مسحوق خبز |4 بياض البيض أو 1/2 كوب بديل البيض |1 كوب (250 جم)زبادي سادة خالٍ من الدهون |1/2 كوب (113 مل) لبن منزوع الدسم |1/4 كوب (50 جم) سكر (لتقليل محتوى السعرات الحرارية يمكنك استبداله بمحلٍ خالٍ من السعرات الحرارية أو التغاضي عن السكر إذا كنت تفضل طعمًا أقل حلاوة)",
    method: "سخن الفرن أولًا إلى درجة حرارة 350 فهرنهايت (176 مئوية). |رش مقلاة حديدية أو صينية فطائر بزيت طهي غير لاصق. |اخلط جميع المكونات في وعاء وقلبها. |صبها في الإناء المُجهز. |ضعها في الفرن لمدة 30 - 35 دقيقة.",
    difficulty: "سهلة",
    category: "dessert|snack|quick and easy|fat free",
    hasImage: true,
    img: "fat-free-corn-bread",
    slug: "fat-free-corn-bread",
    time: 45,
    serves: 8,
    fat: 0.5,
    saturated: 0,
    calories: 97,
    cholesterol: 3,
    carbohydrate: 19,
    protein: 4,
    sodium: 92,
    fiber: 3
  },
  {
    title_english: "Fat-Free Date Bread",
    title: "خبز البلح الخالي من الدهون",
    description: "لن يخمن أي أحد أن هذه التحلية اللذيذة خالية من الدهون. فالبلح يبقيها ندية.",
    ingredients: "2 كوب (50 جم) بلح منزوع النواة |1 كوب (225 مل) ماء ساخن |1 ملعقة صغيرة بيكربونات صوديوم |2 من بياض البيض |1/2 كوب (100 جم) سكر |1 ملعقة صغيرة فانيليا |1 كوب ونصف (210 جم) دقيق",
    method: "سخن الفرن أولًا إلى درجة حرارة 350 فهرنهايت (176 مئوية). |ضع البلح في وعاء صغير. أضف بيكربونات الصوديوم إلى الماء وصبها على البلح. |في آلة تحضير الطعام، امزج بياض البيض والسكر والفانيليا. |أضف حوالي 1/4 خليط البلح والماء وامزج حتى يصبح القوام متجانسًا إلى حد كبير. |أضف الدقيق وامزج حتى يتجانس القوام. |أضف خليط البلح والماء المتبقي وامزجه لمدة 15 - 30 ثانية. قلب الخليط لتتأكد أنه ممزوج جيدًا. |صبه في قالب خُبز مقاس 5 × 9 بوصات مطلي بزيت طهي غير لاصق. |اخبزه في الفرن لمدة 60 - 75 دقيقة حتى تغرز سكين ويخرج نظيفًا. |برده وقطعه إلى شرائح. يمكن تقديمه مع جبن كريمي أو جبن ريكوتا خالٍ من الدهون.",
    difficulty: "متوسطة",
    category: "dessert|snack|fat free",
    hasImage: true,
    img: "fat-free-date-bread",
    slug: "fat-free-date-bread",
    time: 90,
    serves: 12,
    fat: 0,
    saturated: 0,
    calories: 148,
    cholesterol: 0,
    carbohydrate: 34,
    protein: 3,
    sodium: 114
  },
  {
    title_english: "Chewy Oatmeal Raisin Cookies",
    title: "بسكويت الشوفان بالزبيب اليابس",
    description: "مثالي لتجمعات الإجازات!",
    ingredients: "1 كوب (140 جم) شوفان تقليدي |1 كوب (140 جم) دقيق |1/2 ملعقة صغيرة بيكربونات صوديوم |3/4 ملعقة صغيرة قرفة مطحونة |1/2 ملعقة صغيرة ملح |1/2 ملعقة صغيرة فانيليا |1/2 كوب (85 جم) سكر بني |1/4 كوب (50 جم) سكر أبيض |1/4 كوب (44 جم) زبيب |1/2 كوب (175 جم) صلصة تفاح |1 بياض بيضة واحدة |2 ملعقة كبيرة من اللبن المنزوع الدسم",
    method: "سخن الفرن أولًا إلى درجة حرارة 375 فهرنهايت (190 مئوية). |اخلط جميع المكونات الجافة مع الزبيب.|أضف صلصة التفاح، وبياض البيض واللبن منزوع الدسم إلى المكونات الجافة. اخلطها لتمتزج. |ضع الخليط على هيئة أقراص في صينية بسكويت غير لاصقة. |اخبزه في الفرن لمدة 12 -15 دقيقة أو حتى يصبح ذهبيًا. |اتركه يجمد لبضع دقائق قبل رفعه من على الصينية ونقله إلى رف التبريد.",
    difficulty: "سهلة",
    category: "dessert|snack|family favorites|quick and easy",
    hasImage: true,
    img: "chewy-oatmeal-raisin-cookies",
    slug: "chewy-oatmeal-raisin-cookies",
    time: 20,
    serves: 12,
    fat: 0.6,
    saturated: 0.1,
    calories: 121,
    cholesterol: 0,
    carbohydrate: 27,
    protein: 2,
    sodium: 158,
    fiber: 1
  },
  {
    title_english: "Barbequed Vegetables",
    title: "الخضراوات المشوية",
    description: "أضف مذاق خاص على الخضروات. قدمها مع أرز بسمتي بني.",
    ingredients: "1 حبة بصل، مقطع شرائح |1 حبة كوسة، مقطعة شرائح |1 حبة قرع صيفي، مقطع شرائح |1 حبة فلفل أخضر، مقطعة شرائح |1 حبة فلفل أحمر، مقطع شرائح |2 حبة بطاطس جديدة مقطعة لقطع بحجم القضمة |8 حبات فطر كبير أو أكثر |1/2 كوب (70 جم) صلصة شواء",
    method: "سخن الفرن أولًا إلى درجة حرارة 425 فهرنهايت (218 مئوية). |قم بطهي البطاطس قليلًا أولًا بوضعها في الميكروويف لمدة 3 دقائق على الإعداد العالي. |رش صينية خَبز مقاس 9 × 13 بوصة بزيت طهي غير لاصق، أو بطنها بورق ألومنيوم غير لاصق. |ضع جميع الخضراوات في الصينية وادهنها بصلصة الشواء. |ضعها في الفرن لمدة 15 دقيقة وأنهها بوضعها تحت الشواية لمدة 5 دقائق حتى تكتسب لونًا أسود قليلًا.",
    difficulty: "سهلة",
    category: "quick and easy|vegetarian|dinner|lunch",
    hasImage: true,
    img: "barbequed-vegetables",
    slug: "barbequed-vegetables",
    serves: 4,
    fat: 1,
    saturated: 0,
    calories: 115,
    cholesterol: 0,
    carbohydrate: 24,
    protein: 4,
    sodium: 210,
    fiber: 4
  },
  {
    title_english: "Fat-Free Peach Cobbler",
    title: "فطيرة الخوخ الخالية من الدهون",
    description: "هذه حلوى بسيطة لأي مناسبة.",
    ingredients: "1/2 كوب (113 جم) سكر أبيض (أو محلٍ خالٍ من السعرات الحرارية من أجل سعرات حرارية أقل) |1/2 كوب (70 جم) دقيق |1/2 كوب (113 مل) لبن منزوع الدسم |1 ملعقة صغيرة مسحوق خبز |1/4 ملعقة صغيرة ملح |3 أكواب (525 جم) خوخ مجمد بدون سكر مضاف",
    method: "سخن الفرن أولًا إلى درجة حرارة 350 فهرنهايت (176 جم). |رش صينية مربعة مقاس 8 × 8 بوصات بزيت طهي غير لاصق. |امزج الدقيق واللبن ومسحوق الخبز والملح في وعاء واحد. |في وعاء آخر، أضف الخوخ وامزجه مع 1/2 كوب (113 جم) سكر (أو محل أو ستيفيا لوجبة منخفضة السعرات الحرارية). |صب خليط العجينة في الصينية أولًا وافرده. |بعدها، أضف الفاكهة المخلوطة بالسكر (أو المحلي) فوق العجينة مباشرةً. |يتم نضج القشرة بالكامل حتى السطح. |اخبزها في الفرن لمدة 30 - 35 دقيقة حتى تصبح بنية حسب ذوقك. |الكريمة الفوقية اختيارية: أيس كريم الفانيليا الخالي من الدهون (إذا كنت تراقب السعرات الحرارية الخاصة بك، فاختر الوجبة الخالية من الدهون المضافة).",
    difficulty: "متوسطة",
    category: "dessert|fat free",
    hasImage: true,
    img: "fat-free-peach-cobbler",
    slug: "fat-free-peach-cobbler",
    time: 45,
    serves: 6,
    fat: 0,
    saturated: 3,
    calories: 118,
    cholesterol: 0,
    carbohydrate: 30,
    protein: 3,
    sodium: 103,
    fiber: 2
  },
  {
    title_english: "Fish Made Simple",
    title: "السمك سهل التحضير",
    description: "استمتع بنكهة السمك الخفيفة بطريقة التحضير البسيطة هذه.",
    ingredients: "12 - 16 أوقية (340 جم - 453 جم) سمك قليل الدهون مثل سمك الموسى، أو الحدوق أو القد أو البلطي أو الماهي ماهي أو الهلبوت |2 من بياض البيض أو 1/2 علبة بديل بيض |1/2 كوب (63 جم) بقسماط على الطريقة الإيطالية |1 ثمرة ليمون طازجة",
    method: "سخن الفرن أولًا إلى درجة حرارة 425 فهرنهايت (218 مئوية). |اغسل شرائح السمك وجففها. |ضع البيض في وعاء واغمس به السمك. |ضع البقسماط في وعاء آخر واستخدمه لتغطي السمك. |ضع السمك المغطى على ورق ألومنيوم غير لاصق على صينية خبز (من أجل تنظيف أسهل). |زينه بشرائح ليمون رفيعة. |ضعه في الفرن لمدة 20 دقيقة (على حسب السُمك) أو حتى يتفتت السمك. |قدمه مع ليمون طازج.",
    difficulty: "سهلة",
    category: "dinner|fish|quick and easy",
    hasImage: true,
    img: "fish-made-simple",
    slug: "fish-made-simple",
    time: 30,
    serves: 2,
    fat: 3,
    saturated: 0,
    calories: 223,
    cholesterol: 83,
    carbohydrate: 10,
    protein: 37,
    sodium: 395
  },
  {
    title_english: "Gingery Chinese Stir-Fry",
    title: "طبق القلي السريع الصيني بالزنجبيل",
    description: "يصلح لأي نوع خضراوات أو بروتين (الدجاج أو الجمبري أو اللحم البقري قليل الدهون)",
    ingredients: "2 -3 ملاعق كبيرة زنجبيل طازج مفروم (يمكن أيضًا استخدام الزنجبيل المفروم الجاهز) |3 - 4 فصوص ثوم مفروم |1 رطل (16 أوقية) صدور دجاج مخلي بدون الجلد، مقطعة إلى شرائط |كوب (150 جم) قرون بازلاء صينية |2 كوب (300 جم) زهيرات بروكولي |1 كوب (175 جم) فطر، مقطع شرائح |حبة أو اثنين ملفوف صيني صغير، مقطع شرائح |كوب أو اثنين (150 -300 جم) براعم فاصولياء طازجة | 2 حبة بصل أخضر مقطع مكعبات |1/2 كوب (88 جم) شرائح جزر رفيعة |1/2 كوب (88 جم) فلفل أحمر مقطع شرائح |علبة صغيرة من كستناء الماء مشطوفة |1 كوب ونصف (338 مل) مرق دجاج (منخفض الصوديوم حسب الرغبة) |2 ملعقة كبيرة نشا ذرة (استخدم أكثر قليلًا إذا لزم أن يكون أثقل) |2 -3 ملاعق كبيرة صلصة صوية خفيفة |فلفل طازج حسب الذوق",
    method: "في مقلاة تسوية كبيرة أو مقلاة ووك مجهزة برش زيت طهي غير لاصق، قم بتسوية الدجاج حتى قرب نضجه. |أضف الفطر والجزر واستمر في التسوية. ثم أضف باقي الخضراوات وكوب (225 مل) من مرق الدجاج. |غط المقلاة لمدة 5 دقائق، لتكتسب حرارة. |اخلط 2 ملعقتين كبيرتين من نشا الذرة مع المرق المتبقي، ثم قلّب صلصة الصويا مع الخليط. قم بطهيه لفترة وجيزة حتى يثخن. |أضف الفلفل المطحون الطازج وقدمه مع كوب (200 جم) أرز بني أو أبيض، للفرد الواحد.",
    difficulty: "متوسطة",
    category: "dinner|family favorites",
    hasImage: true,
    img: "gingery-chinese-stir-fry",
    slug: "gingery-chinese-stir-fry",
    serves: 4,
    fat: 3,
    saturated: 1,
    calories: 435,
    cholesterol: 65,
    carbohydrate: 66,
    protein: 36,
    sodium: 579 - 972,
  },
  {
    title_english: "Half Homemade Brownies",
    title: "كعكات منزلية الصنع نصف مخبوزة",
    description: "ستستمتع بالمذاق الرائع دون عناء",
    ingredients: "1 علبة خليط البراوني |1/2 بديل للبيض |1/2 كوب (125 جم) زبادي عادي غير دسم أو زبادي يوناني |1/4 كوب (56 مل) ماء (أو لكل وصفة عبوة)",
    method: "يُسخن الفرن حتى 350 درجة فهرنهايت (176 درجة مئوية). |تُخلط جميع المكونات وتُوضع في مقلاة مقاس 13 بوصة × 9 بوصة مدهونة بزيت طهي من بخاخ غير لاصق. |تُخبز لمدة 25 دقيقة أو حتى يمكنك غرس سكين بها ويخرج نظيفًا. |تُبرد وتُقطع إلى 18 قطعة.",
    difficulty: "سهلة",
    category: "dessert|family favorites|quick and easy",
    hasImage: true,
    img: "half-homemade-brownies",
    slug: "half-homemade-brownies",
    time: 35,
    serves: 18,
    fat: 3.5,
    saturated: 1,
    calories: 141,
    cholesterol: 0,
    carbohydrate: 25,
    protein: 3,
    sodium: 97
  },
  {
    title_english: "Harvest Apple Cake",
    title: "كعكة حصاد التفاح",
    description: "تحتوي هذه الكعكة على مكونات رائعة! لا تخبر أحدًا.",
    ingredients: "1/2 كوب (100 جم) سكر |1/2 كوب (70 جم) دقيق |1 كوب (150 جم) فاصوليا بنتو، مغسولة ومصفاة |1 بياض بيضة |2 ملعقة كبيرة من الزيت (استخدم 2 ملعقة كبيرة من عصير التفاح لخفض محتوى الدهون إلى أقل من 1 جم لكل وجبة) |1 ملعقة صغيرة من الفانيليا |1/2 ملعقة صغيرة من صودا الخبز |1/4 ملعقة صغيرة من القرنفل |1 ملعقة صغيرة من القرفة |1 كوب (175 جم) تفاح نيء مفروم (شامل القشرة) |1/3 كوب (58 جم) زبيب",
    method: "يُسخن الفرن حتى 375 فهرنهايت (190 درجة مئوية) |يُخلط التفاح في آلة تحضير الطعام حتى يصبح مفرومًا. فصل المكونات. |تُمزج جميع المكونات باستثناء التفاح والزبيب في آلة تحضير الطعام حتى تصبح ناعمة. |يُقلّب التفاح والزبيب. |يُسكب في طبق خبز زجاجي مقاس 8 × 8 بوصة مدهون بزيت طهي من بخاخ غير لاصق. |تُخبز الوصفة لمدة 50 دقيقة أو حتى يمكنك غرس سكين بها ويخرج نظيفًا.",
    difficulty: "سهلة",
    category: "dessert|family favorites",
    hasImage: true,
    img: "harvest-apple-cake",
    slug: "harvest-apple-cake",
    time: 60,
    serves: 9,
    fat: 3,
    saturated: 0,
    calories: 141,
    cholesterol: 0,
    carbohydrate: 27,
    protein: 2.5,
    sodium: 115,
    fiber: 2
  },
  {
    title_english: "Herbed New Potato Salad",
    title: "سلطة البطاطس الجديدة بالأعشاب",
    description: "متنوعة الألوان ولذيذة. إذا كانت المكونات في متناول يدك، فمن السهل جدًا مزجها معًا.",
    ingredients: "حوالي 2 رطل (900 جم) بطاطس حمراء صغيرة أو جديدة (أو 4-‏5 بطاطس حمراء متوسطة الحجم) |1/2 كوب (75 جم) بازلاء مجمدة مذابة |1 ثمرة فلفل أحمر مفروم |1-2 ثمرة بصل أخضر/ بصل أخضر مفروم |1/4 كوب (58 جم) مايونيز خفيف (3.5 جم دهن لكل ملعقة كبيرة) |1/4 كوب (65 جم) زبادي يوناني خالي الدسم |1-2 ملعقة صغيرة. خردل ديجون |2-3 ملاعق كبيرة شبت طازج مفروم أو 2 - 3 ملعقة صغيرة شبت مجفف |1/4 ملعقة صغيرة من مسحوق الثوم |ملح وفلفل مطحون طازج حسب الرغبة",
    method: "تُسلق البطاطس حتى تنضج. تُبرّد، (لا تُقشر) وتُقطع إلى أرباع أو أثمان. |يُخلط المايونيز واللبن والخردل والتوابل في وعاء كبير. |تُضاف باقي المكونات مع التقليب. تُبرّد وتُقدّم. |لتقليل محتوى الدهون، يمكنك استخدام المايونيز قليل الدسم أو الخالي من الدسم أو الزبادي اليوناني الخالي من الدسم.",
    difficulty: "سهلة",
    category: "lunch|family favorites|vegetarian",
    hasImage: true,
    img: "herbed-new-potato-salad",
    slug: "herbed-new-potato-salad",
    serves: 4,
    fat: 4,
    saturated: 0,
    calories: 209,
    cholesterol: 2,
    carbohydrate: 41,
    protein: 6,
    sodium: 184,
    fiber: 5
  },
  {
    title_english: "7 Layer Dip",
    title: "غموس ذو ٧ طبقات بالوصفة المكسيكية",
    description: "هذا الغموس على الطريقة المكسيكية فاتح للشهية ورائع يمكن تقديمه في الحفلات. لن يتوقع أحد أنها وجبة قليلة الدهون. تُقدّم مع رقائق التورتيلا المخبوزة أو شرائح الخبز العربي.",
    ingredients: "1/4 كوب (44 جم) أفوكادو مفروم |1 ملعقة كبيرة عصير ليمون طازج |1 فص ثوم صغير مفروم |2 ملعقتين صغيرتين بصل مفروم |1/2 كوب (115 جم) زبادي يوناني خالي الدسم، زبادي عادي |1/4 ملعقة صغيرة ملح |1/8 ملعقة صغيرة فلفل |1 كوب (150 جم) (1/2 علبة) من الفاصوليا المقلية الخالية من الدهون |2/3 كوب (165 جم) قشدة حامضة خالية من الدسم / زبادي يوناني خالي من الدسم |1/2 كوب (115 جم) صلصة تشيلي غير حارة |1/4 كوب (29 جم) جبن التاكو مبشور ناعم |1 كوب (175 جم) طماطم برقوق مفرومة |1 ملعقة كبيرة كزبرة طازجة/ كزبرة مفرومة |1 ملعقة كبيرة بصل أخضر مفروم",
    method: "في وعاء صغير، أعد سلطة الجواكامولي بخلط أول 7 مكونات. |في طبق دائري سعة 9 بوصات، ضع الطبقات التالية: |الطبقة الأولى: الفاصوليا المقلية |الطبقة الثانية: القشدة الحامضة/ الزبادي اليوناني |الطبقة الثالثة: الجواكامولي |الطبقة الرابعة: صلصة تشيلي |الطبقة الخامسة: الجبن |الطبقة السادسة: الطماطم |الطبقة السابعة: البصل الأخضر/ الكزبرة",
    difficulty: "سهلة",
    category: "snack|lunch|family favorites|quick and easy",
    hasImage: true,
    img: "seven-layer-dip",
    slug: "seven-layer-dip",
    time: 15,
    serves: 10,
    fat: 1.5,
    saturated: 0.4,
    calories: 68,
    cholesterol: 2,
    carbohydrate: 10,
    protein: 4,
    sodium: 299
  },
  {
    title_english: "Apple Cider Jam Turnover",
    title: "فطيرة مربى محلاة بشراب التفاح",
    description: "هذه الفطائر الصغيرة اللذيذة بنكهة فطيرة التفاح خالية من الدهون!",
    ingredients: "1/2 علبة من رقائق عجينة الفيلو/ الجلاش (حوالي 20 ورقة)، مذابة من التجميد |8 أوقية (226 جم) جبن كريمي خالي من الدسم في درجة حرارة الغرفة |1/2 كوب (160 جم) مربى التفاح |1 بياض بيض مع 1 ملعقة كبيرة ماء |سكر محبب",
    method: "يُسخّن الفرن حتى 350 درجة فهرنهايت (176 درجة مئوية) وتُرص 2 من رقائق الخبر مع ورق الزبدة. |يُخلط الجبن الكريمي والمربى في وعاء صغير حتى تمتزج في خليط واحد. |تُفرد رقائق المعجنات بعناية وتُغطى بمنشفة مبللة لمنعه من الجفاف. |تُؤخذ 1 من رقائق المعجنات وتُطوى من المنتصف بالطول. |تُوضع 1 ملعقة كبيرة من خليط الجبن الكريمي في الزاوية السفلية من رقائق المعجنات. |ثم تُطوى زاوية من رقائق المعجنات عبر الحافة المقابلة لتشكيل مثلث. |تستمر في طي المثلث على نفسه، كما يُطوى العَلَم |تُوضع في صينية خبز |يُخفق البيض والماء. يُدهن البيض بالفرشاة على كل مثلث. يُرش عليها السكر |وتُخبز لمدة 20 دقيقة.",
    difficulty: "متوسطة",
    category: "snack|dessert|family favorites",
    hasImage: true,
    img: "apple-cider-jam-turnovers",
    slug: "apple-cider-jam-turnovers",
    time: 35,
    serves: 10,
    fat: 0.6,
    saturated: 0.1,
    calories: 118,
    cholesterol: 3,
    carbohydrate: 21,
    protein: 6,
    sodium: 245
  },
  {
    title_english: "Apple Crisp",
    title: "فطيرة التفاح المقرمشة",
    description: "استمتع بهذه الوصفة التقليدية مع ملعقة من الزبادي المجمد بالفانيليا الخالي من الدسم.",
    ingredients: "5 أكواب (875 جم) تفاح مقشر ومقطع إلى شرائح |2/3 كوب (93 جم) حبوب شوفان كاملة |1/3 كوب (47 جم) دقيق |2/3 كوب (113 جم) سكر بني معبأ بشكل خفيف |3/4 ملعقة صغيرة قرفة |3/4 ملعقة صغيرة جوزة الطيب |4 ملاعق كبيرة عسل",
    method: "يُسخّن الفرن حتى 350 درجة فهرنهايت (176 درجة مئوية) وتُدهن مقلاة 8 × 8 بوصة برذاذ زيت غير لاصق. |يُضاف التفاح إلى المقلاة المجهزة. |تُخلط باقي المكونات في وعاء كبير وتُمزج جيدًا. |تُرش فوق التفاح وتُخبز لمدة 30-35 دقيقة.",
    difficulty: "سهلة",
    category: "snack|dessert|family favorites",
    hasImage: true,
    img: "apple-crisp",
    slug: "apple-crisp",
    time: 45,
    serves: 8,
    fat: 1.1,
    saturated: 0.2,
    calories: 182,
    cholesterol: 0,
    carbohydrate: 42,
    protein: 3,
    sodium: 4,
    fiber: 3
  },
  {
    title_english: "Blueberry Pie",
    title: "فطيرة التوت الأزرق",
    description: "تأتي معظم الدهون في فطائر الفواكه من القشرة. عجينة قشرة الفطيرة قليلة الدسم هذه تصلح تمامًا لعمل هذه الفطيرة التقليدية.",
    ingredients: "عجينة قشرة الفطيرة (تصنع 1 قشر؛ وتضاعفها لعدد 2 قشرة) |1 ونصف كوب (187 جم) دقيق أبيض |1 إناء (عادة حوالي 5.3 أوقية) (150 جم) زبادي يوناني عادي |1/2 ملعقة صغيرة من زيت الزيتون |4 ملاعق كبيرة من الماء البارد |6 أكواب (600 جم) من التوت الأزرق المجمد أو الطازج |3/4 كوب (169 جم) سكر |4 ملاعق كبيرة من التابيوكا الجاهزة |نصف ملعقة صغيرة قرفة |1 ملعقة كبيرة عصير ليمون",
    method: "يُسخّن الفرن حتى 425 فهرنهايت (218 درجة مئوية) |يُخلط الدقيق واللبن الزبادي والزيت معًا حتى يتفتت. |يُضاف الماء البارد ويُقلّب حتى يختلط (لا تفرط في التقليب). |تُفرك العجينة من 6 مرات إلى 8 مرات. |تُفرد العجينة على سطح مرشوش بالدقيق حتى تأخذ شكل صينية الفطائر |للحشو: تُخلط المكونات في وعاء كبير. |تُضاف إلى قشرة الفطيرة الجاهزة في مقلاة سعة 9 بوصات. |يمكن حشو الطبقة العليا بقشرة فطيرة ثانية أو قطع قشرة الفطيرة الثانية إلى شعرية وإضافتها إلى الطبقة العليا |تُخبز في 425 فهرنهايت (218 درجة مئوية) لمدة 60 دقيقة (بضع دقائق أخرى للتوت المجمد).",
    difficulty: "متوسطة",
    category: "dessert|family favorites",
    hasImage: true,
    img: "blueberry-pie",
    slug: "blueberry-pie",
    time: 80,
    serves: 8,
    fat: 1.3,
    saturated: 0.2,
    calories: 330,
    cholesterol: 2,
    carbohydrate: 71,
    protein: 9,
    sodium: 20,
    fiber: 6
  },
  {
    title_english: "Buffalo Chicken Tenders",
    title: "تندر دجاج بصلصة بافلو",
    description: "هذه الوصفة هي الوصفة الساخنة والحارة قليلة الدسم للمقبلات السريعة هذه. تُقدّم مع الصلصة المفضلة الخالية من الدهون.",
    ingredients: "1/2 كوب (113 مل) حليب رائب خالٍ من الدسم، مقسم |1/3 كوب (75 جم) + 3 ملاعق كبيرة صلصة حارة، مقسمة |3 ملاعق كبيرة خل أبيض |2 رطل (32 أوقية) من قطع الدجاج |6 ملاعق كبيرة دقيق |6 ملاعق كبيرة من دقيق الذرة |1/2 ملعقة صغيرة فلفل حريف |1 ملعقة صغيرة بابريكا |2 ملعقة كبيرة قشدة حامضة خالية من الدهون",
    method: "في وعاء كبير، اخفق 1/4 كوب(56 مل) من مخيض اللبن، و3 ملاعق كبيرة من الصلصة الحارة، وخلًا. أضف الدجاج إلى المنقوع واتركه في الثلاجة لمدة 30 دقيقة على الأقل.|في إناء مسطح قم بمزج الدقيق ودقيق الذرة والفلفل الحار والبابريكا.|سخن الفرن مسبقًا على درجة حرارة 425 فهرنهايت (218 درجة مئوية). أخرج الدجاج من المنقوع ثم يقلب بخليط الدقيق ودقيق الذرة. |ضع الدجاج في صينية فرن كبيرة مغلّفة بورق القصدير ومرشوشة بالرذاذ غير اللاصق. |أدخل الدجاج للفرن لمدة 20 دقيقة، وقلّبه بحرص بعد 10 دقائق. |في وعاء صغير، حضّر صلصة بافالو إضافية بخفق 1/4 كوب (56 مل) من مخيض اللبن، و1/3 كوب (75 جم) من الصلصة الحارة والكريمة الحامضة الخالية من الدسم/ أو الزبادي اليوناني الخالي من الدسم |بمجرد أن يصبح الدجاج جاهزًا، رشّ الكمية المرغوب فيها من صلصة البافالو على الدجاج.|يُقدم مع الجزر وعيدان الكرفس.",
    difficulty: "متوسطة",
    category: "lunch|dinner|family favorites",
    hasImage: true,
    img: "buffalo-chicken-tenders",
    slug: "buffalo-chicken-tenders",
    time: 60,
    serves: 6,
    fat: 4.6,
    saturated: 1.0,
    calories: 259,
    cholesterol: 112,
    carbohydrate: 15,
    protein: 37,
    sodium: 612,
    fiber: 1,
  },
  {
    title_english: "Chicken Stew",
    title: "يخنة الدجاج",
    description: "ستدفئك هذه اليخنة الشهية في تلك الليالي الباردة. هذه الوصفة من السهل مضاعفتها لتكفي عددًا أكبر.",
    ingredients: "1/2 ملعقة كبيرة من زيت الزيتون |1/2 كوب (25 جم) من الكرفس المقطع، |1/2 كوب (25 جم) من الجزر المقطع، |1/2 كوب (75 جم) من البصل المقطع، |ملح وفلفل حسب الرغبة|14 أوقية (396 جم) من الطماطم المعلبة المقطعة لمكعبات، |14 أوقية (396 جم) من مرقة دجاج معلبة خالية من الدسم ومنخفضة الصوديوم، |1/2 كوب (10 جم) من أوراق الريحان الطازجة المقطوفة، |ملعقة كبيرة من صلصة الطماطم، |1/2 ملعقة صغيرة من أوراق الزعتر الطازج، |حبة بطاطا كبيرة مقطعة إلى مكعبات، |عدد 1 رطل من صدور الدجاج المخلية بدون جلد.",
    method: "سّخن الزيت في طاسة كبيرة على درجة حرارة متوسطة وأضف الكرفس، والجزر، والبصل.|قم بالطهي لمدة 5 -10 دقائق؛ ثم أضف الملح والفلفل.|أضف المكونات المتبقية ثم أضف الدجاج أخيرًا. |ضعه على النار حتى الغليان ثم اتركه مكشوفًا على نار هادئة لمدة 25 دقيقة أو حتى تصل درجة حرارة الدجاج الداخلية إلـى 165 درجة فهرنهايت (73 درجة مئوية). |أخرج الدجاج وقطعه لقطع صغيرة ثم أضفه لليخنة مرة أخرى واتركه على نار هادئة لمدة 5 دقائق إضافية.|يُقدم مع الخبز المقرمش.",
    difficulty: "متوسطة",
    category: "dinner|family favorites|hearty meal",
    hasImage: true,
    img: "chicken-stew",
    slug: "chicken-stew",
    time: 60,
    serves: 4,
    fat: 4.9,
    saturated: 0.9,
    calories: 233,
    cholesterol: 83,
    carbohydrate: 17,
    protein: 28,
    sodium: 521,
    fiber: 3
  },
  {
    title_english: "Creamy Mustard Tarragon Chicken",
    title: "دجاج بالطرخون وصوص الكريمة والخردل",
    description: "ستضيف هذه الكريمة نكهة جديدة لدجاجتك على العشاء.",
    ingredients: "عدد 4 قطع من صدور الدجاج المخلية بدون جلد مقطعة إلى أنصاف ومطبوخة، |ملعقة صغيرة من السمن الناعم، |1/4 كوب (25 جم) من الكراث المبشور جيدًا |1/4 كوب (56 مل) من مرقة دجاج معلبة خالية من الدسم ومنخفضة الصوديوم |1/3 كوب (76 جم) من خردل البصل المكرمل ستونوول كيتشن |1/2 كوب (113 مل) من حليب مبخر خالي الدسم وملعقة كبيرة من الطرخون المقطع الطازج.",
    method: "في مقلاة كبيرة أذب السمن على درجة حرارة متوسطة |أضف الكراث وقم بطهيه لمدة دقيقة أو اثنتين. |أضف مرقة الدجاج وخردل البصل المكرمل واتركه على نار هادئة.|ثم أضف ببطء الحليب المبخر خالي الدسم والطرخون. قلّبه حتى يتكاثف قليلًا. |ثم أضف صدور الدجاج المطبوخة وسخنها جيدًا.",
    difficulty: "سهلة",
    category: "dinner|family favorites",
    hasImage: true,
    img: "creamy-mustard-tarragon-chicken",
    slug: "creamy-mustard-tarragon-chicken",
    serves: 4,
    fat: 5.6,
    saturated: 1.2,
    calories: 269,
    cholesterol: 125,
    carbohydrate: 9,
    protein: 41,
    sodium: 367,
    fiber: 0,
  },
  {
    title_english: "Easy Fiesta Fish",
    title: "سمك الفيستا سهل التحضير",
    description: "هذه وصفة سهلة، لكن شهية لتناول السمك الأبيض. بقايا الوصفة مثالية لصنع معجنات التاكو بالسمك.",
    ingredients: "عدد 1 فلفل أحمر صغير مقطع لشرائح رفيعة |1 بصلة صغيرة مقطعة لشرائح رفيعة |رذاذ غير لاصق | 2 رطل (32 أوقية) من سمك القد أو أي سمك أبيض آخر قليل الدهن |كوب (225 جم) من صلصة خالية الدهون |3/4 كوب (86 جم) من جبن شيدر سارجينتو قليلة الدسم.",
    method: "سخّن الفرن مسبقًا على درجة حرارة 350 درجة فهرنهايت (176 درجة مئوية).|رش المقلاة برذاذ زيت الطهي غير اللاصق.|قم بقلي البصل والفلفل في المقلاة من 5 لـ 10 دقائق.|ضع السمك في مقلاة كبيرة بحجم 13×9 ثم أضف خليط البصل والفلفل فوقه.|وزّع الصلصة فوق السمك ثم رش الجبن.|أدخله للفرن من30 لـ 35 دقيقة أو حتى يتفكك السمك بسهولة. |زينه بالكريمة الحامضة الخالية من الدسم/ أو الزبادي اليوناني الخالي من الدسم.",
    difficulty: "سهلة",
    category: "dinner|family favorites|fish",
    hasImage: true,
    img: "easy-fiesta-fish",
    slug: "easy-fiesta-fish",
    time: 50,
    serves: 6,
    fat: 4.1,
    saturated: 2.2,
    calories: 201,
    cholesterol: 75,
    carbohydrate: 10,
    protein: 31,
    sodium: 177,
    fiber: 1
  },
  {
    title_english: "Herb Encrusted Chicken Breast with Mango Chutney",
    title: "صدور الدجاج المغطاة بالأعشاب مع صلصة المانجو",
    description: "جرب هذه الوصفة لإضافة المزيد من النكهة لوجبة صدور الدجاج المشوية الأسبوعية الخاصة بك.",
    ingredients: "عدد 6 قطع من صدور الدجاج، حوالي 6 أوقية (170 جم) لكل قطعة |رذاذ غير لاصق |ملح وفلفل |خردل ديجون |أغصان إكليل الجبل الطازج والريحان والبقدونس (أو النوع المفضل لك من الأعشاب الطازجة) مفرومة، |3/4 كوب (130 جم) من الطماطم المقطعة إلى مكعبات صغيرة، |3/4 كوب (130) من المانجو مقطع إلى مكعبات صغيرة، |1/2 كوب (90 جم) من الفلفل الأخضر المعتدل مقطع إلى مكعبات صغيرة، |1/4 كوب (25 جم) من البصل الأخضر مقطع إلى شرائح، |ملعقة كبيرة من عصير الليمون |1/4 ملعقة صغيرة من الملح |1/4 ملعقة صغيرة من الفلفل الأسود المطحون |1/8 ملعقة صغيرة من الفلفل الأحمر الحار",
    method: "سخّن الفرن على درجة حرارة 350 فهرنهايت (176 درجة مئوية). |بهّر الدجاج بالملح والفلفل. رش الشواية الداخلية أو الخارجية بالرذاذ غير اللاصق وقم بشي الدجاج حتى تظهر عليها العلامات لمدة حوالي دقيقة أو اثنتين.|بعد ظهور العلامات على الدجاج، ضعها على صينية فرن كبيرة. |أضف طبقة رفيعة من خردل ديجون فوق الدجاج ثم أضف الأعشاب الطازجة من اختيارك. |أدخله الفرن حتى تصل درجة الحرارة الداخلية إلى 165 فهرنهايت (73 درجة مئوية).|أمزج المكونات لصلصة المانجو وقدّمها فوق صدور الدجاج.",
    difficulty: "متوسطة",
    category: "dinner|hearty meal",
    hasImage: true,
    img: "herb-encrusted-chicken-breast-with-mango-chutney",
    slug: "herb-encrusted-chicken-breast-with-mango-chutney",
    serves: 6,
    fat: 4.5,
    saturated: 1.0,
    calories: 215,
    cholesterol: 124,
    carbohydrate: 2,
    protein: 39,
    sodium: 191,
    fiber: 0
  },
  {
    title_english: "Apple Brown Betty",
    title: "فطيرة القرفة والتفاح",
    description: "ستمتلئ جميع أركان منزلك برائحة القرفة اللذيذة عندما تطهو هذه الوصفة السهلة بطيئة الطهي!",
    ingredients: "6 أكواب من التفاح المطبوخ المقشور منزوع البذور والمقطع إلى ثمان قطع (حوالي 5 تفاحات متوسطة الحجم) |1 كوب (125 جم) من فتات الخبز |ملعقة صغيرة من القرفة المطحونة |ملعقة صغيرة من جوزة الطيب المطحونة |1/8 ملعقة صغيرة من الملح |3/4 كوب (128 جم) من السكر البني الفاتح المعبأ |3/4 كوب (190 جم) من الزبادي اليوناني السادة |ملعقة كبيرة من زبدة مذابة قليلة الدسم |1/4 كوب (29 جم) من عين الجمل المفروم جيدًا |1/2 كوب (75 جم) من المثلجات الخالية من الدسم بنكهة الفانيليا |أضف 1/2 كوب (75 جم) من المثلجات الخالية من الدسم إذا أحببت ذلك!",
    method: "قم بتغطية حلة الطهو البطيء بالرذاذ غير اللاصق. ضع التفاح في الأسفل.|امزج البقسماط والقرفة وجوزة الطيب والملح والسكر والزبدة والزبادي اليوناني وعين الجمل في وعاء متوسط الحجم. وزّع التفاح. قم بتغطيتها وطهيها على درجة حرارة منخفضة لمدة 3-4 ساعات أو على درجة حرارة عالية لمدة ساعتين. |يُقدم الطبق دافئًا مع المثلجات الخالية من الدسم أو الكريمة المخفوقة الخالية من الدسم",
    difficulty: "متوسطة",
    category: "dessert|family favorites",
    hasImage: true,
    img: "apple-brown-betty",
    slug: "apple-brown-betty",
    time: 130,
    serves: 8,
    fat: 3.1,
    saturated: 0.5,
    calories: 170,
    cholesterol: 1,
    carbohydrate: 33,
    protein: 3,
    sodium: 99,
    fiber: 3,
  },
  {
    title_english: "Beef Kebabs",
    title: "كباب اللحم البقري",
    description: "وجبة شهية ورائعة للطهي خارج المنزل في الأوقات الصيفية!",
    ingredients: "16 أوقية (453 جم) من لحم الخاصرة، قليل الدهون فقط، مقطع |2 حبة من البطاطا المقطعة لمكعبات |16 حبة من الطماطم الكرزية |بصلة حمراء مقطعة لشرائح |2 حبة من الفلفل الحلو، مقطعة إلى شرائح |ملعقة كبيرة من البهارات |8 أسياخ |رذاذ غير لاصق",
    method: "أزل أي دهون مرئية من لحم الخاصرة قليل الدهن فقط. قطعه لمكعبات بحجم 1 أوقية (28 جم) (1 بوصة × 1 بوصة).|اغسل البطاطا وقطعها إلى مكعبات بحجم 1 بوصة × 1 بوصة.|قطع البصل لشرائح ثم قطعها لقطع صغيرة.|ضع حبتين من الطماطم الكرزية، وقطعتين من مكعبات لحم الخاصرة بحجم 1 أوقية، و3 مكعبات من البطاطا، و3 شرائح من الفلفل، و3 شرائح من البصل على كل سيخ بالتناوب. كرر ذلك 8 مرات.|ثم ضع الأسياخ الكاملة على الشواية أو في صينية فرن. أبهر باستخدام بهارات مسز داش.| |للشواء: رش الشواية برذاذ زيت الطعام غير اللاصق وقم بشواء اللحم حتى تصل لدرجة التسوية المرغوب فيها و يمكنك وضع شوكة في البطاطا. لتسويتها بالفرن: قم بتسويتها على درجة حرارة 425 فهرنهايت (218 درجة مئوية) لمدة 30 دقيقة أو حتى تمام النضج.",
    difficulty: "متوسطة",
    category: "dinner|family favorites",
    hasImage: true,
    img: "beef-kebabs",
    slug: "beef-kebabs",
    serves: 4,
    fat: 6.9,
    saturated: 2.6,
    calories: 330,
    cholesterol: 93,
    carbohydrate: 28,
    protein: 38,
    sodium: 87,
    fiber: 4
  },
  {
    title_english: "Berry Trifle",
    title: "ترايفل التوت",
    description: "حلوى ممتعة وسهلة يمكنك أخذها في النزهات والتجمعات.",
    ingredients: "10 أوقيات (283 جم) من كيك محضر ومقطع لمكعبات |باينت أو نصف لتر من الفراولة الطازجة المقطعة لشرائح |2-6 أوقية (56-170 جم) إناء من التوت الأزرق الطازج |1-12 أوقية (28-340 جم) وعاء من الكريمة المخفوقة الخالية من الدسم",
    method: "ضع المكونات في طبقات بدءًا بشرائح الفرولة والكيك والكريمة المخفوقة الباردة والتوت ثم كرر العملية.",
    difficulty: "سهلة",
    category: "dessert|family favorites",
    hasImage: true,
    img: "berry-trifle",
    slug: "berry-trifle",
    time: 10,
    serves: 8,
    fat: 0.5,
    saturated: 0,
    calories: 189,
    cholesterol: 0,
    carbohydrate: 41,
    protein: 3,
    sodium: 290,
    fiber: 2
  },
  {
    title_english: "Boneless Lean Stew",
    title: "يخنة مخلية باللحم الخالي من الدهن",
    description: "وجبة دافئة لليلة باردة.",
    ingredients: "ملعقة كبيرة من زيت الزيتون أو زيت نباتي |1 1/4 رطل (560 جم) من يخنة اللحم قليلة الدهن |عدد 1 فص ثوم |بصلة متوسطة الحجم |عدد 1 حبة فلفل أخضر |ملعقة صغيرة من الكركم |ملعقة صغيرة من المريمية |ملعقة صغيرة من الكمون |2 كوب (300 جم) من البازلاء الصغيرة (مجمدة أو معلبة) |1 رطل (16 أوقية) من الجزر الصغير |4 حبات بطاطا متوسطة الحجم مقشرة ومقطعة إلى أرباع.",
    method: "غط قاع إناء كبير بقليل من الزيت. اضبط الحرارة على الدرجة المنخفضة.|قطّع البصل والثوم وضفهم للإناء. ضع الإناء على النار حتى يذبل البصل. |أضف بقية المكونات، فيما عدا الماء. اتركهم لمدة 5 دقائق مع التقليب بين الحين والآخر حتى ينخفض مستوى السائل المتطاير. |أضف الماء (بما يكفي لتغطية باقي المكونات). لصلصة أكثر سمكًا، أضف ملعقة كبيرة أو اثنتين من الدقيق في المرة الواحدة. غط الإناء، ودع اليخنة تنضج لمدة 30 دقيقة تقريبًا على درجة حرارة هادئة لمتوسطة. |ملحوظة: تصبح هذه اليخنة أفضل كثيرًا في اليوم الثاني أو الثالث، لذا لا بأس في أن تضعها في فريزر الثلاجة.",
    difficulty: "متوسطة",
    category: "dinner|family favorites|hearty meal",
    hasImage: true,
    img: "boneless-lean-stew",
    slug: "boneless-lean-stew",
    time: 45,
    serves: 6,
    fat: 6,
    saturated: 2,
    calories: 312,
    cholesterol: 62,
    carbohydrate: 39,
    protein: 26,
    sodium: 143,
    fiber: 7
  },
  {
    title_english: "Chicken Salad",
    title: "سلطة دجاج",
    description: "وجبة سريعة وسهلة من الوجبات الصيفية المفضلة!",
    ingredients: "2 علبة كبيرة من صدور الدجاج الأبيض، مجففة ومبشورة بالشوكة لتفتيتها |3 من سيقان الكرفس المقطع|1/2 بصلة متوسطة الحجم مقطعة |1/4 كوب (65 جم) من الزبادي اليوناني السادة خالي الدسم |1/8 ملعقة صغيرة من الملح |1/4 ملعقة صغيرة من الفلفل الأسود",
    method: "قطع الدجاج في وعاء متوسط الحجم. |أضف جميع المكونات الأخرى وأمزجها. |إضافات خالية من الدسم اختيارية: تفاح مقطع أو عنب أو بعض التوابل الحُلوة أو أناناس مفروم",
    difficulty: "سهلة",
    category: "lunch|quick and easy",
    hasImage: true,
    img: "chicken-salad",
    slug: "chicken-salad",
    time: 10,
    serves: 6,
    fat: 0.1,
    saturated: 0,
    calories: 101,
    cholesterol: 0.5,
    carbohydrate: 6,
    protein: 16,
    sodium: 437,
    fiber: 2
  },
  {
    title_english: "Creamy Mushroom Chicken",
    title: "دجاج كريمي بالمشروم",
    description: "إذا كنت تبحث عن المذاق الكريمي الشهي، فإليك هذه الوصفة البسيطة المبهرة.",
    ingredients: "1 ونصف رطل ( 675 جم)من صدور الدجاج منزوعة الجلد |10 أوقية (283 جم) من علبة حساء كريمة المشروم |1 كوب (250 جم) من الكريمة الحامضة خالية الدسم / أو زبادي يوناني خالٍ من الدسم |3 ملاعق كبيرة من الخل |8 أوقية (226 جم) من علبة شرائح المشروم المصفاة |كوب (150 جم) من البازلاء المجمدة المذابة |جرة صغيرة من الفلفل الإسباني، فلفل أسود حسب الرغبة|4 أكواب (800 جم) من الأرز البني المطبوخ",
    method: "سخن الفرن مسبقًا على درجة حرارة 350 فهرنهايت (176 درجة مئوية) |ضع صدور الدجاج في صينية فرن مجهزة برذاذ زيت طهي غير لاصق.|في وعاء صغير، اخلط الحساء مع الكريمة الحامضة/ أو الزبادي اليوناني والمشروم والخل. قلّب الدجاج وغطه.|أدخله للفرن لمدة 50 - 65 دقيقة، حتى ترى فقاعات.|أضف البازلاء المجمدة والفلفل الإسباني (إذا كنت ترغب) في نهاية الطهو.|اتركها لمدة 10 دقائق. |يُقدم الدجاج والصلصة مع كوب (200 جم) من الأرز البني للشخص الواحد.",
    difficulty: "سهلة",
    category: "dinner|hearty meal",
    hasImage: true,
    img: "creamy-mushroom-chicken",
    slug: "creamy-mushroom-chicken",
    time: 90,
    serves: 4,
    fat: 7.4,
    saturated: 1.6,
    calories: 558,
    cholesterol: 133,
    carbohydrate: 68,
    sodium: 723,
    fiber: 6
  },
  {
    title_english: "Easy Pie Crust",
    title: "قشرة الفطائر السهلة",
    description: "أساس لذيذ وسهل لجميع الفطائر المفضلة لديك!",
    ingredients: "كوب ونصف (187 جم) دقيق أبيض |علبة (عادةً حوالي 5.3 أوقية) (150 جم) زبادي يوناني، سادة |1/2 ملعقة صغيرة زيت زيتون |4 ملاعق كبيرة ماء بارد |ملعقة صغيرة قرفة",
    method: "اخلط الدقيق، والزبادي اليوناني، والزيت معًا حتى يصبح خليطًا هشًا. |أضف الماء البارد وقلبه حتى يختلط (لا تخلط أكثر من اللازم). |اعجن العجينة 6 - 8 مرات. |افرد العجينة على سطح مرشوش بدقيق لتناسب حجم صينية الفطائر. |رش القرفة على العجينة المفرودة. |اخبزها في درجة حرارة 425 فهرنهايت (218 مئوية) لمدة 15 - 20 دقيقة.",
    difficulty: "سهلة",
    category: "dessert|family favorites|quick and easy",
    hasImage: true,
    img: "easy-pie-crust",
    slug: "easy-pie-crust",
    time: 30,
    serves: 8,
    fat: 0.6,
    saturated: 0.1,
    calories: 91,
    cholesterol: 1,
    carbohydrate: 17,
    sodium: 8,
    fiber: 1,
  },
  {
    title_english: "Easy Spinach Pasta Salad",
    title: "سلطة المعكرونة بالسبانخ السهلة",
    description: "",
    ingredients: "كوب (175 جم) طماطم مجففة في الشمس مقطعة وندية لكن ليست مليئة بالزيت |14.5 أوقية (411 جم) معكرونة ربطة فراشة |6 أكواب (1350 جم) سبانج صغيرة |علبة فاصولياء بيضاء |2/3 كوب (165 مل) تتبيلة إيطالية خالية من الدسم |فصا ثوم مسحوقان |1/2 كوب (50 جم) جبن بارميزان خالٍ من الدسم |فلفل أو فلفل أحمر مسحوق اختياري",
    method: "قم بطهي المعكرونة حسب التعليمات. صفِها واشطفها بماء بارد وضعها في وعاء كبير.|أضف المكونات المتبقية واخلطها جيدًا. |غطها وبردها لمدة ساعتين قبل التقديم.",
    difficulty: "سهلة",
    category: "lunch|dinner|family favorites",
    hasImage: true,
    img: "easy-spinach-pasta-salad",
    slug: "easy-spinach-pasta-salad",
    serves: 12,
    fat: 1.1,
    saturated: 0,
    calories: 214,
    cholesterol: 1,
    sodium: 255,
    fiber: 4
  },
  {
    title_english: "Homemade Pizza Dough",
    title: "عجينة البيتزا منزلية الصنع",
    description: "",
    ingredients: "عبوة خميرة جافة نشطة |كوب (225 مل) ماء دافئ |ملعقة كبيرة عسل |كوب ونصف (340 جم) دقيق خُبز (لاحظ أن دقيق الخبز يصنع قشرة مقرمشة أكثر، والدقيق لجميع الأغراض يصنع قشرة مطاطية أكثر) |1/2 ملعقة صغيرة ملح",
    method: "أذب الخميرة والعسل في ماء دافئ. اتركهما لمدة 10 دقائق حتى تتكون رغوة. |اخلط الدقيق والملح في وعاء وأضف خليط الخميرة بالتدريج. شكّل العجينة على هيئة كرة. اعجنها لمدة 5 دقائق وضع العجينة في وعاء مغطى بطبقة دقيق خفيفة. غطها بكيس بلاستيكي واتركها لمدة ساعة أو حتى تتضاعف في الحجم. |سخن الفرن أولًا إلى درجة حرارة 450 فهرنهايت (232 مئوية). |أخرج العجينة من الوعاء واضربها لتفرغ منها الهواء. افردها على شكل دائرة قطرها 12 بوصة. ضعها على حجر خبز أو صينية وضع الإضافات المفضلة لديك. اخبزها لمدة 10 - 13 دقيقة أو حتى يصبح لون القشرة بنيًا ذهبيًا.",
    difficulty: "سهلة",
    category: "dinner|family favorites|quick and easy",
    hasImage: true,
    img: "homemade-pizza-dough",
    slug: "homemade-pizza-dough",
    time: 25,
    serves: 8,
    fat: 0.8,
    saturated: 0,
    calories: 165,
    cholesterol: 0,
    carbohydrate: 34,
    protein: 6,
    sodium: 147,
    fiber: 1,
  },
  {
    title_english: "Light 'n' Low Pancakes",
    title: "الفطائر المحلاة الخفيفة والمنخفضة",
    description: "هذه الفطائر المحلاة المنخفضة الدسم لذيذة ومتنوعة، وتصلح جيدًا مع كل من الإضافات المالحة والحلوة.",
    ingredients: "125 جم (نصف كوب) دقيق بني أو دقيق قمح كامل عادي |بيضة واحدة |300 مل (8 أوقيات) لبن منزوع الدسم (إذا استخدمت دقيق القمح الكامل، فستحتاج إلى أكثر بقليل) |ملعقة صغيرة زيت خضراوات، وأكثر بقليل من أجل الطهي، أو استخدم بخاخ زيت وماء",
    method: "انخل الدقيق في وعاء. إذا استخدمت دقيق القمح الكامل، فأضف أيضًا النخالة التي في المنخل إلى الدقيق في الوعاء. |اضرب البيض واللبن والزيت معًا، ثم أضف الخليط ببطء إلى الدقيق. قلّب الخليط حتى تتكون عجينة سائلة متجانسة. |اتركها لمدة 20 دقيقة، ثم قلبها مجددًا. |سخن القليل من الزيت في مقلاة غير لاصقة، أو رشها بزيت الطهي. عندما يسخن الزيت، أضف ملعقتين كبيرتين من خليط الفطائر المحلاة وهُز المقلاة حتى ينفرد. |قم بطهي الفطائر المحلاة لمدة دقيقتين حتى يصبح الجانب السفلي بنيًا فاتحًا، ثم اقلبها أو أدرها وقم بطهيها على الجانب الآخر لدقيقة أو نحو ذلك. |أبقِ الفطائر المحلاة دافئة في الفرن بينما تطهي الباقي، ويمكنك تكديسها فوق بعضها البعض أثناء الطهي. ينبغي أن يصنع الخليط 8 فطائر محلاة إجمالًا. قدمها مع إضافات من اختيارك.",
    difficulty: "سهلة",
    category: "breakfast|family favorites|light snacks|quick and easy|vegetarian",
    hasImage: true,
    img: "light-and-low-pancakes",
    slug: "light-and-low-pancakes",
    time: 30,
    serves: 4,
    fat: 3.1,
    saturated: 0.6,
    calories: 162,
    sodium: 140
  },
  {
    title_english: "Creamy Porridge With Summer Berries",
    title: "عصيدة الكريمة بالتوت الصيفي",
    description: "ابدأ يومك بهذا الإفطار المغذي، واللذيذ. يعد الشوفان مصدرًا عظيمًا للألياف القابلة للذوبان في الماء ويساعد التوت في الوصول إلى هدف الخمس حصص اليومية الخاص بك. الفاكهة الطازجة والمجمدة والمعلبة والمجففة جميعها لها قيمتها.",
    ingredients: "600 مل (20 أوقية) ماء |125 جم (كوب) شوفان عصيدة |150 مل (5 أوقيات) لبن منزوع الدسم |مقدار قبضة من التوت الطازج أو المجمد والذائب أو المعلب أو المطبوخ مثل توت العليق أو الفراولة أو التوت الأسود أو التوت البري",
    method: "ضع الماء والشوفان في قدر واجعله يغل. اترك القدر على نار هادئة لمدة 10 - 20 دقيقة مع التقليب من وقت لآخر. |أضف اللبن منزوع الدسم، وقلبه واتركه على نار هادئة لدقيقتين إضافيتين. |قدمه مع التوت من اختيارك.",
    difficulty: "سهلة",
    category: "breakfast|family favorites|light snacks|quick and easy|vegetarian",
    hasImage: true,
    img: "creamy-porridge-with-summer-berries",
    slug: "creamy-porridge-with-summer-berries",
    time: 5,
    serves: 2,
    fat: 5.4,
    saturated: 0.9,
    sodium: 90,
    calories: 296,
  },
  {
    title_english: "Carrot and Coriander/Cilantro Soup",
    title: "حساء الجزر والكزبرة",
    description: "مثالي من أجل عشاء متأخر سريع أو كغداء خفيف لشخص واحد.",
    ingredients: "ملعقة كبيرة زيت عباد شمس أو زيت سلجم |فص ثوم مسحوق |حبة بصل مقطعة مكعبات |2 حبة متوسطة جزر، مبشور | 2 عود كرفس مقطع مكعبات |2 حبة طماطم مقطعة مكعبات |600 مل (20 أوقية) مرق خضراوات منخفض الملح |300 مل (10 أوقيات) عصير برتقال |3 ملاعق كبيرة كزبرة طازجة مقطعة |فلفل أسود مطحون طازج من أجل التتبيل",
    method: "سخن الزيت وأضف الثوم والبصل والجزر والكرفس والطماطم وقم بطهيها لبضع دقائق حتى تصبح طرية. |أضف المرق والتوابل واتركه على نار هادئة لمدة 20 - 25 دقيقة. |أضف الكزبرة وعصير البرتقال. |اضرب الحساء في الخلاط، وأعد التسخين، وأضف مقدار التوابل المطلوب. |يُقدم مع قطع الخبز من دقيق الحبوب الكامل",
    difficulty: "سهلة",
    category: "lunch|light snacks|vegetarian",
    hasImage: true,
    img: "carrot-and-coriander-soup",
    slug: "carrot-and-coriander-soup",
    time: 40,
    serves: 4,
    fat: 3.6,
    saturated: 0.3,
    calories: 109,
    sodium: 110,
  },
  {
    title_english: "Mediterranean Soup",
    title: "حساء البحر المتوسط",
    description: "لا يمكننا أن نكتفي من هذه الوصفة. وصفة ممتازة بالأخص من أجل استخدام بواقي الكوسة والفلفل. |أتمنى لكم وقتًا ممتعًا! توفر كل حصة على الأقل حصتين من هدف الخمس حصص اليومية الخاص بك.",
    ingredients: "حبة بصل، مقطعة جيدًا |فص ثوم مفروم |ملعقة كبيرة زيت زيتون |حبة فلفل حلو (أحمر أو أصفر)، مقطع قطع صغيرة | 2 حبة كوسة مقطعة قطع صغيرة |ملعقة صغيرة بابريكا |ملعقة صغيرة روزماري طازج مقطع |ملعقة صغيرة خل بلسمي |400 جم (14 أوقية) علبة طماطم مهروسة أو مقطعة |لتر (4 أكواب) مرق خضراوات معد من مكعبي مرق منخفض الملح |ملعقة كبيرة طماطم مهروسة |ورقة بقدونس إيطالي طازج (اختياري) |فلفل مطحون طازج",
    method: "سخن الزيت في مقلاة وقم بطهي البصل والثوم على نار هادئة لمدة 5 دقائق دون أن يكتسبا لونًا. |ضع جانبًا ملعقة كبيرة من الفلفل المقطع قطعًا صغيرة، ثم أضف باقي الفلفل مع الكوسة والبابريكا والروزماري إلى المقلاة وقم بطهيها لبضع دقائق. |أضف الخل البلسمي، وبعد دقيقتين، أضف الطماطم والمرق واجعله يغلي. |اتركه على نار هادئة حتى تنضج الخضراوات، حوالي 10 دقائق. |وأخيرًا، قلّب معها معجون الطماطم. إما أن تترك الوصفة كحساء متكتل ريفي أو استخدم مضربًا يدويًا لتضربه حتى يصبح متجانسًا. |تبله بالفلفل الأسود المطحون وقدمه مزينًا بالفلفل المقطع المتساوي وورقة البقدونس.",
    difficulty: "سهلة",
    category: "lunch|light snacks|vegetarian|soup",
    hasImage: true,
    img: "mediterranean-soup",
    slug: "mediterranean-soup",
    time: 35,
    serves: 4,
    fat: 4.1,
    saturated: 0.6,
    sodium: 220,
    calories: 122
  },
  {
    title_english: "Tasty Tuna Sandwiches",
    title: "شطائر التونة اللذيذة",
    description: "هذه الوجبة الأخف من \"التونة بالمايونيز\" الكلاسيكية وتكتسب شهرة من أجل وجبة غداء سريع.",
    ingredients: "علبة تونة محفوظة في الماء، مصفاة |2 ملعقة كبيرة زبادي يوناني قليل الدسم |ملعقة كبيرة كزبرة طازجة مقطعة|فلفل أسود مطحون |4 شرائح خبز من دقيق القمح الكامل أو 2 رغيف خبز | حبة خيار مقطع قطع صغيرة |فلفل حلو أحمر مقطع قطع صغيرة |مقدار قبضة من الخضراوات الورقية الطازجة |طبقة رقيقة من المايونيز قليل الدسم - حسب الحاجة",
    method: "امزج الزبادي مع الكزبرة، وتبلها بالفلفل الأسود. فتت التونة في المزيج وأضف الخيار والفلفل الأحمر المقطع. |افرد القليل من المايونيز قليل الدسم على قطعتي الخبز (ليساعد الحشوة على الالتصاق بالخبز) ثم قسم خليط التونة على الشريحتين. |أضف الخضراوات الورقية وباقي شرائح الخبز فوق خليط التونة وقدمه.",
    difficulty: "سهلة",
    category: "lunch|light snacks",
    hasImage: true,
    img: "tasty-tuna-sandwiches",
    slug: "tasty-tuna-sandwiches",
    time: 5,
    serves: 2,
    fat: 4.4,
    saturated: 0.7,
    sodium: 98,
    calories: 282
  },
  {
    title_english: "Mushroom and Lentil Soup",
    title: "حساء الفطر والعدس",
    description: "يمكنك استخدام أصناف من الفطر المخصوص في هذه الوصفة أو اختيار الأقل تكلفة وسيكون طعمه لذيذًا أيضًا. استخدمنا مرق خضراوات جيد الجودة ولكن يمكنك استخدام المرق المعد منزليًا الخاص بك أو حتى استبدال 250 مل من مرق الخضراوات بخل بني.",
    ingredients: "ملعقة كبيرة زيت زيتون |حبتا بصل صغيرتان مقطعتان لمكعبات كبيرة |عودان كرفس مقطعان لقطع كبيرة |حبة جزر مقطعة إلى مكعبات كبيرة |400 جم (4 أكواب) فطر، مقطع شرائح كبيرة |100 جم (كوب) عدس أخضر مطهي مسبقًا في ماء مغلي |لتر (4 أكواب) مرق خضراوات معد من 2 مكعب مرق خضراوات منخفض الصوديوم |1 ورقة غار |1 ملعقة كبيرة صلصة ورسيستر |فلفل أسود مطحون |اختياري عند التقديم - 4 ملاعق صغيرة جوز صنوبر محمص |اختياري عند التقديم - 4 ملاعق صغيرة زبادي صويا",
    method: "يُنقع البصل في زيت الزيتون بضع دقائق حتى ينضج مع الحرص على عدم احمراره. |يُضاف الكرفس والجزر مع استمرار التحريك والطهي لبضع دقائق على نار خفيفة |تُترك بضع شرائح من الفطر جانبًا للتزيين، ثم يُضاف ما تبقى من الفطر والعدس المطبوخ ومرق الخضار وصلصة وسترشير وورق الغار إلى المقلاة ويُترك على نار هادئة حتى ينضج جميع الخضار |يُزال ورق الغار ويُستخدم الخلاط اليدوي لهرس الحساء |يُتبل بالفلفل الأسود ويُقدم مزينًا بشرائح الفطر المحفوظة وبذور الصنوبر واللبن، عند التقديم.",
    difficulty: "سهلة",
    category: "lunch|light snacks|vegetarian|soup",
    hasImage: true,
    img: "mushroom-and-lentil-soup",
    slug: "mushroom-and-lentil-soup",
    time: 30,
    serves: 4,
    fat: 4.6,
    saturated: 0.7,
    sodium: 280,
    calories: 161
  },
  {
    title_english: "Red Super Soup",
    title: "الحساء الأحمر السوبر",
    description: "أتى هذا الحساء نتيجة لمحادثة عظيمة بين فريق خط المساعدة لدينا. ويتكون من أساس من الطماطم والعدس والبصل والثوم ولكن الشيء الرائع هو أنه يمكنك إضافة مكونات أخرى على حسب ما يناسبك. لقد استخدمنا جميع بواقي الخضراوات الحمراء في هذه الوجبة ونتج لون أحمر داكن رائع وطعم لذيذ جدًا أيضًا. يمكن تقديمه متكتلًا أو مهروسًا كحساء متجانس، حسبما تفضل!",
    ingredients: "ملعقة كبيرة زيت زيتون |2 حبة بصل أحمر صغيرة مقطعة إلى مكعبات كبيرة |2 فص ثوم مفروم |عود كرفس مقطع مكعبات كبيرة |حبة جزر مقطعة مكعبات كبيرة |250 جم (كوب) كرنب أحمر، مفتت جيدًا |50 جم (كوب) فلفل أحمر، مقطع مكعبات كبيرة |100 جم (كوب) عدس أحمر مطهي مسبقًا في ماء مغلي |2 علبة (28 أوقية) طماطم مقطعة مكعبات (مهروسة إذا لم تكن ستهرس الحساء في النهاية) |نصف لتر (2 كوب) مرق خضراوات معد من مكعب ونصف من مكعبات مرق منخفض الملح |ملعقة كبيرة خل بلسمي |فلفل أسود مطحون |بقدونس إيطالي، للزينة (اختياري)",
    method: "يُنقع البصل في زيت الزيتون بضع دقائق حتى ينضج مع الحرص على عدم احمراره. |يُضاف الكرفس والجزر مع استمرار التحريك والطهي لبضع دقائق على نار خفيفة |تُترك بضع شرائح من الفطر جانبًا للتزيين، ثم يُضاف ما تبقى من الفطر والعدس المطبوخ ومرق الخضار وصلصة وسترشير وورق الغار إلى المقلاة ويُترك على نار هادئة حتى ينضج جميع الخضار |يُزال ورق الغار ويُستخدم الخلاط اليدوي لهرس الحساء |يُتبل بالفلفل الأسود ويُقدم مزينًا بشرائح الفطر المحفوظة وبذور الصنوبر واللبن، عند التقديم.",
    difficulty: "سهلة",
    category: "lunch|light snacks|vegetarian|soup",
    hasImage: true,
    img: "red-super-soup",
    slug: "red-super-soup",
    time: 30,
    serves: 4,
    fat: 4.7,
    calories: 230,
    saturated: 0.6,
    sodium: 140
  },
  {
    title_english: "Mung Dhal with Spinach",
    title: "العدس الهندي مع السبانخ",
    description: "تمتزج المكونات البسيطة والصحية لإعداد وصفة العدس الهندي الرائعة. يُصنع دفعة واحدة، ثم تُجمد أي كمية متبقية.",
    ingredients: "150 جم (1 كوب) حبوب دال مونج (بقوليات/ حبوب مونج مشطورة أو مقشرة) |100 جم (1 كوب) بطاطس جديدة مقطعة إلى نصفين ومسلوقة حتى تصبح طرية |250 جم (2 كوب) سبانخ مغسولة ومقطعة قطعًا ناعمة |1 ملعقة كبيرة زيت بذور اللفت |1 ملعقة صغيرة زنجبيل طازج مقطع |1-2 حبة فلفل أخضر مفروم |نصف ملعقة صغيرة بذور كمون |نصف ملعقة صغيرة كركم |عصير نصف ثمرة ليمون",
    method: "يُغسل العدس عدة مرات مع تغيير الماء. |يُسخن الزيت في مقلاة ويُقلى الزنجبيل والفلفل الأخضر والكمون لمدة دقيقة. |يُضاف العدس والسبانخ ويُطهى لمدة 1 إلى 2 دقيقة أخرى. |يُضاف الكركم ولتر ونصف لتر ماء. |يُطهى مكشوفًا على نار هادئة، مع التقليب من وقت لآخر حتى يصبح نديًا. قد تحتاج إلى إضافة المزيد من الماء. يُضاف عصير الليمون الحامض والبطاطا المطبوخة ويُسخن حتى النضج. يُقدم مع الخبز البلدي أو الأرز.",
    difficulty: "متوسطة",
    category: "dinner|vegetarian",
    hasImage: true,
    img: "mung-dhal-with-spinach",
    slug: "mung-dhal-with-spinach",
    time: 60,
    serves: 6,
    fat: 2.7,
    calories: 95,
    saturated: 0.2,
    sodium: 160,
  },
  {
    title_english: "Fish Tikkas",
    title: "سمك تكا",
    description: "يُنقع السمك الأبيض في صلصة تكا ماسالا قليلة الدسم وتُقدم مع السلطة لتحضير هذا العشاء على الطريقة الهندية. يمكنك استخدام أي سمك أبيض مقدد من مصادر مستدامة في هذه الوصفة.",
    ingredients: "1 كجم (2.2 رطل) سمك فيليه مقدد (أو أي سمكة مقددة)، مقطعة إلى مكعبات |1 ملعقة كبيرة عصير ليمون |نصف كوب زبادي طبيعي قليل الدسم |1 ملعقة كبيرة خل |1 ملعقة كبيرة بهارات گرم مصالحه|2 ملعقة صغيرة بذور كمون مطحون |1 ملعقة صغيرة فلفل أحمر مسحوق |2 ملعقة صغيرة ثوم مفروم |زيت نباتي",
    method: "يُغسل العدس عدة مرات مع تغيير الماء. |يُسخن الزيت في مقلاة ويُقلى الزنجبيل والفلفل الأخضر والكمون لمدة دقيقة. |يُضاف العدس والسبانخ ويُطهى لمدة 1 إلى 2 دقيقة أخرى. |يُضاف الكركم ولتر ونصف لتر ماء. |يُطهى مكشوفًا على نار هادئة، مع التقليب من وقت لآخر حتى يصبح نديًا. قد تحتاج إلى إضافة المزيد من الماء. يُضاف عصير الليمون الحامض والبطاطا المطبوخة ويُسخن حتى النضج. يُقدم مع الخبز البلدي أو الأرز.",
    difficulty: "متوسطة",
    category: "dinner|fish",
    hasImage: true,
    img: "fish-tikkas",
    slug: "fish-tikkas",
    time: 25,
    serves: 6,
    fat: 3.1,
    calories: 165,
    saturated: 0.5,
    sodium: 610
  },
  {
    title_english: "Tandoori Chicken with Herb Yoghurt Sauce",
    title: "دجاج تندوري مع صلصة الزبادي بالأعشاب",
    description: "لا يحتوي الماء المملح التندوري الرائع هذا على دهون أو سكر مضاف ويمكن استخدامه للأسماك الكاملة أو لحم الضأن أو السمك الفيليه، فما عليك سوى ضبط وقت الطهي حسب الضرورة.",
    ingredients: "4 صدور دجاج مخلية منزوعة الجلد، حوالي 150 جم (1 كوب) لكل منهما |ماء |عدد قليل من أغصان العشبية، مثل إكليل الجبل أو الزعتر أو البقدونس |1 ملعقة كبيرة من الزنجبيل الطازج المبشور |2 ملعقة صغيرة من الكزبرة/ بذور الكزبرة المحمصة |2 ملعقة صغيرة من أوراق إكليل الجبل |1 ملعقة صغيرة من قشر الليمون المبشور |نصف ملعقة صغيرة من الهيل المطحون |نصف ملعقة صغيرة من الكمون المطحون |نصف ملعقة صغيرة من الفلفل الأسود المطحون |نصف ملعقة صغيرة من صلصة الفلفل الحار أو المطحون |325 جم (1 كوب) زبادي طبيعي قليل الدسم |2 ملعقة كبيرة من عصير الليمون |125 جم (1 كوب) خيار مبشور |1 ملعقة كبيرة شبت أو نعناع مفروم |فلفل أسود مطحون وطازج",
    method: "تُخلط جميع مكونات التتبيلة معًا في وعاء. |يُوضع الدجاج في طبق غير معدني. يُسكب المزيج فوق التتبيلة ويُفرك جيدًا في الدجاج. تُغطى وتُوضع في الثلاجة لمدة 2-4 ساعات |تُزال التتبيلة الزائدة من على الدجاج. يوضع الدجاج على رف سلك في صينية تحميص. يُصب الماء على عمق 2.5 سم (1 بوصة) وتُضاف الأغصان العشبية للحفاظ على رطوبة اللحم أثناء الطهي. |يُطهى الدجاج في فرن محمى على حرارة 240 درجة مئوية (475 درجة فهرنهايت)، على مقياس درجة الحرارة المستخدم في أفران الغاز وهو 9 درجات، لمدة 10 دقائق. تُقلب المكونات وتُطهى لمدة 10 دقائق إضافية حتى تنضج تمامًا |أثناء طهي الدجاج، تُخلط جميع مكونات صلصة الزبادي بالأعشاب في وعاء. تُغطّى وتُبرّد في الثلاجة لحوالي 20 دقيقة حتى تكتسب جميع النكهات. |يُقدّم الدجاج مع صلصة الزبادي بالأعشاب مع أرز بسمتي وسلطة خضراء.",
    difficulty: "متوسطة",
    category: "dinner|family favorites",
    hasImage: true,
    img: "tandoori-chicken-with-herb-yoghurt-sauce",
    slug: "tandoori-chicken-with-herb-yoghurt-sauce",
    time: 30,
    serves: 4,
    fat: 3,
    calories: 222,
    saturated: 1,
    sodium: 380
  },
  {
    title_english: "Fish Curry",
    title: "كاري السمك",
    description: "يُخفق طبق الكاري مع طبق السمك المتبل هذا ثم يُقدم مع الأرز أو الخبز البلدي والسلطة لوجبة عشاء صحية. يتم التأكد من استخدام السمك الأبيض من مصادر مستدامة.",
    ingredients: "450 جم/ 1 رطل سمك أبيض، سمك القد أو الحدوق، مخلي ومقطع إلى قطع |2 ملعقة كبيرتان من عصير الليمون |1 ملعقة كبيرة زيت بذور اللفت |2 بصلة صغيرة، مفرومتان |1 ملعقة صغيرة ثوم مفروم |1 ملعقة صغيرة زنجبيل مطحون |1 ملعقة صغيرة فلفل أخضر مفروم ناعم |200 مل (7 أوقيات) طماطم معلبة |نصف ملعقة صغيرة مسحوق كركم |1 ملعقة صغيرة ملح |1 ملعقة صغيرة توابل كرم مصالحة|2 ملعقة كبيرة كزبرة طازجة/ كزبرة للتزيين",
    method: "تُخلط جميع مكونات التتبيلة معًا في وعاء. |يُوضع الدجاج في طبق غير معدني. يُسكب المزيج فوق التتبيلة ويُفرك جيدًا في الدجاج. تُغطى وتُوضع في الثلاجة لمدة 2-4 ساعات |تُزال التتبيلة الزائدة من على الدجاج. يوضع الدجاج على رف سلك في صينية تحميص. يُصب الماء على عمق 2.5 سم (1 بوصة) وتُضاف الأغصان العشبية للحفاظ على رطوبة اللحم أثناء الطهي. |يُطهى الدجاج في فرن محمى على حرارة 240 درجة مئوية (475 درجة فهرنهايت)، على مقياس درجة الحرارة المستخدم في أفران الغاز وهو 9 درجات، لمدة 10 دقائق. تُقلب المكونات وتُطهى لمدة 10 دقائق إضافية حتى تنضج تمامًا |أثناء طهي الدجاج، تُخلط جميع مكونات صلصة الزبادي بالأعشاب في وعاء. تُغطّى وتُبرّد في الثلاجة لحوالي 20 دقيقة حتى تكتسب جميع النكهات. |يُقدّم الدجاج مع صلصة الزبادي بالأعشاب مع أرز بسمتي وسلطة خضراء.",
    difficulty: "متوسطة",
    category: "dinner|family favorites|fish|hearty meal",
    hasImage: true,
    img: "fish-curry",
    slug: "fish-curry",
    time: 30,
    serves: 4,
    fat: 4.4,
    calories: 147,
    saturated: 0.4,
    sodium: 1400,
  },
  {
    title_english: "Tuna Pasta Bake",
    title: "طاجن المعكرونة بالتونة",
    description: "يُصبح هذا العشاء المفضل لدى الأسرة، واللذيذ والمشبع جاهزًا في غضون 45 دقيقة ويُمثل وجبة مريحة ورائعة دون أي عناء.",
    ingredients: "400 جم (3 كوب) من المعكرونة المصنوعة من دقيق القمح الكامل/ الحبوب الكاملة (استخدمنا معكرونة فوزيلي) |2 × 160 جرامًا (6 أوقيات) من التونة المصفاة في الماء |100 جم (1 كوب) من السبانخ |1 علبة ذرة حلوة مصفاة |75 جم (نصف كوب) دقيق القمح الكامل/ بقسماط |1 x‏ 500 مل (16 أوقية) برطمان صلصة الطماطم |100 جم (نصف كوب) 10% دهن/ جبنة موتزاريلا قليلة الدسم، مبشورة أو مقطعة إلى قطع صغيرة |فلفل أسود",
    method: "يُسخن الفرن حتى 200 درجة مئوية (180 درجة مئوية لمروحة الفرن) |تُطبخ المعكرونة في مقلاة كبيرة (باتباع التعليمات على العبوة) حتى تنضج مع الاحتفاظ بتماسكها - معكرونة الدنت (معكرونة مطبوخة بدرجة كافية لدرجة أنها ليست مقرمشة ولا طرية جدًا، مع قوام لطيف قابل للمضغ). |تُضاف السبانخ إلى مقلاة المعكرونة في الدقيقة الأخيرة ووتُترك لتذبل. |تُصفى المعكرونة والسبانخ وتُنقل في طبق خبز كبير. |تُخلط التونة والذرة الحلوة وصلصة الطماطم وتُتبل بالفلفل الأسود. |تُوضع فوقها جبنة الموتزاريلا وآخر شيء البقسماط. |تُطهى في الفرن لمدة 30 دقيقة على الأقل أو حتى تغلي. |ثم تُقدّم.",
    difficulty: "متوسطة",
    category: "dinner|family favorites|fish|hearty meal",
    hasImage: true,
    img: "tuna-pasta-bake",
    slug: "tuna-pasta-bake",
    time: 45,
    serves: 6,
    fat: 5.3,
    calories: 397,
    saturated: 1.9,
    sodium: 150
  },
  {
    title_english: "Prawn and Vegetable Curry",
    title: "الروبيان بالخضار والكاري",
    description: "من يقول إنه لا يصعب طهي وجبة صحية في أقل من 30 دقيقة، فليجرب هذا الكاري اللذيذ لوجبة سريعة وسهلة في منتصف الأسبوع!",
    ingredients: "4 فصوص ثوم |1 بصلة |1 ملعقة كبيرة زيت زيتون |1 تفاحة مبشورة |2 ملعقتين كبيرتان مسحوق كاري |1 ملعقة صغيرة توابل كرم مصالحه |نصف ملعقة صغيرة كركم |400 جم (14 أوقية) علبة طماطم مقطعة |نصف ثمرة فلفل أحمر مفروم ناعم |2 ملعقة صغيرة من المحلي |110 جرام (1 كوب) حمص معلب مصفى ومشطوف |200 جرام (كوب ونصف كوب) روبيان مجمد |50 مل (1.7 أوقية) حليب الصويا |قليل من الكزبرة/ أوراق الكزبرة |265 جم (2 كوب) أرز بسمتي",
    method: "يُعاير الأرز البسمتي ويُصب، ثم يُغطى بالماء المغلي ويُترك ليُطهى حسب التعليمات الموجودة على العبوة. |يُطهى الثوم والبصل في زيت الزيتون على نار متوسطة حتى يصير لونه ذهبيًا. يُضاف مسحوق الكاري وكرم مصالحه والكركم ويتم طهيها لمدة دقيقة أخرى. يُضاف التفاح المبشور والطماطم المفرومة والفلفل الأحمر ويقلب الخليط ثم يضاف 200 مل من الماء ويقلب مرة أخرى. يُطهى على نار هادئة ويُترك لمدة دقيقتين. |يُضاف الحمص والروبيان المجمد ويتم الطهي حتى يلين ويُسخن طوال الوقت. بمجرد أن يسخن، تُضاف التحلية وحليب الصويا. |يُقدم الأرز والكاري في وعاء ويُزيّن بالكزبرة/ أوراق الكزبرة.",
    difficulty: "متوسطة",
    category: "dinner|family favorites|fish|hearty meal",
    hasImage: true,
    img: "prawn-and-vegetable-curry",
    slug: "prawn-and-vegetable-curry",
    time: 25,
    serves: 4,
    fat: 5.8,
    calories: 416,
    saturated: 0.9,
    sodium: 540,
  },
  {
    title_english: "Summer Pudding",
    title: "حلوى البودينغ الصيفية",
    description: "حلوى البودينغ الصيفية التقليدية هذه قليلة الدسم وتعتمد أكثر على جميع أنواع الفواكه الموسمية الرائعة. لكن ليس من الضروري أن تكون في الصيف فقط، فيمكنك استخدم الفاكهة المجمدة عندما ينتهي موسم التوت الصيفي.",
    ingredients: "300 جم (2 كوب ونصف) من الخبز الأبيض المقطع إلى شرائح متوسطة |875 جم (7 أكواب) فواكه صيفية ناضجة مختلطة مثل الكشمش الأحمر والكشمش الأبيض والكشمش الأسود وتوت العليق والفراولة والكرز تكون محضرة كل على حدة |75 جم (3 أوقيات) سكر ناعم |75 مل (3 أوقيات) ماء |فواكه وأوراق فواكه إضافية للتزيين",
    method: "تُقطّع قشور الخبز وتُستخدم لبطانة قاعدة وجوانب وعاء من البودنج سعة 1.2 لتر (نصفا لتر) ، مع رص قطع الخبز معًا وترتيبها. يُحتفظ بكمية كافية من الخبز للوجه العلوي |تُوضع الفاكهة، باستثناء التوت والفراولة، في قدر مع سكر وماء. تُسخن برفق حتى يأخذ العصير في الانسياب من الفاكهة ويذوب السكر. يُرفع عن النار وتُضاف إليه الفاكهة المتبقية. تُصفي الفاكهة بمنخل من النايلون، ويُحتفظ بالعصير. تُسكب الفاكهة بملعقة في القالب المبطن بنصف العصائر ويُغطى بالخبز المخصص للجزء العلوي. |يُضغط على الجزء العلوي بصحن ثقيل (تُغطى الكتلة بغطاء بلاستيكي لمنع تلوث البودنغ). يُوضع القالب في طبق مسطح لالتقاط أي سوائل تتسرب منه ثم يُوضع في الثلاجة طوال الليل. تُغطي العصائر المتبقية وتُوضع في الثلاجة منفصلة |للتقديم، تُنزع الكتلة ويُغرس سكين غير حاد الحواف حول البودينغ. يُقلب في طبق بحواف، ويُرج برفق ليخرج البودينغ. يُرفع القالب بحرص. إذا بدا الخبز مبقع وغير مكتمل، فيُدهن بالعصائر المحفوظة بالفرشاة. تُقدّم أي عصائر متبقية منفصلة. يُزيَّن البودينغ بالفاكهة وأوراقها. يُقدَّم مع الزبادي الطبيعي قليل الدسم أو الجُبن الكريمي.",
    difficulty: "متوسطة",
    category: "dessert|family favorites",
    hasImage: true,
    img: "summer-pudding",
    slug: "summer-pudding",
    time: 30,
    serves: 6,
    fat: 1.2,
    calories: 221,
    saturated: 0,
    sodium: 510
  },
  {
    title_english: "Italian Chicken Soup",
    title: "حساء الدجاج الإيطالي",
    description: "حساء لذيذ قليل الدسم لكنها شهية تحبها عائلتي. يصلح تقديمها مع الخبز الفرنسي المقرمش.",
    ingredients: "1 بصلة صغيرة مفرومة |1 فلفل أخضر، مقطع مكعبات |3 فصوص ثوم |1 ملعقة ريحان مجفف كبيرة|1/4 ملعقة صغيرة من فلفل أحمر مطحون (اختياري) |1 كوب جزر نيء مقطع |1 كوسة كبيرة/ كوسة مقطعة إلى مكعبات |1 علبة من الفاصوليا مصفاة |1 علبة طماطم مقطعة إلى مكعبات |3 علب مرق دجاج قليلة الصوديوم وخالية من الدهون |1 عبوة خفيفة أربع قطع جبن رافيولي |1 كوب ونصف كوب (190 جم) مكعبات صدر دجاج مطبوخة |جبن بارميزان قليل الدسم |رذاذ زيت طهي غير لاصق",
    method: "يُدهن إناء كبير برذاذ زيت الطهي غير اللاصق. |يُضاف البصل والفلفل الحلو والثوم والريحان والفلفل الأحمر ويُقلى على نار متوسطة حتى ينضج لمدة 10 دقائق تقريبًا. |يُضاف المرق. يُغطى القدر ويُترك على نار خفيفة لمدة 10 دقائق. |يُضاف الجزر والكوسة/ القرع. |يُغطى ويُترك على نار هادئة حتى ينضج الجزر تمامًا، حوالي 5 دقائق. |تُرفع النار إلى درجة حرارة عالية ويُترك الحساء حتى يغلي. يُضاف الرافيولي ويُغلى حتى يرق، لمدة 5 دقائق تقريبًا. |يُضاف الدجاج والفاصوليا والطماطم ويُطهى حتى يسخن، حوالي 1 دقيقة. |تُغرف الشوربة في سلطانيات ويُرش القليل من جبن البارميزان ولتستمتع بالطعم الشهي.",
    difficulty: "سهلة",
    category: "dinner|family favorites|hearty meal",
    hasImage: true,
    img: "italian-chicken-soup",
    slug: "italian-chicken-soup",
    serves: 6,
    fat: 6,
    calories: 303,
    cholesterol: 51,
    carbohydrate: 39,
    saturated: 3.7,
    sodium: 543
  },
  {
    title_english: "Italian Meatballs",
    title: "وصفة كرات اللحم المفروم الإيطالية",
    description: "أضف هذه الوصفة إلى قائمة العشاء الأسبوعية، ومن المؤكد أنها ستصبح المفضلة لعائلتك!",
    ingredients: "1 رطل (450 جم) لحم بقري مفروم قليل الدهن (95% على الأقل خالي من الدهون) |1/2 كوب (63 جم) بقسماط سادة |1/4 كوب (56 مل) حليب خالي من الدسم |2 من بياض البيض |1/4 كوب (40 جم) بصلة مفرومة |1 فص ثوم مفروم |1/2 ملعقة صغيرة زعتر |1/8 ملعقة صغيرة فلفل |4 أكواب (900 جم) من صلصة الطماطم التي تفضلها الخالية من الدهون",
    method: "يُسخن الفرن حتى 350 درجة فهرنهايت (176 درجة مئوية). |تُخلط جميع المكونات في وعاء كبير ما عدا صلصة الطماطم. |تُلف على شكل كرات صغيرة (حوالي 1.5 بوصة) وتُوضع على صاج الكعك المبطن بورق غير لاصق. 20-25 دقيقة أو حتى تصل درجة الحرارة الداخلية إلى 160 درجة فهرنهايت على الأقل؛ تُقلب كرات اللحم في منتصف وقت الطهي. |في قدر كبير، وتُضاف صلصة الطماطم إليها وتُترك على نار هادئة. |أضف كرات اللحم المفروم وتُترك على نار هادئة لمدة 15 إلى 20 دقيقة. |تُقدّم فوق المعكرونة المفضلة لديك. |تكفي لعمل 24 كرة من كرات اللحم.",
    difficulty: "سهلة",
    category: "dinner|family favorites",
    hasImage: true,
    img: "italian-dressing",
    slug: "italian-dressing",
    time: 10,
    serves: 4,
    fat: 0,
    calories: 19,
    cholesterol: 0,
    carbohydrate: 3,
    saturated: 0,
    sodium: 496,
    fiber: 0
  },
  {
    title_english: "Italian Style Spaghetti Squash Bake",
    title: "طاجن اسباجيتي سكواش (بالقرع) على الطريقة الإيطالية",
    description: "تغيير رائع في طريقة عمل المعكرونة!",
    ingredients: "1 قرع المعكرونة متوسط الحجم (حوالي 4 أكواب (500 جم) من القرع) | 1 ثمرة قرع/ معكرونة قرع، مبشورة | 16 أوقية (453 جم) من صلصة المكرونة قليلة الدسم (مثل صلصة Barilla بالريحان والثوم، أو أي نوع من الخضراوات أو الأعشاب الأخرى) |علبة 8 أوقيات (226 جم) من الفطر | 1/2 كوب (50 جم) 2% دهون (قليلة الدسم) جبنة موزاريلا مبشورة | جبنة بارميزان مبشورة حسب الرغبة (غير مدرجة في التحليل) | ملح وفلفل ومسحوق ثوم حسب الرغبة | توابل إيطالية حسب الرغبة",
    method: "سّخن الفرن مسبقًا عند درجة حرارة 350 درجة فهرنهايت (176 درجة مئوية) | ثم قطّع القرع من المنتصف بالطول وقم بإزالة البذور. |ضع ما يقرب من 1/2 بوصة من الماء في قاع طبق تحضير بسعة 12 بوصة × 8 بوصات، ثم ضع القرع (نصفا ثمرة القرع المقطعة لأسفل) في الطبق ووضعها بالميكروويف لمدة 12-15 دقيقة أو حتى يمكن ثقبها من خلال الشوكة، ثم قم بتركها لبضع دقائق لكي تبرد. | وفي نفس طبق التحضير (قم برش زيت طهي غير دهني) افرغ قرع المعكرونة باستخدام شوكة كبيرة في المقلاة ووزعها بالتساوي على الطبق بأكمله. أضف القرع/ الكوسة. |صف الفطر ووزعه بالتساوي فوق القرع. |أضف الملح (حسب الرغبة) والفلفل ومسحوق الثوم والتوابل الإيطالية فوق الخليط حسب الرغبة. |وزّع صلصة السباغيتي بالتساوي فوق خليط القرع. |وزّع جبنة الموزاريلا المقطعة بالتساوي فوقها، ثم رش جبن البارميزان. ضعه على النار لمدة 25 دقيقة، أو حتى تذوب الجبن ويغلي الطبق. |يُترك الطبق يبرد لبضع دقائق قبل التقديم.",
    difficulty: "سهلة",
    category: "dinner|family favorites|hearty meal",
    hasImage: true,
    img: "italian-style-spaghetti-squash-bake",
    slug: "italian-style-spaghetti-squash-bake",
    time: 50,
    serves: 6,
    fat: 2.2,
    calories: 103,
    cholesterol: 5,
    carbohydrate: 17,
    saturated: 1.0,
    sodium: 630,
    fiber: 3.5
  },
  {
    title_english: "Justin's Low Fat French Toast",
    title: "خبز توست جاستن الفرنسي قليل الدسم",
    description: "امنح نفسك وجبة إفطار أو غداء لذيذة في نهاية الأسبوع!",
    ingredients: "1/2 كوب بياض بيض (بيضتان كبيرتان) |1/2 كوب (113 مل) حليب خالي الدسم | شطيرتان من خبز الزبيب قليل الدسم |رشة زيت طهي خالٍ من الدسم |2 ملعقتين كبيرتين من شراب القيقب النقي | 1/2 ملعقة قرفة صغيرة |كريمة مخفوقة خالية من الدهون | 3 حبات فراولة بلا زوائد مقطعة إلى نصفين",
    method: "اخفق بياض البيض والحليب الخالي من الدسم مع القرفة في وعاء كبير بما يكفي لغمس الخبز. |سخن مقلاة غير لاصقة على نار متوسطة. |رش القليل من زيت الطهي على مساحة المقلاة. |اغمس خبز الزبيب في مزيج البيض. |أضف الخبز إلى المقلاة، واترك البيض يلتصق بالخبز إلى أن يصبح مقرمشًا قليلاً. |اقلب الخبز وكرر الأمر نفسه على الجانب الآخر. |ضعه على طبق التقديم وضع فوقه الشراب، والكريمة المخفوقة وقطع الفراولة المقطعة إلى نصفين.",
    difficulty: "سهلة",
    category: "breakfast|family favorites|quick and easy",
    hasImage: true,
    img: "justins-low-fat-french-toast",
    slug: "justins-low-fat-french-toast",
    time: 30,
    serves: 1,
    fat: 3.7,
    calories: 395,
    cholesterol: 6,
    carbohydrate: 72,
    saturated: 1.4,
    sodium: 516,
    fiber: 4
  },
  {
    title_english: "Lazy Lasagna",
    title: "ليزي لازانيا",
    description: "لا حاجة لطهي المعكرونة (النودلز)! هذا الطبق اللذيذ هو الخيار الأفضل لأي من عاشقي المعكرونة.",
    ingredients: "12 قطعة من مكرونة اللازانيا | 2 كوب (200 جم) من جبن موزاريلا مبشور خالي من الدسم | 1/4 كوب (25 جم) من جبن بارميزان المبشور قليل الدسم | 12 أوقية (340 جم) 99% من لحم الديك الرومي المفروم الخالي من الدهن| 2 علبة (1 رطل لكل منهما) صلصة طماطم| 2 علبة (1 رطل) طماطم مهروسة غير مملحة| 2 ملعقة كبيرة من معجون طماطم| 2 كوب (150 جم) من الفطر الطازج المقطع| 1 بصلة متوسطة مفرومة| 2 ملعقة صغيرة ثوم مفروم | 2 ونصف ملعقة صغيرة من التوابل الإيطالية المجففة| 15 أوقية (425 جم) من جبن الريكوتا الخالية من الدسم| 1 كوب (225 جم) جبن قريش أبيض قليل الدسم| 1/4 كوب (25 جم) من جبن البارميزان المبشور قليل الدسم| 2 ملعقة صغيرة بقدونس مجفف",
    method: "ضع لحم الديك الرومي المفروم في وعاء. ضع الوعاء على نار متوسطة مع التحريك حتى يتحول لون اللحم إلى اللون الوردي. صفي أي دهون.| ثم أضف باقي مكونات الصلصة إلى اللحم المحمر، وارفع النار إلى درجة عالية واتركه حتى يغلي. |اخفض درجة الحرارة إلى درجة منخفضة، ثم غط الوعاء واتركه على نار هادئة لمدة 25 دقيقة. ضعه جانبًا. |اخلط جميع مكونات الحشو في وعاء كبير وقلب جيدًا. ضعه جانبًا | رش طبقة من رذاذ زيت الطهي غير اللاصق على إناء 9×13. |ضع ملعقة ونصف كوب (200 مل) من الصلصة فوق أسفل المقلاة. ضع 4 قطع من المعكرونة غير المطبوخة بأسفل المقلاة، ثم رتب 3 قطع من المعكرونة بالطول و1 قطعة من المعكرونة بالعرض (ربما تحتاج إلى كسر هذه المعكرونة لجعلها مناسبة). |ضع نصف كمية خليط الحشو على المعكرونة، 3/4 كوب (75 جم) من جبن موزاريلا و 1.5 كوب (300 مل) من الصلصة. كرر وضع طبقات المعكرونة والحشو والموزاريلا والصلصة. |ضع الكمية المتبقية من المعكرونة والصلصة وجبنة البارميزان والموزاريلا. |غط المقلاة بورق الألمنيوم وضعها على النار على درجة 350 فهرنهايت (176 درجة مئوية) لمدة 45 دقيقة. |أزل ورق الألمنيوم واترك المقلاة حتى ينضج الطعام لمدة 15 دقيقة إضافية. اترك المقلاة لمدة 5 دقائق لكي تبرد، ثم قطع الوجبة وقدمها!",
    difficulty: "متوسطة",
    category: "dinner|family favorites|hearty meal",
    hasImage: true,
    img: "lazy-lasagna",
    slug: "lazy-lasagna",
    time: 90,
    serves: 10,
    fat: 2,
    calories: 277,
    cholesterol: 40,
    carbohydrate: 36,
    saturated: 0.8,
    sodium: 998,
    fiber: 4
  },
  {
    title_english: "Lemon drop cookies",
    title: "كعكات قطرات الليمون",
    description: "تتطلب هذه الكعكات 5 مكونات فقط وهي لينة وقابلة للمضغ. تكفي لإشباع شهيتك عندما ترغب في تناول طعام حلو.",
    ingredients: "1 عبوة من خليط كعكة الليمون |1/2 كوب (30 جم) كريمة باردة خالية من الدسم | مستخلص ليمون سبلاش| 1 بيضة مخفوقة| سكر حلوانى",
    method: "اخلط جميع المكونات ماعدا سكر الحلواني| سيصبح الخليط متفتتًا قليلًا وعليك خلطه جيدًا. |لف الخليط على شكل كرات مقاس 1 بوصة ثم لفها في وعاء من سكر الحلواني.| رش صينية الكعك برذاذ زيت الطهي. | ضعه في الفرن على درجة حرارة 350 فهرنهايت (176 درجة مئوية) لمدة 10-12 دقيقة. |يكفي لإعداد 32 قطعة بسكويت",
    difficulty: "سهلة",
    category: "light snacks|family favorites|dessert|quick and easy",
    hasImage: true,
    img: "lemon-drop-cookies",
    slug: "lemon-drop-cookies",
    time: 20,
    serves: 16,
    fat: 1,
    calories: 107,
    cholesterol: 13,
    carbohydrate: 23,
    saturated: 1,
    sodium: 205,
    fiber: 1
  },
  {
    title_english: "Low Fat Chicken Enchiladas",
    title: "انشيلادا الدجاج قليلة الدسم",
    description: "وجبة غداء أو عشاء ممتع وقليل الدسم!",
    ingredients: "1/2 كوب (115 جم) صلصة| 1/2 كوب (113 مل) مرق دجاج قليل الصوديوم وخالي من الدهون| 1 ملعقة صغيرة من الكمون المطحون| 3- 8 أوقيات (226 جم) من عبوة صلصة طماطم غير مضاف إليها الملح| 3 أكواب (375 جم) من مكعبات صدر الدجاج المطبوخ| 3 ملاعق كبيرة مخلل فلفل حار مفروم | 1- 15 أوقية (425 جم) من الفاصوليا السوداء المغسولة والمصفاة بدون ملح| 12- 6 بوصات من رقائق خبز الذرة| 1 ونصف أكواب (173 جرام) مزيج مكسيكي، جبن لايت مبشور| 3/4 كوب (184 جرام) كريمة حامضة خالية من الدسم/ زبادي يوناني خالي من الدسم| 1/2 كوب (75 جم) بصل أخضر مفروم/ بصل أخضر",
    method: "سخّن الفرن إلى درجة حرارة 350 درجة فهرنهايت (176 درجة مئوية).| امزج المكونات الأربعة الأولى، مع التقليب جيدًا. افرد 3/4 كوب من الخليط بأسفل طبق تحضير مقاس 13×9×2 بوصة.| امزج الدجاج وجبن الجالابينو والفاصوليا السوداء و1/2 كوب من خليط صلصة الطماطم في وعاء متوسط الحجم. يقلب المزيج جيدًا| ضع بالملعقة خليط الدجاج بشكل متساوٍ أسفل مراكز الرقائق. |لف الرقائق، وضعها جنبًا إلى جنب بالأسفل على خليط الصلصة في طبق التحضير.| ضع فوقها خليط الصلصة المتبقي والجبن.|غطّه وضعه على النار لمدة 25 دقيقة.| ضع فوقه الكريمة الحامضة/ الزبادي اليوناني وانثر فوقه البصل الأخضر.",
    difficulty: "سهلة",
    category: "dinner|family favorites",
    hasImage: true,
    img: "low-fat-chicken-enchiladas",
    slug: "low-fat-chicken-enchiladas",
    time: 40,
    serves: 6,
    fat: 8.8,
    calories: 439,
    cholesterol: 67,
    carbohydrate: 51,
    saturated: 3.0,
    sodium: 554,
    fiber: 11,
  },
  {
    title_english: "Low Fat Chili",
    title: "وجبة الفلفل الحار قليلة الدسم",
    description: "",
    ingredients: "3 فصوص ثوم مفروم| 1 عبوة صغيرة (5 أوقية (141 جم) من الفلفل الأخضر الحار مقطع إلى مكعبات| 1 بصلة متوسطة مفرومة| 1 ثمرة فلفل أخضر مفروم| 1 رطل (450 جم) 95% لحمًا بقريًا مفرومًا قليل الدسم | عبوة 2-15 أوقية (425 جم) من الفاصوليا الحمراء الداكنة | عبوة 15 أوقية (425 جم) طماطم مقطعة | 2 أوقية (56 جم) معجون طماطم| مسحوق الفلفل الحار والملح والفلفل حسب الرغبة| 1/2 ملعقة كبيرة كمون| 1/2 ملعقة طعام من الزعتر المجفف| 1/2 ملعقة كبيرة من مسحوق الفلفل الحار |1 ملعقة صغيرة زيت",
    method: "التحضير في مقلاة مقاس 12 بوصة، قم بقلي البصل والثوم والفلفل الأخضر في ملعقة صغيرة من الزيت حتى يصبح طريًا وبنيًا خفيفًا. ثم أضف اللحم إلى المقلاة وقم بتحميره. صف أي دهون زائدة. |أضف المكونات المتبقية واترك الإناء حتى الغليان. ثم خفف الحرارة واتركه على نار هادئة لمدة 40 دقيقة.",
    difficulty: "سهلة",
    category: "dinner|family favorites|hearty meal",
    hasImage: true,
    img: "low-fat-chili",
    slug: "low-fat-chili",
    time: 55,
    serves: 4,
    fat: 7.3,
    calories: 404,
    cholesterol: 70,
    carbohydrate: 52,
    saturated: 2.8,
    sodium: 720,
    fiber: 17
  },
  {
    title_english: "Low-Fat Green Bean Casserole",
    title: "طاجن الفول الأخضر قليل الدسم",
    description: "طبق لذيذ من المفضلات في العطلة التقليدية!",
    ingredients: "4 أكواب (600 جم) من الفاصوليا الخضراء المطبوخة المقطعة إلى شرائح 2/11 بوصة| 15 أوقية. عبوة (425 جرام) من حساء صحي بكريم الفطر المكثف من Campbell| 1/2 كوب (113 مللي) حليب خالي الدسم| 1 ملعقة بصل مفروم مجفف| فلفل أسود| 1 ملعقة زيت الكانولا| 1 بصلة حلوة متوسطة، مقطعة لشرائح رفيعة| 1/2 كوب (63 جم) من فتات خبز البانكو",
    method: "سخّن الفرن إلى درجة حرارة 350 فهرنهايت (176 درجة مئوية).| ضع الفاصوليا الخضراء في طبق طاجن سعة ربع جالون 11/ 2-2. |اخلط الحساء المكثف والحليب والبصل المفروم المجفف في وعاء، وُرش الفلفل الأسود. |صب المزيج فوق الفاصوليا الخضراء. |سخّن 1 ملعقة من زيت الكانولا في مقلاة غير لاصقة واطهو البصل حتى يصبح ذهبي اللون. |ضع المزيج فوق خليط الفاصوليا الخضراء بصورة متساوية. |رش فتات خبز البانكو فوق الإناء. |ضعه في الفرن لمدة 30 دقيقة أو حتى يصبح لونه بنيًا ذهبيًا.",
    difficulty: "متوسطة",
    category: "dinner|family favorites|hearty meal",
    hasImage: true,
    img: "low-fat-green-bean-casserole",
    slug: "low-fat-green-bean-casserole",
    time: 50,
    serves: 6,
    fat: 2,
    calories: 109,
    cholesterol: 4,
    carbohydrate: 18,
    saturated: 0.4,
    sodium: 281,
    fiber: 4
  },
  {
    title_english: "Low Fat Mac & Cheese",
    title: "وجبة المعكرونة بالجبن (ماك اند تشيز) قليلة الدسم",
    description: "",
    ingredients: "2 كوب (200 جم) معكرونة نودلز جافة| 2 ملعقتين كبيرتين من زبدة الكانولا الخفيفة| 1 ملعقة كبيرة من الدقيق| 1 كوب (280 مل) حليب بارد منزوع الدسم| 1 عبوة جبن شيدر أبيض Laughing Cow | 1/4 كوب (29 جم) جبن مبشور خالي من الدهون| ملح وفلفل حسب الرغبة",
    method: "سخّن الفرن إلى درجة حرارة 350 درجة فهرنهايت (176 درجة مئوية).| قم بطهي معكرونة النودلز وفقًا لتوجيهات العبوة وضعها جانبًا في طبق فرن آمن.| قم بإذابة الزبد في قدر صغير على نار متوسطة واخلطها مع الدقيق. يضاف الحليب ويقلب جيدًا. قم بطهي الصلصة على نار هادئة حتى تصبح ملساء وحتى الغليان. أضف 8 قطع من الجبن وحركها حتى تصبح ملساء. |أضف صلصة الجبن إلى الطبق الآمن بالفرن مع معكرونة النودلز المطبوخة واخلطهم جيدًا. |ضع الجبن فوق المزيج وضع الإناء في الفرن لمدة 20 دقيقة.",
    difficulty: "سهلة",
    category: "dinner|family favorites|quick and easy",
    hasImage: true,
    img: "low-fat-mac-and-cheese",
    slug: "low-fat-mac-and-cheese",
    time: 35,
    serves: 8,
    fat: 3.2,
    calories: 173,
    cholesterol: 8,
    carbohydrate: 25,
    saturated: 1.9,
    sodium: 280,
    fiber: 1
  },
  {
    title_english: "Jambalaya",
    title: "الجامبالايا",
    description: "رائع، سهل التحضير، عبارة عن كاجون تقليدي مُعد قليل الدسم!",
    ingredients: "1/2 رطل ( 225 جم)جمبري متوسط الحجم مقشر ومفروم ومُقطع| 1.5 ملعقة صغيرة من توابل المأكولات البحرية| رذاذ زيت طهي غير لاصق| 1 ملعقة صغيرة زيت زيتون أو زيت كانولا| 1 كوب (150 جم) بصل مفروم| 1/2 كوب (90 جم) فلفل أخضر مفروم| 1/2 كوب (115 جرام) كرفس مفروم| 2 ملعقتين كبيرتين من الثوم المفروم| 1 ثمرة طماطم مقطعة بدون ملح| 3 من ورق الغار| 1 ملعقة صغيرة صلصة وسترشير| 1 ملعقة صغيرة صلصة حارة (مثل صلصة توباسكو)| 3/4 كوب (190 جم) أرز أبيض| 2 كوب (475 مل) مرق دجاج قليل الصوديوم| 4 أوقيات (113 جم) شرائح سجق من لحم الديك الرومي المدخن| ملح وفلفل وصلصة حارة حسب الرغبة",
    method: "امزج الجمبري مع توابل الكريول في وعاء، واتقن عمل التتبيل جيدًا. |رش قدر ملعقة كبيرة من رذاذ زيت الطهي غير اللاصق لدهن قاع المقلاة. |أضف الزيت والبصل والفلفل والكرفس وسخن المقلاة على نار متوسطة مع التحريك بشكل متكرر لمدة 3 دقائق. |أضف الثوم والطماطم وأوراق الغار وصلصة وسترشير والصلصة الحارة. |قم بتقليب الأرز وإضافة مرق الدجاج ببطء. |خفف مستوى النار إلى متوسطة وقم بطهي الأرز حتى يمتص السائل ويصبح طريًا، مع التقليب من حين لآخر، حوالي 15 دقيقة. |أضف الجمبري والسجق عندما ينضج الأرز. |اتركه على النار حتى ينضج اللحم، مع التقليب من حين لآخر، حوالي 10 دقائق إضافية. |قم بالتتبيل بالملح والفلفل والصلصة الحارة حسب الرغبة.",
    difficulty: "متوسطة",
    category: "dinner|family favorites|hearty meal",
    hasImage: true,
    img: "low-fat-jambalaya",
    slug: "low-fat-jambalaya",
    time: 40,
    serves: 6,
    fat: 3.1,
    calories: 179,
    cholesterol: 71,
    carbohydrate: 25,
    saturated: 0.8,
    sodium: 633,
    fiber: 3
  },
  {
    title_english: "Mac and Cheese",
    title: "المعكرونة بالجبن",
    description: "سهل التحضير وطعام رائع ومتوفر. تقدم مع سلطة وكعك البراونيز قليل الدسم للتحلية.",
    ingredients: "15 أوقية (425 جم) معكرونة| 2 عبوة حساء بجبن شيدر قليلة الدسم| 8 أوقيات (226 جم) جبن شيدر مبشور قليل الدسم",
    method: "قم بطهي المعكرونة وفقًا لتوجيهات العبوة حتى تنضج. |صفها وضعها في طبق تحضير زجاجي 13 بوصة. | ثم اخلطها في شوربة جبنة الشيدر. |اخلط الجبن المبشور. |غطها بإحكام بورق الألمنيوم وقم بطهيها في الفرن في درجة حرارة 350 فهرنهايت (176 درجة مئوية) لمدة ساعة ونصف تقريبًا، أو حتى تظهر الفقاعات.",
    difficulty: "سهلة",
    category: "dinner|family favorites|hearty meal",
    hasImage: true,
    img: "mac-and-cheese",
    slug: "mac-and-cheese",
    time: 70,
    serves: 8,
    fat: 6,
    calories: 273,
    cholesterol: 6,
    carbohydrate: 40,
    saturated: 4,
    sodium: 515,
    fiber: 6
  },
  {
    title_english: "Marinated Grilled Shrimp",
    title: "الجمبري المُتبل المشوي",
    description: "سيكون هذا الجمبري اللذيذ الطبق الأبرز لك خلال حفلة الشواء المقبلة.",
    ingredients: "1 رطل ( 450 جم) (أو أكثر) جمبري مقشر منزوع العرق حجم كبير جدًا (عدد 26-30) | 3-4 فصوص ثوم مفروم |1/3 كوب (75 مل) صلصة صويا قليلة الصوديوم |1/4 كوب (85 جم) عسل | 3/4 كوب (169 مل) ماء |عصير ليمون سبلاش أو برتقال |فلفل حسب الرغبة",
    method: "امزج المكونات ثم اسكبها فوق الجمبري المقشر والمُقطع على أسياخ. في حالة استخدام أسياخ خشبية، تأكد من نقع تلك الأسياخ في الماء أولًا |انقع الجمبري في ماء مالح لمدة 1/2 ساعة ثم قم بشويه. |أتمنى لكم وقتًا ممتعًا!",
    difficulty: "سهلة",
    category: "dinner|family favorites",
    hasImage: true,
    img: "marinade-for-grilled-shrimp",
    slug: "marinade-for-grilled-shrimp",
    serves: 4,
    time: 50,
    fat: 1.8,
    calories: 154,
    cholesterol: 160,
    carbohydrate: 11,
    saturated: 0.3,
    sodium: 488,
    fiber: 0
  },
  {
    title_english: "Martha's Egg White Bites",
    title: "كرات بياض البيض من مارثا",
    description: "استمتع بوجبة فطور وغداء أو وجبة مطهوة مقدمًا لتناول إفطار سريع. يبقى مذاقها جيدًا إلى اليوم التالي ويمكن تجميدها أيضًا. يكمن الجزء الأفضل في أنك لن يغيب طعم صفار البيض عن هذا الطبق، لأن الخضراوات تمنحه الكثير من النكهة.",
    ingredients: "2 ونصف كوب (375 جم) من الخضار المفرومة بشكل ناعم (ربما تشتمل على البصل والفطر والفلفل الحلو والسبانخ والبطاطس المبشورة والقرنبيط والقرع الصيفي)| عبوة 16 أوقية (453 جم) (2 كوب) بديل البيض أو بياض البيض| 1/4 كوب (29 جرام) جبن مبشور قليل الدسم",
    method: "سخّن الفرن إلى درجة حرارة 350 درجة فهرنهايت (176 درجة مئوية). | ثم قم بقلي الخضار في مقلاة غير لاصقة مدهونة برذاذ زيت طهي غير لاصق. قم بالطهي حتى يصبح طريًا. أضف الملح والفلفل حسب الرغبة. |حضّر 12 قالب فطير مدهون برذاذ زيت طهي غير لاصق. املأ كل القوالب بكمية صغيرة من خليط الخضراوات، وقسّم الخليط بالتساوي بين 12 قالب. |اسكب بديل البيض فوق الخضراوات، وقسّمه بالتساوي بين 12 قالب. |انثر كمية صغيرة من الجبن فوق خليط الخضراوات/ بديل البيض، ثم ضعه في الفرن لمدة 20-25 دقيقة، أو حتى تنضج. أخرج الكرات من قوالب الفطائر وقدمها.| اقتراح التقديم (غير مشمول في التحليل الغذائي) ربما يكون في شطيرة بيض مع كعكة فطيرة إنجليزية أو خبز محمص. يمكن تقديمها مع الصلصة.",
    difficulty: "سهلة",
    category: "breakfast|vegetarian",
    hasImage: true,
    img: "marthas-egg-white-bites",
    slug: "marthas-egg-white-bites",
    serves: 6,
    time: 35,
    fat: 0.3,
    calories: 36,
    cholesterol: 1,
    carbohydrate: 3,
    saturated: 0,
    sodium: 110,
    fiber: 1
  },
  {
    title_english: "Mexican Picadillo",
    title: "البيكاديلو المكسيكي",
    description: "يمكن صنع هذا الطبق المكسيكي التقليدي بعدة طرق مختلفة. قم بتغيير نوع الخضار حسب رغبتك. هذا الطبق لذيذ للغالية وقليل الدهون!",
    ingredients: "1 رطل (450 جم) من اللحم المفروم 95% أو 5% أو الأقل دهونًا| 2 كوب (450 جم) بطاطس مقطعة (تطهى بشكل أسرع في حالة كونها أصغر وأرق)| 1 ونصف كوب (225 جم) خضراوات مختلطة مجمدة| 1/2 كوب (88 جم) مكعبات طماطم| 1/2 كوب (26 جم) بصل مكعبات | 1/2 كوب (90 جم) فلفل أخضر مفروم| 1/2 ملعقة صغيرة فلفل سيرانو مفروم (اختياري)| 1 فص ثوم مطحون| 1/2 ملعقة صغيرة مردقوش| 1/2 ملعقة كمون مطحون صغيرة| 1 ملعقة ملح صغيرة | 1 كوب (225 مل) من الماء",
    method: "يُحمّر اللحم المفروم في مقلاة كبيرة على نار متوسطة مع التقليب بين الحين والآخر. | بمجرد أن يصبح اللحم بنيًا، يضاف البصل والفلفل الأخضر وفلفل السيرانو والطماطم والثوم والمردقوش والكمون والملح. قم بالتقليب والطهي لمدة 5 دقائق. |أضف البطاطس والماء. يُترك على نار خفيفة لمدة 15 دقيقة، أو حتى تنضج البطاطس.",
    difficulty: "سهلة",
    category: "dinner",
    hasImage: true,
    img: "mexican-picadillo",
    slug: "mexican-picadillo",
    serves: 4,
    time: 40,
    fat: 6.1,
    calories: 281,
    cholesterol: 70,
    carbohydrate: 27,
    saturated: 2.7,
    sodium: 874,
    fiber: 5
  },
  {
    title_english: "Morning Shake",
    title: "مخفوق الحليب",
    description: "هذه الوجبة رائعة عندما تكون في عجلة من أمرك. من السهل أن تأخذها معك!",
    ingredients: "1 كوب (225 مل) حليب خالي من الدسم | 1/2 ثمرة موز متوسطة الحجم | 1/2 كوب (50 جم) توت أزرق |1 ملعقة صغيرة من مستخلص الفانيليا|1 عبوة من مُحلٍ صناعي |1 كوب (150 جم) ثلج",
    method: "ضع جميع المكونات في الخلاط واخلطها حتى تصبح ناعمة",
    difficulty: "سهلة",
    category: "breakfast|quick and easy",
    hasImage: true,
    img: "morning-shake",
    slug: "morning-shake",
    serves: 1,
    time: 5,
    fat: 0.6,
    calories: 193,
    cholesterol: 5,
    carbohydrate: 38,
    saturated: 0.2,
    sodium: 105,
    fiber: 3
  },
  {
    title_english: "No-Crust Apple Pie",
    title: "فطيرة التفاح بدون قشر",
    description: "",
    ingredients: "6-7 تفاحات (5 -6 أكواب) مقشرة منزوعة البذور ومقطعة إلى شرائح| 1 ملعقة كبيرة. سكر | 1 ملعقة قرفة| 1/3 كوب (75 جم) زبد نباتي مذاب| 3/4 كوب (169 جم) سكر | 1 كوب (140 جم) دقيق قمح كامل (أو أبيض) | 1/2 كوب أو 4 من بياض البيض",
    method: "ضع شرائح التفاح في طبق الفطائر. |اخلط السكر والقرفة في وعاء صغير. |انثر هذا الخليط على التفاح. |اخلط المكونات المتبقية في وعاء متوسط الحجم. |اسكب هذا المزيج السميك كثير الدسم على التفاح بالتساوي قدر الإمكان. |اخبز الفطيرة في الفرن في درجة حرارة 350 فهرنهايت (176 درجة مئوية) لمدة 1 ساعة أو حتى يصبح لونها بنيًا ذهبيًا.",
    difficulty: "سهلة",
    category: "dessert|family favorites",
    hasImage: true,
    img: "no-crust-apple-pie",
    slug: "no-crust-apple-pie",
    serves: 8,
    time: 75,
    fat: 4,
    calories: 208,
    cholesterol: 0,
    carbohydrate: 42,
    saturated: 1,
    sodium: 86,
    fiber: 3
  },
  {
    title_english: "Old Fashioned Potato Salad",
    title: "طبق سلطة البطاطس على الطراز القديم",
    description: "قم بإعداد بعض البدائل السهلة لجعل هذه الوجبة المفضلة منخفضة الدسم!",
    ingredients: "4 حبات بطاطس خمرية متوسطة الحجم| وعاء 48 أوقية (1.4 لتر) من مرق الدجاج قليل الدسم ومنخفض الصوديوم| 1/4 كوب (60 جم) نكهة المخلل الحلو| 1/4 كوب (40 جم) بصل مقطع| 1/2 كوب (115 جم) كرفس مقطع| 1/2 ملعقة صغيرة ملح| 1/2 ملعقة صغيرة فلفل| 4 بيض| 1 ملعقة كبيرة خردل| 1/4 كوب (58 جم) مايونيز قليل الدسم من Hellmanns",
    method: "اغسل البطاطس واترك القشر عليها. نضيف مرق الدجاج والبطاطس في قدر كبير (أضف الماء إذا لم تكن البطاطس مغطاة به بالكامل حتى يتم ذلك) واتركها حتى الغليان. |اخفض الحرارة إلى متوسطة وقم بتغطية القدر. يُطهى الخليط حتى تنضج البطاطس، لمدة 30 دقيقة تقريبًا. |بمجرد الانتهاء من ذلك، صف السائل وقشر البطاطس خلال وجودها تحت الماء الجاري البارد. |ضع البيض في قدر وغطه بالماء البارد خلال طهي البطاطس. اترك الماء ليغلي، قم بتغليفها وحفظها بعيدًا عن الحرارة. اترك البيض في الماء الساخن لمدة 12-14 دقيقة. |ارفع البيض من الماء ثم برده وقشّره. قم بإزالة صفار البيض وقطّع بياض البيض.| بمجرد أن تنضج البطاطس، ضعها في وعاء كبير واهرس البطاطس بالشوكة مع ترك بعض القطع الصغيرة. |أضف النكهة والبصل والكرفس وبياض البيض والملح والفلفل والخردل والمايونيز. |اخلط المزيج جيدًا وضعه في الثلاجة حتى يبرد.",
    difficulty: "سهلة",
    category: "lunch|family favorites",
    hasImage: true,
    img: "old-fashioned-potato-salad",
    slug: "old-fashioned-potato-salad",
    serves: 6,
    time: 50,
    fat: 1,
    calories: 136,
    cholesterol: 0,
    carbohydrate: 28,
    saturated: 0,
    sodium: 439,
    fiber: 2
  },
  {
    title_english: "Orange Cake",
    title: "الكيك بالبرتقال",
    description: "تُعد الكعكة اللذيذة ندية للغاية ومذاقها رائع ومبردة بشكل طفيف.",
    ingredients: "1 عبوة خليط كعكة البرتقال| 1 عبوة خوخ فطير حشو | 1/2 كوب بيض (أو 4 بياض بيض)| 1/2 كوب (123 جم) كريمة حامضة خالية من الدسم/ زبادي يوناني خالي من الدسم| 8 أوقيات (226 جرام) جبن بالقشدة خالٍ من الدسم| 1 علبة صغيرة خالية من الدهون، بودنغ الفانيليا الخالي من السكر|20 أوقية (566 جم) عبوة أناناس مطحونة (غير مصفاة)| 8 أوقيات (226 جم) كريمة باردة خالية من الدهون",
    method: "سخّن الفرن عند درجة حرارة تصل إلى 350 درجة فهرنهايت (176 درجة مئوية). |اخلط مكونات الكعك جيدًا وصب الخليط في قالب الكعك مع رش رذاذ زيت الطهي. |يمكنك استخدام مقلاة أنبوبية أو مقلاة بسعة 13 بوصة| اخبزها في الفرن لمدة 40 إلى 45 دقيقة أو حتى يخرج عود الأسنان نظيفًا.| اتركها لتبرد تمامًا. | امزج المكونات المتجمدة الثلاثة جيدًا ثم قم بطيها في كريمة باردة (كول ويب) خالية من الدسم. |كعكة فروست مبردة.",
    difficulty: "سهلة",
    category: "dessert|family favorites",
    hasImage: true,
    img: "orange-cake",
    slug: "orange-cake",
    serves: 12,
    time: 60,
    fat: 4,
    calories: 326,
    cholesterol: 3,
    carbohydrate: 65,
    saturated: 1,
    sodium: 534
  },
  {
    title_english: "Pulled Chicken in a Crock Pot",
    title: "طاجن دجاج مسحوب فخاري",
    description: "لن يصدق أي شخص إذا أخبر بمدى سهولة هذه الوصفة.",
    ingredients: "4-6 صدور دجاج منزوعة العظم والجلد| 8-12 أوقية (226-340 جم) من صلصة الباربيكيو المفضلة لديك",
    method: "في طاجن من الفخار معد برذاذ زيت طهي غير لاصق، ضع الدجاج مع الصلصة وغطه. |قم بطهيِ على نار خفيفة لمدة 6 ساعات، أو على نار عالية لمدة 3 ساعات. |قبل تقديم الطاجن، اسحب صدور الدجاج عن بعضها باستخدام شوكة لتحضير وجبة دجاج سهلة التناول. |مقترحات تقديم الطبق *: يُقدم مع طبق جانبي وسلطة، أو على رغيف خبز قمح كامل مع السلطة. | * لا تُدرج الإضافات الاختيارية ضمن تحليل التغذية",
    difficulty: "سهلة",
    category: "dinner|family favorites",
    hasImage: true,
    img: "pulled-chicken-in-a-crock-pot",
    slug: "pulled-chicken-in-a-crock-pot",
    serves: 4,
    fat: 1.5,
    calories: 251,
    cholesterol: 68,
    carbohydrate: 32,
    saturated: 0.4,
    sodium: 757
  },
  {
    title_english: "Ratatouille",
    title: "طاجن الراتاتوي بالصلصة",
    description: "في أوائل الخريف، يتوفر لدينا الكثير من الخضراوات الرائعة المتاحة. حقق استفادة منها بشكل لذيذ بطهي هذا الطبق النباتي. يمكن تقديم هذه الوصفة كطبق إضافي، أو فوق المعكرونة المفضلة لديك أو الأرز البني كوجبة.",
    ingredients: "1 بصلة كبيرة مفرومة | 2 فص ثوم مفروم | 1/2 ملعقة كبيرة زيت زيتون| 1 فلفل أحمر مفروم| 1 فلفل أخضر مفروم| 1 باذنجان كبير/ باذنجان مقشر ومكعب | 3 طماطم متوسطة مفرومة| 2 ثمرة كوسة متوسطة/ كوسة مقطعة",
    method: "قم بقلي البصل والثوم في زيت الزيتون في قدر كبير لمدة 2 - 3 دقائق. |أضف الفلفل وقم بقليه لمدة 2 دقيقة أخرى. |أضف بقية المكونات وغط الإناء. يُترك على نار خفيفة لمدة 45 دقيقة - 1 ساعة أو حتى تنضج الخضراوات.",
    difficulty: "سهلة",
    category: "dinner|hearty meal",
    hasImage: true,
    img: "ratatouille",
    slug: "ratatouille",
    serves: 6,
    time: 80,
    fat: 1.8,
    calories: 88,
    cholesterol: 0,
    carbohydrate: 17,
    saturated: 0.3,
    sodium: 14,
    fiber: 6
  },
  {
    title_english: "Scalloped Potatoes",
    title: "اسكالوب البطاطس",
    description: "طاجن غني بالقشدة والجبن يمكنك إحضاره إلى أي مناسبة! يُعد هذا الطبق مبهجًا لأي جمع ومفعمًا بالنكهة، ولن يعرف أحد أنه قليل الدسم!",
    ingredients: "1/2 كوب (70 جم) دقيق غير مبيض| 4 ملاعق صغيرة من البقدونس المجفف |1/4 ملعقة صغيرة من الفلفل الأسود المطحون | 2 ونصف رطل (8 أوقيات) من البطاطس المخبوزة (حوالي 4 وسط) | 2 بصلة صغيرة مقطعة إلى شرائح رقيقة ومقسمة إلى حلقات | 1 فص ثوم | 1/2 كوب (50 جم) جبن بارميزان مبشور | 1 كوب (340 مل) حليب خالي الدسم",
    method: "يُمزج الدقيق والبقدونس والفلفل في وعاء صغير. اخلطها معًا واتركها جانبًا. | افرك البطاطس قبل تقطيعها إلى شرائح رفيعة (أقل من 1/4 بوصة). | رش رذاذ زيت الطهي غير اللاصق على قاع وجوانب صينية التحضير مقاس 8 × 12 بوصة. | ضع طبقة من شرائح البطاطس في قاع المقلاة مع جعل الشرائح متداخلة قليلًا. ثم أضف طبقة من حلقات البصل فوق البطاطس (نصف حلقات البصل المقطعة) مع 1/2 من فص الثوم المرشوش فوقها. رش هذه الطبقة بنصف خليط الطحين. ثم انثر ملعقتين كبيرتين من جبنة البارميزان بالتساوي. كرر هذه الخطوة لإضافة طبقة أخرى من البطاطس والبصل والثوم والدقيق والجبن.| اسكب الحليب فوق البطاطس ورش ما تبقى من جبن البارميزان.| قم بتغطية الطبق بورق الألمنيوم وضعه في الفرن على درجة 350 فهرنهايت (176 درجة مئوية) لمدة 45 دقيقة. أزل ورق القصدير وضعه في الفرن لمدة 30 دقيقة إضافية أو حتى تنضج البطاطس ويصبح الجزء العلوي ذهبي اللون. اتركه لمدة 5 دقائق قبل التقديم.",
    difficulty: "سهلة",
    category: "dinner|vegetarian|family favorites",
    hasImage: true,
    img: "scalloped-potatoes",
    slug: "scalloped-potatoes",
    serves: 10,
    time: 60,
    fat: 1.3,
    calories: 191,
    cholesterol: 4,
    carbohydrate: 27,
    saturated: 0.8,
    sodium: 105,
    protein: 6
  },
  {
    title_english: "Shrimp Casserole",
    title: "طاجن الجمبري",
    description: "هذا الطبق من الأطباق السهلة والخالية من الدهون تقريبًا من مفضلات الكاجون. ضع التتبيل حسب رغبتك.",
    ingredients: "1 كوب (150 جم) بصل مفروم | 1 كوب (225 جم) كرفس مفروم | 1 كوب (175 جم) فلفل أخضر مفروم| 1 ملعقة صغيرة من مسحوق الثوم| 3 ملاعق كبيرة من معجون الطماطم| 1 عبوة قشدة قليلة الدسم من حساء الدجاج 1 كيس (12 أوقية) جمبري مطبوخ مثلج متوسط الحجم| 1 ملعقة صغيرة من توابل الكاجون | 1/2 ملعقة صغيرة من صلصة الفلفل الحار",
    method: "رش زذاذ زيت الطهي غير اللاصق في طبق آمن للميكروويف سعة 2 لتر | أضف البصل والكرفس والفلفل الأخضر والثوم. |رش الجزء العلوي من الخضار برذاذ زيت الطهي غير اللاصق. | سخن الطاجن في الميكروويف لمدة 8 دقائق.| اخرج الطاجن وقلّبه ثم أضف معجون الطماطم وعلبة الحساء والجمبري وتوابل الكاجون وصلصة الفلفل الحار.| ضع كل هذا في الميكروويف واطهه لمدة 5 دقائق أخرى حتى يتكاثف الخليط | اختياري: يُقدم فوق أرز أبيض أو بني خالٍ من الدهون تقريبًا لكل 1/21 كوب (115225 جم) مطبوخ.",
    difficulty: "سهلة",
    category: "dinner|quick and easy",
    hasImage: true,
    img: "shrimp-casserole",
    slug: "shrimp-casserole",
    serves: 4,
    time: 25,
    fat: 2.5,
    calories: 150,
    cholesterol: 118,
    carbohydrate: 14,
    saturated: 1,
    sodium: 567,
    protein: 18
  },
  {
    title_english: "Spicy Chicken with Sesame Noodles",
    title: "دجاج حار مع معكرونة نودلز بالسمسم",
    description: "طبق سريع وسهل مشبع ولذيذ جدًا. يُفضل تقديمه في درجة حرارة الغرفة أو حتى باردًا كطبق إضافي.",
    ingredients: "1 1/2 رطل (675 جم) صدر دجاج مخلي منزوع الجلد | 12 أوقية (340 جم) معكرونة نودلز لينجويني| 2 حبة فلفل ملون (أحمر أو أصفر أو برتقالي) مقطعة إلى شرائح رفيعة | 2 كوب (350 جم) من رؤوس البروكلي المقطعة| 4 حبات بصل أخضر/ بصل الربيع مقطع أعواد إلى قطع 1/2 بوصة مكعبات خضراء| 1-2 ملعقة كبيرة من خلطة توابل الكاجون| 1 ملعقة كبيرة مسحوق بصل| 1 ملعقة كبيرة من مسحوق الثوم | 1-2 ملعقة ملح صغيرة| 1 ملعقة فلفل أسود كبيرة| 1/2 كوب (115 جرام) صلصة الفلفل الحار الحلو | 2 ملعقة كبيرة من زيت السمسم| رذاذ زيت الطهي",
    method: "يُسخن الماء للمعكرونة، وتُطهى حسب التوجيهات، ثم تُصفى وتُقلب بزيت السمسم بينما تكون معكرونة النودلز ساخنة. اتركها تبرد أثناء طهي الدجاج. |قطّع الدجاج إلى مكعبات. |أضف بهارات الكاجون والبصل ومسحوق الثوم والملح والفلفل إلى كيس بلاستيكي بسحاب علوي. |أضف الدجاج إلى الكيس ورجه جيدًا حتى يُدهن. |رش مقلاة كبيرة برذاذ المقلاة وضعها على نار متوسطة وقم بطهي الدجاج حتى ينضج. |أخرجه من المقلاة ورش المقلاة برذاذ الزيت مرة أخرى. |يُضاف الفلفل ويُقلى لمدة 5 دقائق، ثم يُضاف البروكلي والبصل الأخضر/ أعواد البصل الأخضر. قم بقلي الخليط حتى ينضج البروكلي. |قلًب الخضراوات والدجاج مع النودلز واخلطها جيدًا. |أضف صلصة الفلفل الحار الحلو والبصل الأخضر/ قطع البصل الأخضر، وقلّب مرة أخرى. الطعام جاهز للتقديم",
    difficulty: "سهلة",
    category: "dinner|family favorites|quick and easy",
    hasImage: true,
    img: "spicy-chicken-with-sesame-noodles",
    slug: "spicy-chicken-with-sesame-noodles",
    serves: 6,
    time: 40,
    fat: 9.3,
    calories: 467,
    cholesterol: 83,
    carbohydrate: 57,
    saturated: 1.3,
    sodium: 654,
    protein: 34,
    fiber: 9,
  },
  {
    title_english: "Spinach Cheese Bake",
    title: "خبز السبانخ مع الجبن",
    description: "سهلة التحضير. دائما من المفضلات. تقدم كوجبة عشاء أو غداء أو وجبة فطور وغداء مع فواكه طازجة وسلطة.",
    ingredients: "10-12 أوقية (283-340 جم) كجم سبانخ مقطع مجمّد يُذوّب ويُصفّى جيدًا| 4 بياض بيض | 16 أوقية (450 جم) جبن أبيض خالٍ من الدسم | 16 أوقية (450 جم) 2% جبنة شيدر قليلة الدسم، أو جبنة موزاريلا مبشورة| 3 ملاعق دقيق كبيرة| 1/4 ملعقة صغيرة من مسحوق الثوم| فلفل أسود حسب الرغبة",
    method: "سخّن الفرن عند درجة حرارة تصل إلى 350 درجة فهرنهايت (176 درجة مئوية). |تخلط جميع المكونات معًا وتوضع في صينية خبز مقاس 8 بوصات معدة برذاذ زيت طهي غير لاصق. |توضع في الفرن لمدة 35 - 45 دقيقة (أو حتى تغرز سكين ويخرج نظيفًا). |اترك الطبق ليبرد لمدة 10 دقائق.",
    difficulty: "سهلة",
    category: "dinner|lunch|family favorites",
    hasImage: true,
    img: "spinach-cheese-bake",
    slug: "spinach-cheese-bake",
    serves: 4,
    time: 55,
    fat: 7.5,
    calories: 240,
    cholesterol: 10,
    carbohydrate: 14,
    saturated: 4.5,
    sodium: 790,
    protein: 29
  },
  {
    title_english: "Strawberry Spinach Salad",
    title: "سلطة السبانخ بالفراولة",
    description: "سلطة خفيفة ولذيذة، إضافة مثالية لأي وجبة!",
    ingredients: "3 أكواب (675 جم) معبأة من السبانخ الطازجة| 2 كوب (400 جم) من الفراولة الطازجة، مقطعة إلى شرائح| 3 ملاعق كبيرة من جبنة البارميزان المبشورة | 1/2 كوب (113 مل) خل بلسمي | 1/4 كوب (88 جم) من العسل | رشة ملح وفلفل",
    method: "اخلط السبانخ والفراولة والجبن وقلّبه.| اخلط مكونات الصلصة في وعاء متوسط الحجم ثم أضفها إلى السلطة وقم بالتقليب.",
    difficulty: "سهلة",
    category: "lunch|quick and easy|vegetarian",
    hasImage: true,
    img: "strawberry-spinach-salad",
    slug: "strawberry-spinach-salad",
    serves: 3,
    time: 10,
    fat: 1.7,
    calories: 178,
    cholesterol: 4,
    carbohydrate: 39,
    sodium: 113,
    protein: 3,
    fiber: 2
  },
  {
    title_english: "Stuffed Peppers",
    title: "فلفل محشي",
    description: "",
    ingredients: "4 حبات فلفل أخضر كبير| 1/2 رطل (225 جم) 96% لحم بقري مفروم قليل الدهن| 1/4 كوب (40 جم) بصل مفروم| 1/2 ملعقة صغيرة من مسحوق الفلفل الحار | 1/4 ملعقة صغيرة فلفل حريف (اختياري)| 1 فص ثوم مفروم| 1/4 ملعقة صغيرة فلفل | 1/2 ملعقة صغيرة ملح| 1/2 ملعقة كبيرة صلصة وسترشير| ونص كوب (375 جم) أرز بني مطبوخ| 1/2 كوب (50 جم) جبنة شيدر مبشورة غير دهنية مقسمة| 8 أوقيات (226 جم) علبة صلصة طماطم",
    method: "سخّن الفرن على درجة حرارة 350 فهرنهايت (176 درجة مئوية)| ضع اللحم في مقلاة كبيرة وقم بطهيه على نار متوسطة مع التقليب حتى يتفتت، حتى يتلاشى اللون الوردي. يُضاف البصل ومسحوق الفلفل الحار والثوم والفلفل والملح وصلصة وسترشير واستمر في الطهي حتى ينضج البصل. |أرفع المقلاة عن النار وقلب الأرز وصلصة الطماطم و1/4 كوب (25 جم) من الجبن| تقطع الأجزاء العلوية من الفلفل وقم بإزالة الأغشية والبذور. املأ الفلفل بخليط اللحم. |ضع الفلفل في طاجن. قم بتغطية بورق الألمنيوم وضعه في الفرن في درجة حرارة 350 فهرنهايت (176 درجة مئوية) لمدة 55 دقيقة ثم أخرج الفلفل ورش باقي جبن الشيدر بالتساوي على كل حبة فلفل. يُعاد الطبق إلى الفرن ويُطهى لمدة 5 دقائق إضافية بدون ورق الألومنيوم. يُقدم ساخنًا.",
    difficulty: "سهلة",
    category: "lunch|vegetarian",
    hasImage: true,
    img: "stuffed-peppers",
    slug: "stuffed-peppers",
    serves: 4,
    fat: 3.4,
    calories: 233,
    cholesterol: 31,
    carbohydrate: 34,
    sodium: 766,
    protein: 18,
    fiber: 4
  },
  {
    title_english: "Super-Easy Chili",
    title: "طبق الفلفل الحار السهل السوبر",
    description: "وجبة تبعث الدفء في الليلة الباردة.",
    ingredients: "1 رطل(450 جم) ديك رومي مفروم قليل الدهن أو لحم بقري مفروم (95% على الأقل خالٍ من الدهون)| عبوة 14 أوقية (396 جم) من الطماطم المقطعة| عبوة 6 أوقية (170 جم) من معجون طماطم| عبوة 15 أوقية (425 جم) من فاصوليا بنتو أو الفاصوليا الشائعة مغسولة ومصفاة| 1 بصلة مفرومة| 1-2 ملعقة كبيرة من مسحوق الفلفل الحار | 1/2 ملعقة صغيرة من مسحوق الثوم",
    method: "قم بتحمير لحم الديك الرومي والبصل في مقلاة كبيرة غير لاصقة. |أضف بقية المكونات و 3/4 كوب (169 مل) من الماء، ثم اتركها على نار هادئة.",
    difficulty: "سهلة",
    category: "dinner|hearty meal|family favorites",
    hasImage: true,
    img: "super-easy-chili",
    slug: "super-easy-chili",
    serves: 4,
    fat: 6,
    calories: 358,
    cholesterol: 80,
    carbohydrate: 45,
    sodium: 468,
    protein: 31
  },
  {
    title_english: "Tuna Pasta Un-Casserole",
    title: "طاجن المكرونة بالتونة",
    description: "هذا تحسين قليل الدسم لطاجن المعكرونة التونة. يمكنك إعداد هذا الطبق من الأطعمة الموجودة في مطبخك.",
    ingredients: "عبوة 12 أوقية (340 جم) من تونة في الماء | عبوة 10 أوقية (283 جرام) من حساء كريمة الفطر | 1/2 كوب (113 مل) حليب خالي الدسم | 1/2 كوب (75 جم) بازلاء مجمدة | 8 أوقيات (226 جم) فطر مقطّع إلى شرائح| برطمان صغير من الفلفل الحلو | 1/2 ملعقة صغيرة من مسحوق الثوم | فلفل أبيض أو أسود حسب الرغبة | رذاذ زبدة خالية من الدهون | 3 ملاعق كبيرة. إحضار جبنة البارميزان كصلصلة علوية (حسب الرغبة) | 4 أكواب (800 جم) من المعكرونة المطبوخة من اختيارك",
    method: "يُمزج الفطر والحساء والحليب مزجًا جيدًا في وعاء آمن للاستخدام في الميكروويف. أضف التونة والبازلاء والفلفل الحلو والبهارات| رش رذاذ الزبدة حوالي 15 مرة، إذا رغبت في ذلك، وقلّب جيدًا. |سخّن لمدة 4 دقائق | يقدّم أكثر من 1 كوب من المعكرونة المطبوخة. | ضع 2 ملعقتين صغيرتين على كل جزء من جبنة بارميزان حسب الرغبة.",
    difficulty: "سهلة",
    category: "dinner|family favorites|quick and easy",
    hasImage: true,
    img: "tuna-pasta-un-casserole",
    slug: "tuna-pasta-un-casserole",
    serves: 4,
    time: 25,
    fat: 3,
    calories: 331,
    cholesterol: 35,
    carbohydrate: 48,
    saturated: 0.5,
    sodium: 510,
    protein: 28
  },
  {
    title_english: "Vegetable Cream Cheese Roll-ups",
    title: "لفائف الجبن الكريمي بالخضروات",
    description: "قم بإعداد مجموعة من هذه اللفائف من أجل كسر الوتيرة بشكل لذيذ.",
    ingredients: "8 أوقيات (226 جم) من جبن كريمي خالٍ من الدسم| 1 ثمرة خيار مقشرة ومنزوعة البذر ومفرومة| 1 حبة فلفل أحمر مفروم| 1 حبة طماطم روما مفرومة 1/4 ملعقة صغيرة من مسحوق الثوم| 2 ملعقة كبيرة من الثوم المعمر المجفف| 3 تورتيلا الطحين قليل الدسم (حجم تاكو ناعم)",
    method: "تُخلط جميع المكونات (باستثناء التورتيلا) وتترك في الثلاجة لمدة ساعتين. |وزع الخليط بالتساوي على 2-3 من طحين التورتيلا. |لفها بإحكام وقطّعها إلى لفائف (بسمك 1 بوصة) | تُقدّم على صينية.",
    difficulty: "سهلة",
    category: "dinner|family favorites|vegetarian",
    hasImage: true,
    img: "vegetable-cream-cheese-roll-ups",
    slug: "vegetable-cream-cheese-roll-ups",
    serves: 3,
    fat: 3,
    calories: 235,
    cholesterol: 20,
    carbohydrate: 30,
    saturated: 1,
    sodium: 813,
    protein: 22
  },
  {
    title_english: "Vegetarian Chili",
    title: "طاجن صلصة الفلفل النباتية",
    description: "هل تريد شيئًا دافئًا ولذيذًا لوجبة العشاء هذه الليلة؟ جرب وصفة الفلفل الحار النباتية مع فتات الصويا. ولن تفتقد مذاق اللحم المفروم.",
    ingredients: "1 ملعقة كبيرة من زيت الكانولا | 1 بصلة كبيرة مفرومة | 1-2 فص ثوم مفروم | 1/2 حبة فلفل أحمر مفرومة | 1/2حبة فلفل أخضر مفرومة | 1 فلفل هلابينو مقطع مكعبات | عبوة 2، 28 أوقية (793 جم) من طماطم الكاملة المقشرة | 3 ملاعق كبيرة من مسحوق الفلفل الحار | 1/2 ملعقة صغيرة كمون | 1/2 ملعقة صغيرة فلفل أسود | 1/2 ملعقة صغيرة من المردقوش | 1/2 ملعقة صغيرة من الصلصة الحارة المفضلة (اختياري) | 1/2 ملعقة صغيرة فلفل حريف (اختياري) | 2، 15.5 أوقية (439 جم) من الفاصوليا مصفاة منخفضة الصوديوم",
    method: "يُقلى البصل والثوم والفلفل في زيت الكانولا حتى يصبح طريًا. | تُهرس الطماطم باليد في قدر كبير ويُضاف مزيج البصل والفلفل. |أضف مسحوق الفلفل الحار والكمون والفلفل الأسود والمردقوش والصلصة الحارة الاختيارية والفلفل الحار حسب الرغبة. |اترك الطبق على نار هادئة لمدة 45 دقيقة. |أضف البازلاء واتركها على نار هادئة لمدة 15 دقيقة إضافية.| زينه بالكريمة الحامضة الخالية من الدهون/ اللبن الزبادي اليوناني الخالي من الدسم، حسب الرغبة.",
    difficulty: "سهلة",
    category: "dinner|family favorites|vegetarian",
    hasImage: true,
    img: "vegetarian-chili",
    slug: "vegetarian-chili",
    serves: 8,
    time: 75,
    fat: 4.3,
    calories: 231,
    cholesterol: 0,
    carbohydrate: 35,
    saturated: 0,
    sodium: 618,
    protein: 16
  },
  {
    title_english: "Veggie Taco Salad",
    title: "سلطة تاكو النباتية",
    description: "سلطة تاكو مُحضرة من لحم البقر المفروم بالخضراوات",
    ingredients: "4 أكواب (300 جم) خضراوات مُشكلة | 8-10 طماطم كرزية مقطعة إلى أنصاف| 1/4 حبة بصل أحمر مفرومة | 1/2 حبة فلفل أخضر مفرومة | 1 حبة فلفل أصفر أو أحمر مقطعة | 1/2 كوب (75 جم) ذرة مجمدة مذابة | 1، 16 أوقية (453 جم) من البازلاء السوداء قليلة الملح مغسولة ومصفاة | 4 ملاعق كبيرة من شرائح زيتون أسود (أو حوالي 4 حبات زيتون أسود كبير مقطع شرائح) | 1 كوب (1/2 عبوة سعة 12 أوقية) بديل \"لحم\" خضار | 1/4 كوب (55 جم) صلصة | 1 حصة من رقائق الذرة المخبوزة قليلة الدسم (1 أوقية، أو حوالي 18 من رقائق البطاطس)",
    method: "قم بقلي الخضراوات المطحونة بشكل دائري لمدة من 5-10 دقائق لتسخينها تمامًا. | ضع المكونات الأخرى باستثناء الصلصة والرقائق في وعاء تقديم كبير. | ضع فوقها الخليط المطحون الدافئ بشكل دائري والصلصة ورقائق الذرة المطحونة.",
    difficulty: "سهلة",
    category: "lunch|snack|vegetarian|quick and easy",
    hasImage: true,
    img: "veggie-taco-salad",
    slug: "veggie-taco-salad",
    serves: 2,
    time: 15,
    fat: 3.5,
    calories: 408,
    cholesterol: 0,
    carbohydrate: 71,
    saturated: 0,
    sodium: 648,
    protein: 30
  },
  {
    title_english: "Waldorf Salad",
    title: "سلطة والدورف",
    description: "طبق إضافي سهل التحضير في دقائق!",
    ingredients: "2 تفاحة كبيرة (أحمر أو أخضر) (مكعبات) | 1 كوب (100 جم) عنب (نصفين)| 2 كوب (450 جم) كرفس مفروم| 1/2 كوب (125 جم) زبادي خالٍ من الدسم| 1 ملعقة كبيرة عصير ليمون| 2 ملعقة كبيرة عصير تفاح خل| 1 ملعقة صغيرة طرخون مجفف",
    method: "قم بتقطيع التفاح. | امزج التفاح والعنب والكرفس في وعاء كبير| أضف بقية المكونات إلى الوعاء واخلطها. | قدمها على الفور أو غطها وبردها وقدمها لاحقًا.",
    difficulty: "سهلة",
    category: "lunch|vegetarian|quick and easy",
    hasImage: true,
    img: "waldorf-salad",
    slug: "waldorf-salad",
    serves: 7,
    time: 15,
    fat: 0.2,
    calories: 59,
    cholesterol: 0.8,
    carbohydrate: 12,
    saturated: 0.05,
    sodium: 25,
    protein: 2,
    fiber: 2
  },
  {
    title_english: "Spicy Burgers",
    title: "برجر سبايسي",
    description: "هذا البرجر برائحة الفلفل الأحمر اللذيذ الذي يسعد الكثيرين وجبة خفيفة ولكنه لذيذ وطبيعي.",
    ingredients: "450 جم (1 رطل) دجاج مفروم/ مهروس | 1 بصلة مبشورة | 2 فص ثوم مهروس | 1 ملعقة صغيرة فلفل أحمر",
    method: "سخّن الشواية على درجة متوسطة. |امزج جميع المكونات معًا. |شكّل الخليط في 8 قطع برجر. |قم بشوي البرجر على نار متوسطة لمدة من 4-5 دقائق لكل جانب أو حتى ينضج اللحم تمامًا. |يقدم البرجر مع السلطة أو في لفائف القمح الكامل.",
    difficulty: "سهلة",
    category: "dinner|family favorites|quick and easy",
    hasImage: true,
    img: "spicy-burgers",
    slug: "spicy-burgers",
    serves: 4,
    time: 15,
    fat: 1.4,
    calories: 110,
    saturated: 0.4,
    sodium: 0.17
  },
  {
    title_english: "Herb and Garlic Baked Chicken",
    title: "صينية دجاج بالفرن بالأعشاب والثوم",
    description: "يعني مزيج الأعشاب والثوم أنك لست بحاجة إلى إضافة الملح للحصول على دجاج مطهو جيدًا ولذيذ.",
    ingredients: "4 صدور دجاج منزوعة الجلد منزوعة الدهن بالكامل| حفنة من الأعشاب المفرومة مثل الطرخون والمريمية والبقدونس| 3 فصوص ثوم مهروسة| رذاذ زيت الطهي وماء| 600-650 جم (4 - 5 أكواب) من الخضراوات المقلية (اختر من البصل، والفلفل، والفطر، والملفوف المبشور، وعيدان الخضار المسلوقة قليلًا، والفاصوليا المعلبة)",
    method: "اخلط الثوم والأعشاب معًا. |اصنع 3-4 شقوق سطحية في صدور الدجاج. احش خليط الثوم والأعشاب. | رش صينية الفرن برذاذ زيت الطهي والماء. أضف الدجاج ورشه مرة أخرى. | غطه برقائق معدنية لمنع الاحتراق أو الجفاف في الفرن. |اطهه لمدة 30 دقيقة على حرارة 200 درجة مئوية/ 400 فهرنهايت/ غاز 6 درجات أو حتى تنفد العصارات الصافية عند دس سيخ في الدجاج. | قم بتغطية المقلاة بخفة برذاذ الزيت والماء. سخّن المقلاة وأضف الخضراوات وضعها على النار لبضع دقائق حتى تنضج | تُقدّم مع الدجاج.",
    difficulty: "سهلة",
    category: "dinner|lunch|family favorites",
    hasImage: true,
    img: "herb-and-garlic-baked-chicken",
    slug: "herb-and-garlic-baked-chicken",
    serves: 4,
    time: 45,
    fat: 2.7,
    calories: 186,
    saturated: 0.6,
    sodium: 1
  },
  {
    title_english: "Spicy Pasta",
    title: "معكرونة حارة",
    description: "طبق معكرونة قليل الدسم وآمن مع نكهات غنية وجريئة يمكنك طهيه في أقل من نصف ساعة.",
    ingredients: "450 جرام (3 ونصف كوب) معكرونة بيني قمح كامل أو أي شكل آخر من المعكرونة | 1 ملعقة كبيرة زيت زيتون | 1 ملعقة صغيرة من بذور الكمون | 1 ملعقة صغيرة من بذور الخردل |1 بصلة كبيرة مقطعة |1 ملعقة صغيرة ثوم مفروم | 2 حبة فلفل أخضر مفروم بشكل ناعم | 225 جرام (2 كوب) فطر دائري | 400 مل (عبوة سعة 14 أوقية) من الطماطم المصفاة | 1 ملعقة صغيرة من توابل كرم مصالحه | 1 ملعقة صغيرة كزبرة مفرومة/ كزبرة",
    method: "أطهو المعكرونة كما هو موضح على العبوة، ويفضل تركها غير مطبوخة قليلًا. صفها جيدًا. |سخّن مقلاة كبيرة غير لاصقة. أضف الزيت متبوعًا ببذور الكمون وبذور الخردل والبصل. يُطهى البصل حتى يصبح لونه بنيًا فاتحًا. أضف الثوم والفلفل الحار والفطر واستمر في الطهي لمدة 2 دقيقة أخرى. |أضف الطماطم ودعها تغلِ. |أضف توابل كرم مصالحه وخفف النار واتركها على نار هادئة لمدة 5 دقائق. | قلّب المعكرونة. قم بتزيين الطبق بالكزبرة المطحونة/ الكزبرة ويُقدم ساخنًا.",
    difficulty: "سهلة",
    category: "dinner|family favorites|quick and easy|vegetarian",
    hasImage: true,
    img: "spicy-pasta",
    slug: "spicy-pasta",
    serves: 6,
    time: 28,
    fat: 4.7,
    calories: 339,
    saturated: 0.7
  },
  {
    title_english: "Cottage Pie",
    title: "فطيرة الراعي",
    description: "مفضل بشكل تقليدي لدى العائلة، لحم بقري قليل الدسم مفروم مغطى بطبقة من الهريس الرقيق.",
    ingredients: "450 جم (1 رطل) لحم بقري مفروم قليل الدهن | 1 ملعقة طعام زيت نباتي | 1 بصلة كبيرة مفرومة | 1 فص ثوم مهروس أو مفروم | 1 ملعقة كبيرة صلصة وسترشير (اختياري) | 1 جزرة كبيرة مقطعة إلى مكعبات | 1-2 ملعقة كبيرة من هريس الطماطم | 50 جرام (1/4 كوب) من البازلاء المجمدة | 1 مكعب مرق لحم قليل الملح | عبوة واحدة 400 جرام (14 أوقية) من الطماطم المقطعة | 500 جرام (17 أوقية) بطاطس مقشرة | 2 - 3 ملاعق كبيرة من الحليب منزوع الدسم | 1 ملعقة كبيرة زيت نباتي (مثل الزيتون أو عباد الشمس) | فلفل للتتبيل",
    method: "يُسخن الفرن حتى 200 درجة مئوية/ 400 فهرنهايت أو علامة الغاز عند 6 درجات. |للحشو: |يُسخن الزيت في قدر كبير أو مقلاة كبيرة. يُضاف البصل المفروم والثوم ويُطهى لمدة 5 دقائق دون الوصول لدرجة الاحمرار. |يُضاف اللحم المفروم ويستمر الطهي حتى يصير لونه بنيًا. |يُضاف مكعب المرقة والطماطم المعلبة وعصير الطماطم وصلصة وسترشير وقطع الجزر. ويترك على نار هادئة لمدة 10-15 دقيقة. يجب أن يصبح قوام الصلصة كثيفًا. |تُضاف البازلاء المجمدة وتستمر في الغليان لمدة 5 دقائق، وتُتبل بالفلفل. |للتزيين: |تُقشر البطاطس وتُقطع إلى قطع بحجم البيضة. دع المكونات لتغلي لمدة 20 دقيقة أو حتى تنضج. |تُصفى البطاطس ويُضاف إليها زيت نباتي والحليب وتُهرس حتى تصبح ناعمة بقوام كريمي.|طريقة صنع الفطيرة: |يُوضع حشو اللحم في طاجن أو طبق خبز، وتُصب فوقها البطاطا المهروسة |يُطهى لمدة 45 دقيقة (30 دقيقة من الحرارة)، حتى يصبح لون أعلاه بنيًا ذهبيًا |يُقدم بمفرده أو مع خضار الموسم |نصيحة لعمل الوصفة: حاول إضافة الفاصوليا المعلبة إلى خليط اللحم بدلًا من البازلاء، وإضافة فطر عيش الغراب المفروم أو للحصول على صلصة دسمة، تُهرس الطماطم المفرومة قبل إضافتها إلى المقلاة.",
    difficulty: "متوسطة",
    category: "dinner|family favorites|hearty meal",
    hasImage: true,
    img: "cottage-pie",
    slug: "cottage-pie",
    serves: 4,
    time: 50,
    fat: 12,
    calories: 322,
    saturated: 3.1,
    sodium: 1.3
  },
  {
    title_english: "Mediterranean Vegetable Lasagne",
    title: "لازانيا البحر المتوسط بالخضراوات",
    description: "طبق المعكرونة الطبقات هذا هو بديل صحي للقلب عن الوصفة التقليدية مع خضار البحر المتوسط المحمص اللذيذ ليحل محل صلصة اللحم الإيطالية راجو وممزوج مع صلصة أخف مع احتفاظها بقوامها الكريمي - لتستمتع بوجبة شهية!",
    ingredients: "2 ثمرة باذنجان مقطعة إلى قطع |2 بصلة حمراء مقطعة إلى شرائح |2 ثمرة فلفل أحمر مقطعة إلى شرائح |4 فصوص ثوم مفرومة ناعمة |3 ملاعق كبيرة زيت زيتون |450 جم (4 أكواب) كوسة مقطعة إلى شرائح |225 جم (8 أوقية) شرائح لازانيا |30 جم (2 ملعقة كبيرة) جبن بارميزان |900 مل (30 أوقية سائلة) حليب خالي الدسم |60 جم (2 أوقية) زيت زيتون |70 جم (2.5 أوقية) دقيق عادي |125 جم (1/3 كوب) جبن جاف قليل الدسم (استخدمنا جبن فلمنك)",
    method: "يُسخن الفرن إلى 220 درجة مئوية/ مروحة 200 درجة مئوية/ غاز 7 درجة مئوية/ 428 فهرنهايت. يُخلط الباذنجان والبصل والفلفل والثوم ونصف كمية الزيت في وعاء. يُنقل الخليط إلى صينية تحمير كبيرة وتُطهى لمدة 30 دقيقة أو حتى تصبح طرية. |في الوقت نفسه يُسخن باقي الزيت في المقلاة. تُقلى الكوسة لمدة 4 دقائق حتى تحمر. |يتم إخراج الخضار المحمص من الفرن وتُقلب الكوسة. تُخفض حرارة الفرن إلى 200 درجة مئوية/ 180 درجة مئوية للمروحة/ الغاز 6 درجة/ 390 فهرنهايت |لعمل الصلصة، يُترك الحليب ليغلي في المقلاة ويُنحى جانبًا. يُذاب معجون الزيتون في مقلاة ويُضاف إليه الدقيق ويُطهى لمدة 1 دقيقة ثم يُرفع عن النار. يُضاف الحليب تدريجيًا ثم يُترك ليغلي مع التقليب على نار خفيفة لمدة 10 دقائق مع مواصلة التحريك من حين لآخر. |تُطهى اللازانيا حسب التعليمات الموجودة على العبوة |يُضاف الجبن إلى الصلصة وتُتبل بالفلفل. تُوضع طبقة خفيفة فوق قاعدة طبق فرن مقاوم للحرارة مدهون بقليل من الزيت، وتُغطى بـ 4 شرائح من اللازانيا، متشابكة معها قليلًا. تُوضع نصف كمية الخضار، ثم ثلث الكمية المتبقية من الصلصة و4 شرائح أخرى من اللازانيا. تُكرر هذه العملية مرة أخرى ثم تُوزع فوق الصلصة المتبقية وتُرش بجبن البارميزان. |تُوضع في الفرن لمدة 40 دقيقة، حتى يصبح لونها ذهبيًا.",
    difficulty: "متوسطة",
    category: "dinner|family favorites|vegetarian",
    hasImage: true,
    img: "mediterranean-vegetable-lasagne",
    slug: "mediterranean-vegetable-lasagne",
    serves: 8,
    time: 105,
    fat: 13,
    calories: 282,
    saturated: 3.6,
    sodium: 0.29
  },
  {
    title_english: "Apple and Blackberry Oat Crumble",
    title: "كسرات (كرامبل) التفاح بالشوفان والتوت الأسود.",
    description: "وجبة تمنحك الدفء في الشتاء عند تقديمها في وجباتك الخمس اليومية.",
    ingredients: "7 تفاحات برايبورن مقطعة |4 ملاعق صغيرة من السكر أو التحلية المفضلة |1 ملعقة صغيرة قرفة |100 جم (3/4 كوب) توت أسود |50 مل (1.5 أوقية سائلة) من الماء |60 جم (2 أوقية) شوفان/ شوفان عصيدة |120 جم (4 أوقية) دقيق القمح الكامل الصافي/ دقيق الحبوب الكاملة |40 جم (1/3 كوب) سكر بني خام (سكر موسكوفادو) |1 ملعقة صغيرة قرفة |75 جم (2.5 أوقية) دهان قليل الدسم",
    method: "يُسخن الفرن على حرارة 200/ 180 درجة مئوية/ 392 فهرنهايت. |يُقشر التفاح ويُقطع إلى قطع بسُمك 2 سم. تُرش 4 ملاعق صغيرة من التحلية و11 ملعقة صغيرة من القرفة، ثم تُغطى وتُترك في 50 مل من الماء على نار متوسطة حتى ينضج التفاح. يُختبر النضج ويُقلّب الخليط كل بضع دقائق. ما أن يصبح الخليط هشًا بدرجة كافية لسحقه بسهولة بالملعقة، تُطفئ النار ويُترك ليبرد. |أثناء طهي التفاح، يتم تحضير الكسرات. يُخلط الشوفان والدقيق الصافي معًا في وعاء كبير. تُضاف التحلية والقرفة والسكر البني (موسكوفادو) ويخلط جيدا بالملعقة. باستخدام أطراف أصابعك، أضف المعجون وافركه في خليط الدقيق والشوفان لتشكيل قوام رطب ومفتت ليشبه فتات الخبز. |يُصب التفاح المطهو في طبق فرن مقاوم للحرارة، ويُقلب فيه التوت وتُرش فوقه طبقة الكرامبل، ثم يُخبز لمدة 25 دقيقة حتى يصير لونه ذهبيًا ويشبه البسكويت من الأعلى. يمكنك، إذا كنت تفضل، رش القليل من السكر البودرة على الطبق وكذلك رش ملعقة كبيرة من الكاسترد قليل الدسم للتقديم.",
    difficulty: "سهلة",
    category: "dessert|snack|family favorites|vegetarian",
    hasImage: true,
    img: "apple-and-blackberry-oat-crumble",
    slug: "apple-and-blackberry-oat-crumble",
    serves: 8,
    time: 45,
    fat: 5.1,
    calories: 230,
    saturated: 1.1,
    sodium: 0.12
  },
  {
    title_english: "Fudgy Buttermilk Brownies",
    title: "فادجي براونيز بالزبدة",
    description: "كلنا نحب الاستمتاع بطعم الشوكولاتة ولكن على عكس معظم وصفات الشوكولاتة، فهذه الوصفة مصنوعة من اللبن قليل الدسم. فسواء قررت المغامرة أم لا، فمن المؤكد أنك ستستمتع بالانغماس في تلك الوصفة.",
    ingredients: "1 ملعقة صغيرة زيت نباتي |100 جم (3/4 كوب) دقيق أبيض |50 جم (1/3 كوب) دقيق أسمر/ دقيق الحبوب الكاملة |175 جم (3/4 كوب) سكر بني ناعم |50 جم (1/3 كوب) مسحوق كاكاو (لكعك البراونيز) |1/2 ملعقة صغيرة من صودا الخبز |1 بيضة كبيرة |1 تفاحة متوسطة الطهي، مقطعة إلى شرائح ومطبوخة على نار هادئة في قليل من الماء ومهروسة |120 مل (4 أوقية سائلة) من اللبن قليل الدسم |2 ملعقة صغيرة من خلاصة الفانيليا |150 جم (1 كوب) سكر بودرة منخول |50 جم (1/3 كوب) مسحوق كاكاو (للتزيين) |1 - 3 ملاعق كبيرة من الحليب الخالي من الدسم",
    method: "يُسخن الفرن إلى 180 درجة مئوية (360 درجة فهرنهايت) |تُدهن صينية خبز سعة 9 بوصة مربعة بالزيت النباتي قليلًا. |يُقلب الدقيق والسكر ومسحوق الكاكاو ومسحوق الخبز معًا. |يُخفق البيض وحده في وعاء آخر. يُضاف التفاح واللبن وخلاصة الفانيليا. |تُضاف هذه المكونات إلى خليط الدقيق وتُخلط حتى تمتزج جيدًا. |يُصب الخليط في صينية الخبز. |يُخبز لمدة 30 دقيقة. |في حالة تحضير كريمة التزيين، يُقلّب السكر البودرة ومسحوق الكاكاو معًا |يُضاف الحليب تدريجيًا حتى يصل إلى القوام المنبسط. يوزّع الخليط فوق البراونيز المبرد. يُقطع إلى 16 مربعًا ويُنزع بعناية من الصينية.",
    difficulty: "سهلة",
    category: "dessert|family favorites",
    hasImage: true,
    img: "fudgy-buttermilk-brownies",
    slug: "fudgy-buttermilk-brownies",
    serves: 16,
    time: 45,
    fat: 2.3,
    calories: 155,
    saturated: 1,
    sodium: 0.22
  },
  {
    title_english: "Pure Fruit Cake",
    title: "كعكة الفاكهة المهروسة",
    description: "يعمل التمر المصفى كبديل للدهون في هذه الوصفة وتُمزج كل الفواكه لإنتاج كعكة غنية بما يكفي لصنع كعكة عيد الميلاد. كل ما تحتاجه هو سانتا كلوز!",
    ingredients: "رذاذ الطهي لدهن الصينية |250 جم (2 كوب) تمر ناشف/ مكسَّر |300 مل (10 أوقيات سائلة) ماء |175 جم (1 1/2 كوب) زبيب بدون بذور/ زبيب أسود |125 جم (1 كوب) سلطانية زبيب/ زبيب ذهبي |125 جم (1 كوب) كشمش |50 جم (1/3 كوب) حلوى/ قشر فواكه مختلطة مسكرة ومفرومة |175 جم (1 1/2 كوب) دقيق أسمر كامل/ دقيق كامل الحبوب |3 ملاعق صغيرة من مسحوق الخبز |1 ملعقة صغيرة بهارات مختلطة/ فطيرة قرع متبلة |قشر مبشور وعصير 1 ثمرة برتقال أو ليمون |25 جم (0.8 أوقية) لوز مطحون |يمكن تزيينه بقليل من الجوز والكرز (اختياري)",
    method: "يُدهن قالب رغيف بسعة 1 كجم (35 أوقية). يُوضع التمر في قدر مع الماء المعاير ويُسخن على نار هادئة حتى ينضج. يُرفع عن النار ويُهرس بالشوكة حتى ينضج. |يُوضع التمر المهروس في وعاء مع جميع المكونات المتبقية، ما عدا اللوز المقشر، و4 ملاعق كبيرة من الماء. تُخلط المكونات جيدًا. يُسكب الخليط بالملعقة في القالب المجهّز ويساوى الجزء العلوي. يُرش اللوز المقشر. |يُخبز في فرن محمى حتى 160 درجة مئوية (325 فهرنهايت)، درجة الغاز 3، لمدة ساعة ونصف حتى يتم إدخال سيخ في الوسط ويخرج نظيفًا. قرب انتهاء عملية الطهي، قد تحتاج إلى تغطية الجزء العلوي من الكعكة بورق الألومنيوم. |تُترك الكعكة قليلًا لتبرد في القالب، ثم تُقلب وتُترك لتبرد تمامًا على رف شبكي.",
    difficulty: "سهلة",
    category: "dessert|family favorites",
    hasImage: true,
    img: "pure-fruit-cake",
    slug: "pure-fruit-cake",
    serves: 12,
    time: 105,
    fat: 1.9,
    calories: 250,
    saturated: 0.2,
    sodium: 0.37
  }
]